<template>
  <v-container grid-list-md fluid class="pa-0">
    <v-layout row wrap>
      <v-flex xs12>
        <v-tabs v-model="tab"
        background-color="primary" dark
        grow height="40"
        >
          <v-tab v-for="(tabitem, n) in tabitems" :key="n" :href="`#tab-${n}`" @change="refreshTab(tabitem)">
            {{ tabitem }}
          </v-tab>
        </v-tabs>

        <!-- 1. Tab Items -->
        <v-tabs-items v-if="lAction === 'view'" v-model="tab">
          <v-tab-item v-for="(tabitem, n) in tabitems" :key="n" :value="`tab-${n}`">
            <!-- Uniform Inward -->
            <v-layout v-if="tab === 'tab-0'" class="pa-0" row wrap>
              <v-flex xs12 mx-auto>
                <v-flex xs12>
                  <v-card flat>
                    <v-card-title class="px-0 py-0">
                      <v-text-field
                      class="pt-0"
                      append-icon="mdi-account-search"
                      :placeholder="$vuetify.breakpoint.smAndUp?'Search by Vendor Name, Invoice No, Qty etc.':'Search'"
                      hide-details
                      v-model="searchInward"
                      outlined
                      clearable
                      ></v-text-field>
                    </v-card-title>
                    <v-card-text class="px-0 pt-2">
                      <v-data-table
                      :headers="uniformInwardHeader"
                      :items="uniformInward"
                      hide-default-header
                      hide-default-footer
                      class="elevation-3"
                      :mobile-breakpoint="0"
                      disable-pagination
                      fixed-header
                      dense
                      :search="searchInward"
                      height="500px"
                      >
                        <template v-slot:header="{ props: { headers } }">
                          <thead>
                            <tr>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 50px; text-align: center ">{{headers[0].text}}</th>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: center ">{{headers[1].text}}</th>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: center ">{{headers[2].text}}</th>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 250px; text-align: left ">{{headers[3].text}}</th>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: center ">{{headers[4].text}}</th>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 140px; text-align: right ">{{headers[5].text}}</th>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 140px; text-align: right ">{{headers[6].text}}</th>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 140px; text-align: right ">{{headers[7].text}}</th>
                            </tr>
                          </thead>
                        </template>
                        <template slot="item" slot-scope="props">
                          <tr @click="prepareUpdateUniformInwardBase(props.item)">
                            <td style="text-align:center; font-size: 12px"> {{ props.index + 1 }} </td>
                            <td style="text-align:center; font-size: 12px"> {{ props.item.invoice_no ? props.item.invoice_no : '-' }} </td>
                            <td style="text-align:center; font-size: 12px"> {{ props.item.invoice_date ? handy.formatDate(props.item.invoice_date) : '-' }} </td>
                            <td style="text-align:left; font-size: 12px"> {{ props.item.vendorsupplier_name ? props.item.vendorsupplier_name : '-' }} </td>
                            <td style="text-align:center; font-size: 12px"> {{ props.item.qty ? props.item.qty : '-' }} </td>
                            <td style="text-align:right; font-size: 12px"> {{ props.item.amount_bf_tax ? handy.formatCur(props.item.amount_bf_tax) : '-' }} </td>
                            <td style="text-align:right; font-size: 12px"> {{ props.item.tax_amount ? handy.formatCur(props.item.tax_amount) : '-' }} </td>
                            <td style="text-align:right; font-size: 12px"> {{ props.item.amount_af_tax ? handy.formatCur(props.item.amount_af_tax) : '-' }} </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-flex>
            </v-layout>
            <!-- Uniform Outward -->
            <v-layout v-if="tab === 'tab-1'" class="pa-0" row wrap>
              <v-flex xs12 mx-auto>
                <v-flex xs12>
                  <v-card flat>
                    <v-card-title class="px-0 py-0">
                      <v-text-field
                      class="pt-0"
                      append-icon="mdi-account-search"
                      :placeholder="$vuetify.breakpoint.smAndUp?'Search by Project Name, Account Manager, Qty etc.':'Search'"
                      hide-details
                      v-model="searchOutward"
                      outlined
                      clearable
                      ></v-text-field>
                    </v-card-title>
                    <v-card-text class="px-0 pt-2">
                      <v-data-table
                      :headers="uniformOutwardHeader"
                      :items="uniformOutward"
                      hide-default-header
                      hide-default-footer
                      class="elevation-3"
                      :mobile-breakpoint="0"
                      disable-pagination
                      fixed-header
                      dense
                      :search="searchOutward"
                      height="500px"
                      >
                        <template v-slot:header="{ props: { headers } }">
                          <thead>
                            <tr>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 50px; text-align: center">{{headers[0].text}}</th>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 280px; text-align: left">{{headers[1].text}}</th>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 150px; text-align: left">{{headers[2].text}}</th>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: center">{{headers[3].text}}</th>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 110px; text-align: right">{{headers[4].text}}</th>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 110px; text-align: right">{{headers[5].text}}</th>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 110px; text-align: right">{{headers[6].text}}</th>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 90px; text-align: center">{{headers[7].text}}</th>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[8].text}}</th>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 90px; text-align: center">{{headers[9].text}}</th>
                            </tr>
                          </thead>
                        </template>
                        <template slot="item" slot-scope="props">
                          <tr @click="prepareUpdateUniformOutwardBase(props.item)">
                            <td style="text-align:center; font-size: 12px"> {{ props.index + 1 }} </td>
                            <td style="text-align:left; font-size: 12px"> {{ props.item.proj_name ? props.item.proj_name : '-' }} </td>
                            <td style="text-align:left; font-size: 12px"> {{ props.item.proj_manager ? props.item.proj_manager : '-' }} </td>
                            <td style="text-align:center; font-size: 12px"> {{ props.item.qty ? props.item.qty : '-' }} </td>
                            <td style="text-align:right; font-size: 12px"> {{ props.item.tot_amt ? handy.formatCur(props.item.tot_amt) : '-' }} </td>
                            <td style="text-align:right; font-size: 12px"> {{ props.item.tax_amt ? handy.formatCur(props.item.tax_amt) : '-' }} </td>
                            <td style="text-align:right; font-size: 12px"> {{ props.item.amt_with_tax ? handy.formatCur(props.item.amt_with_tax) : '-' }} </td>
                            <td style="text-align:center; font-size: 12px"> {{ props.item.bulk_outward ? props.item.bulk_outward : '-' }} </td>
                            <td style="text-align:center; font-size: 12px"> {{ props.item.emp_mapped ? props.item.emp_mapped : '-' }} </td>
                            <td style="text-align:center; font-size: 12px"> {{ props.item.bal_emp_mapped ? props.item.bal_emp_mapped : '-' }} </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-flex>
            </v-layout>
            <!-- Uniform Reports -->
            <v-layout v-if="tab === 'tab-2'" class="pt-4 px-4" row wrap>
              <v-flex xs12 mx-auto v-if="lAction === 'view'">
                <v-layout row wrap>
                  <v-flex xs12>
                    <span class="primary--text">Stock Reports</span>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-card @click.native="loadSubCatWiseStockReport()">
                      <v-card-title class="title pa-2 grey lighten-4 grey--text">
                        Sub Category Wise Stock Report
                      </v-card-title>
                      <v-card-text>
                        View Uniform Sub-Category wise stock report.
                        <div style="float:right">
                          <v-icon>mdi-chevron-right</v-icon>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-card @click.native="loadStockSequenceStockReport()">
                      <v-card-title class="title pa-2 grey lighten-4 grey--text">
                        Stock Sequence Report
                      </v-card-title>
                      <v-card-text>
                        View stock report with combination of Sub-Category, Size, Price and Tax Percent.
                        <div style="float:right">
                          <v-icon>mdi-chevron-right</v-icon>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-card @click.native="loadStockValueReport()">
                      <v-card-title class="title pa-2 grey lighten-4 grey--text">
                        Stock Value Report
                      </v-card-title>
                      <v-card-text>
                        View current stock value on Uniform Sub-Category wise.
                        <div style="float:right">
                          <v-icon>mdi-chevron-right</v-icon>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-card @click.native="loadSubCatWiseSequenceStock_temp()">
                      <v-card-title class="title pa-2 grey lighten-4 grey--text">
                        Sub Cat Wise Stock Sequence Table Report
                      </v-card-title>
                      <v-card-text>
                        Temp - Load Stock Sequence Table data.
                        <div style="float:right">
                          <v-icon>mdi-chevron-right</v-icon>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12>
                    <div class="primary--text mt-2">Distribution Reports</div>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-card @click.native="loadUniformAllProjectsDistributionReports()">
                      <v-card-title class="title pa-2 grey lighten-4 grey--text">
                        Project Wise Distribution Summary Report
                      </v-card-title>
                      <v-card-text>
                        View project wise uniform distribution transactions.
                        <div style="float:right">
                          <v-icon>mdi-chevron-right</v-icon>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-card @click.native="loadEmpWiseDistributionReportBase()">
                      <v-card-title class="title pa-2 grey lighten-4 grey--text">
                        Employee Wise Distribution Report
                      </v-card-title>
                      <v-card-text>
                        View employee wise uniform distribution transactions.
                        <div style="float:right">
                          <v-icon>mdi-chevron-right</v-icon>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-card @click.native="loadUniformBulkDistribMappingComparisonReportBase()">
                      <v-card-title class="title pa-2 grey lighten-4 grey--text">
                        Bulk Distribution & Emp Mapping Comparison Report
                      </v-card-title>
                      <v-card-text>
                        View bulk distirbution & employee mapping comparison report.
                        <div style="float:right">
                          <v-icon>mdi-chevron-right</v-icon>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-card @click.native="loadUniformMonthlyDistributionSummaryReportBase()">
                      <v-card-title class="title pa-2 grey lighten-4 grey--text">
                        Monthly Distribution Summary Report
                      </v-card-title>
                      <v-card-text>
                        View monthly distributed summary report and also for given period.
                        <div style="float:right">
                          <v-icon>mdi-chevron-right</v-icon>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12>
                    <div class="primary--text mt-2">Purchase</div>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-card @click.native="loadPurchaseHistorySummaryBase()">
                      <v-card-title class="title pa-2 grey lighten-4 grey--text">
                        Purchase History Summary
                      </v-card-title>
                      <v-card-text>
                        View supplier, category and sub-category wise purchase history.
                        <div style="float:right">
                          <v-icon>mdi-chevron-right</v-icon>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12>
                    <div class="primary--text mt-2">Audit Log Statements</div>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-card @click.native="loadInwardAuditLog()">
                      <v-card-title class="title pa-2 grey lighten-4 grey--text">
                        Inward Audit Log
                      </v-card-title>
                      <v-card-text>
                        The summary of for each change of inward transactions.
                        <div style="float:right">
                          <v-icon>mdi-chevron-right</v-icon>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-card @click.native="loadOutwardAuditLog()">
                      <v-card-title class="title pa-2 grey lighten-4 grey--text">
                        Distribution Audit Log
                      </v-card-title>
                      <v-card-text>
                        The summary of for each change of distribution transactions.
                        <div style="float:right">
                          <v-icon>mdi-chevron-right</v-icon>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-card @click.native="loadBulkOutwardAuditLog()">
                      <v-card-title class="title pa-2 grey lighten-4 grey--text">
                        Bulk Distribution Audit Log
                      </v-card-title>
                      <v-card-text>
                        The summary of for each change of Bulk Distribution transactions.
                        <div style="float:right">
                          <v-icon>mdi-chevron-right</v-icon>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-card @click.native="loadStockSequenceAuditLog()">
                      <v-card-title class="title pa-2 grey lighten-4 grey--text">
                        Stock Sequence Audit Log
                      </v-card-title>
                      <v-card-text>
                        The summary of stock sequence change of inward and distribution transactions.
                        <div style="float:right">
                          <v-icon>mdi-chevron-right</v-icon>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-tab-item>
          <v-tooltip top v-if="lAction === 'view' && (tab === 'tab-0' || tab === 'tab-1')">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on"
              :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; right:15px;':'bottom:15px; right:15px;')"
              dark fab fixed
              v-if="config.IS_EDITED_BY_USER"
              color="accent white--text"
              @click.native="tab === 'tab-0' ? prepareCreateUniformInwardBase() : prepareCreateUniformOutwardBase()">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span v-if="tab === 'tab-0'" class="caption">Add Uniform Inward</span>
            <span v-if="tab === 'tab-1'" class="caption">Add Uniform Outward</span>
          </v-tooltip>
        </v-tabs-items>

        <!-- 2. Insert, Update and Delete Uniform Inward -->
        <v-container v-if="tab === 'tab-0' && (lAction === 'create' || lAction === 'update')" class="pa-2" grid-list-md>
          <v-layout row wrap>
            <v-flex xs12 mx-auto>
              <v-form ref="lFormUniformInwardBase" @submit.prevent="saveUniformInwardBase(lAction)">
                <v-card>
                  <v-card-title class="pa-1">
                    <div class="title mb-2">
                      <v-btn small icon @click="lAction = 'view'"><v-icon>mdi-arrow-left</v-icon></v-btn>
                      <span class="pl-2 primary--text">{{ handy.startWithUpper(lAction) + ' Uniform Inward' }}</span>
                    </div>
                  </v-card-title>
                  <v-card-text class="px-2 pb-2 pt-0">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs4>
                            <v-autocomplete
                            v-model="lUniformInwardBase.vendorsupplier_id"
                            :items="vendorSupplier"
                            label="Vendor Supplier Name"
                            item-text="vendorsupplier_name"
                            item-value="vendorsupplier_id"
                            hide-details
                            :rules="[rules.required]"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs4>
                            <v-text-field
                            v-model="lUniformInwardBase.invoice_no"
                            label="Invoice Number"
                            :rules="[rules.required]"
                            hide-details
                            maxlength="25">
                            </v-text-field>
                          </v-flex>
                          <v-flex xs4>
                            <v-dialog ref="dlgDate_inward"
                            persistent v-model="dlgDate_inward"
                            max-width="290px"
                            :return-value.sync="lUniformInwardBase.invoice_date">
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                slot="activator" label="Date"
                                v-model="lUniformInwardBase.invoice_date" append-icon="mdi-calendar-today"
                                readonly clearable
                                :rules="[rules.required]"
                                v-on="on"
                                hide-details
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="lUniformInwardBase.invoice_date"
                              first-day-of-week="1">
                                <v-spacer></v-spacer>
                                <v-btn text @click="dlgDate_inward = false">Cancel</v-btn>
                                <v-btn text color="accent" @click="$refs.dlgDate_inward.save(lUniformInwardBase.invoice_date)">OK</v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-3">
                    <v-layout row wrap>
                      <v-spacer></v-spacer>
                      <v-btn @click.stop="cancelChanges()">Cancel</v-btn>
                      <v-btn v-if="lAction === 'update' && uniformInwardDetail.length === 0 && config.IS_EDITED_BY_USER" @click="deleteUniformInwardBase(lUniformInwardBase)">delete</v-btn>
                      <v-btn type="submit" color="accent black--text" v-if="config.IS_EDITED_BY_USER" :disabled="beingSaved">Save</v-btn>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
            <v-flex xs12 mx-auto v-if = "lUniformInwardBase.uniform_inward_base_id">
              <v-card flat>
                <v-card-title class="pa-1">
                  Inward Details
                  <v-spacer></v-spacer>
                  <v-btn icon v-if="config.IS_EDITED_BY_USER" @click="prepareCreateUniformInwardDetail(lUniformInwardBase)"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="pa-1">
                  <v-layout row wrap>
                    <v-card-text class="ma-0 pa-0">
                      <v-data-table
                      :headers="uniformInwardDetailHeader"
                      :items="uniformInwardDetail"
                      hide-default-header
                      hide-default-footer
                      fixed-header
                      class="elevation-3"
                      :mobile-breakpoint="0"
                      disable-pagination
                      dense
                      height="440px"
                      >
                        <template v-slot:header="{ props: { headers } }">
                          <thead>
                            <tr>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 50px; text-align: center">{{headers[0].text}}</th>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 200px; text-align: left">{{headers[1].text}}</th>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 140px; text-align: center">{{headers[2].text}}</th>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: center">{{headers[3].text}}</th>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: center">{{headers[4].text}}</th>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: right">{{headers[5].text}}</th>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 150px; text-align: right">{{headers[6].text}}</th>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: center">{{headers[7].text}}</th>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 120px; text-align: right">{{headers[8].text}}</th>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 140px; text-align: right">{{headers[9].text}}</th>
                              <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: center">{{headers[10].text}}</th>
                            </tr>
                          </thead>
                        </template>
                        <template slot="item" slot-scope="props">
                          <tr>
                            <td style="text-align:center; font-size: 12px"> {{ props.index + 1 }} </td>
                            <td style="text-align:left; font-size: 12px"> {{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : '-' }} </td>
                            <td style="text-align:center; font-size: 12px"> {{ props.item.uniform_size ? props.item.uniform_size : '-' }} </td>
                            <td style="text-align:center; font-size: 12px"> {{ props.item.qty ? props.item.qty : '-' }} </td>
                            <td style="text-align:center; font-size: 12px"> {{ props.item.unit ? props.item.unit : '-' }} </td>
                            <td style="text-align:right; font-size: 12px"> {{ props.item.unit_rate ? handy.formatCur(props.item.unit_rate) : '-' }} </td>
                            <td style="text-align:right; font-size: 12px"> {{ props.item.amount_bf_tax ? handy.formatCur(props.item.amount_bf_tax) : '-' }} </td>
                            <td style="text-align:center; font-size: 12px"> {{ props.item.tax_percent ? props.item.tax_percent + '%' : '-' }} </td>
                            <td style="text-align:right; font-size: 12px"> {{ props.item.tax_amount ? handy.formatCur(props.item.tax_amount) : '-' }} </td>
                            <td style="text-align:right; font-size: 12px"> {{ props.item.amount_af_tax ? handy.formatCur(props.item.amount_af_tax) : '-' }} </td>
                            <td style="text-align:center; font-size: 12px">
                              <v-menu
                              :close-on-content-click="false"
                              top right class="mt-0">
                                <template v-slot:activator="{ on }">
                                  <v-btn icon small v-on="on">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                  </v-btn>
                                </template>
                                <!-- list of menuitems -->
                                <v-list v-if="config.IS_EDITED_BY_USER" class="py-0">
                                  <!-- menu with submenus of status -->
                                  <v-list-item @click="prepareUpdateUniformInwardDetail(props.item)">
                                    <v-list-item-avatar><v-icon>mdi-pencil</v-icon></v-list-item-avatar>
                                    <v-list-item-title>Edit</v-list-item-title>
                                  </v-list-item>
                                  <v-list-item @click="prepareCloneUniformInwardDetail(props.item)">
                                    <v-list-item-avatar><v-icon>mdi-content-copy</v-icon></v-list-item-avatar>
                                    <v-list-item-title>Clone</v-list-item-title>
                                  </v-list-item>
                                  <v-list-item @click="deleteUniformInwardDetail(props.item)">
                                    <v-list-item-avatar><v-icon>mdi-delete</v-icon></v-list-item-avatar>
                                    <v-list-item-title>Delete</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu> </td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-layout>
                  </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12 mx-auto v-if = "lUniformInwardBase.uniform_inward_base_id">
              <v-card>
                <v-card-title class="pa-3">
                  <v-chip small class="mr-4 ml-12 font-weight-bold" color="uniformchipinfo white--text">Total Qty :  {{uniformInward.find(rec => rec.uniform_inward_base_id === lUniformInwardBase.uniform_inward_base_id) && uniformInward.find(rec => rec.uniform_inward_base_id === lUniformInwardBase.uniform_inward_base_id).qty}}  Units</v-chip>
                  <v-chip small class="mr-4 ml-5 font-weight-bold" color="uniformchipinfo white--text">Amount Before Tax :  {{uniformInward.find(rec => rec.uniform_inward_base_id === lUniformInwardBase.uniform_inward_base_id) && handy.formatCur(uniformInward.find(rec => rec.uniform_inward_base_id === lUniformInwardBase.uniform_inward_base_id).amount_bf_tax)}}</v-chip>
                  <v-chip small class="mr-4 ml-5 font-weight-bold" color="uniformchipinfo white--text">Tax Amount :  {{uniformInward.find(rec => rec.uniform_inward_base_id === lUniformInwardBase.uniform_inward_base_id) && handy.formatCur(uniformInward.find(rec => rec.uniform_inward_base_id === lUniformInwardBase.uniform_inward_base_id).tax_amount)}}</v-chip>
                  <v-chip small class="mr-4 ml-5 font-weight-bold" color="uniformchipinfo white--text">Amount After Tax :  {{uniformInward.find(rec => rec.uniform_inward_base_id === lUniformInwardBase.uniform_inward_base_id) && handy.formatCur(uniformInward.find(rec => rec.uniform_inward_base_id === lUniformInwardBase.uniform_inward_base_id).amount_af_tax)}}</v-chip>
                </v-card-title>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>

<v-dialog v-model="manageUniformInwardDetail" persistent max-width="600px">
  <v-form>
    <!-- Create, Edit and Delete Uniform Inward Detail -->
    <v-container v-if="lMAction === 'create' || lMAction === 'update'" class="pa-0" fluid grid-list-md>
      <v-form ref="lFormUniformInwardDetail" @submit.prevent="saveUniformInwardDetail(lMAction)">
        <v-card flat class="pa-0">
          <v-card-title class="title py-1 uniformtableheader white--text">
            {{ handy.startWithUpper(lMAction) }} Uniform Inward Detail
          </v-card-title>
          <v-card-text>
            <v-flex xs12>
              <v-autocomplete
              v-model="lUniformInwardDetail.uniform_sub_cat_id"
              :items="uniformSubCat"
              label="Uniform Sub Category"
              item-text="uniform_sub_cat"
              item-value="uniform_sub_cat_id"
              hide-details
              :disabled="lMAction === 'update'"
              @input="loadUniformSize(lUniformInwardDetail.uniform_sub_cat_id)"
              :rules="[rules.required]"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-autocomplete
                  v-model="lUniformInwardDetail.uniform_size_id"
                  :items="uniformSize"
                  label="Uniform Size"
                  item-text="uniform_size"
                  item-value="uniform_size_id"
                  hide-details
                  :disabled="lMAction === 'update'"
                  :rules="[rules.required]"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-select
                  v-model="lUniformInwardDetail.unit"
                  :items="['Nos', 'Set']"
                  label="Unit"
                  hide-details
                  :rules="[rules.required]"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs4>
                  <v-text-field
                  v-model="lUniformInwardDetail.qty"
                  label="Qty"
                  hide-details
                  type="Number"
                  @input="calculateAmount(lUniformInwardDetail)"
                  maxlength="5"
                  :rules="[rules.required]">
                </v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                v-model="lUniformInwardDetail.unit_rate"
                label="Unit Rate"
                type="Number"
                hide-details
                :disabled="lMAction === 'update'"
                @input="calculateAmount(lUniformInwardDetail)"
                maxlength="5"
                :rules="[rules.required]">
              </v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
              v-model="lUniformInwardDetail.amount_bf_tax"
              label="Amount"
              :rules="[rules.required]"
              hide-details
              disabled
              maxlength="5">
            </v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs4>
            <v-text-field
            v-model="lUniformInwardDetail.tax_percent"
            label="Tax Percent"
            hide-details
            type="Number"
            @input="calculateTaxAmount(lUniformInwardDetail)"
            maxlength="3"
            :disabled="lMAction === 'update'"
            :rules="[rules.required]">
          </v-text-field>
        </v-flex>
        <v-flex xs4>
          <v-text-field
          v-model="lUniformInwardDetail.tax_amount"
          label="Tax Amount"
          :rules="[rules.required]"
          hide-details
          disabled
          maxlength="5">
        </v-text-field>
      </v-flex>
      <v-flex xs4>
        <v-text-field
        v-model="lUniformInwardDetail.amount_af_tax"
        label="Total Amount with Tax"
        :rules="[rules.required]"
        hide-details
        disabled
        maxlength="5">
      </v-text-field>
    </v-flex>
  </v-layout>
</v-flex>
</v-card-text>
<v-card-actions>
  <v-spacer></v-spacer>
  <v-btn @click.stop="cancelChangesUniformInwardDetail">Cancel</v-btn>
  <v-btn v-if="lMAction === 'update'" :disabled="beingSaved" @click="deleteUniformInwardDetail(lUniformInwardDetail)">delete</v-btn>
  <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
</v-card-actions>
</v-card>
</v-form>
</v-container>
</v-form>
</v-dialog>

<!-- Insert, Update and Delete Uniform Outward -->
<v-container v-if="tab === 'tab-1' && (lAction === 'create' || lAction === 'update')" class="pa-2" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12 mx-auto>
      <v-form ref="lFormUniformOutwardBase" @submit.prevent="saveUniformOutwardBase(lAction)">
        <v-card>
          <v-card-title class="pa-1">
            <div class="title mb-2">
              <v-btn small icon @click="lAction = 'view'"><v-icon>mdi-arrow-left</v-icon></v-btn>
              <span class="pl-2 primary--text">{{ handy.startWithUpper(lAction) + ' Uniform Outward' }}</span>
            </div>
          </v-card-title>
          <v-card-text class="px-2 pb-2 pt-0">
            <v-layout row wrap>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-autocomplete
                    v-model="lUniformOutwardBase.proj_id"
                    :items="activeProjects"
                    label="Project Name"
                    item-text="proj_name"
                    item-value="proj_id"
                    hide-details
                    :disabled="lAction === 'update'"
                    :rules="[rules.required]"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs3>
                    <v-layout row wrap class="pt-4">
                      <v-btn class="mr-0 ml-2" @click.stop="cancelChanges()">Cancel</v-btn>
                      <v-btn class="mr-0 ml-2" v-if="lAction === 'update' && uniformOutwardDetail.length === 0 && config.IS_EDITED_BY_USER" @click="deleteUniformOutwardBase(lUniformOutwardBase)">delete</v-btn>
                      <v-btn class="mr-0 ml-2" v-if="lAction === 'create' && config.IS_EDITED_BY_USER" type="submit" color="accent black--text" :disabled="beingSaved">Save</v-btn>
                    </v-layout>
                  </v-flex>
                  <v-flex xs3>
                    <v-layout row wrap>
                      <v-chip small class="mr-4 ml-5 font-weight-bold" color="uniformchipinfo white--text">Total Qty : {{this.lUniformOutwardBase.qty}}   Units</v-chip>
                      <v-chip small class="mr-4 ml-5 mt-1 font-weight-bold" color="uniformchipinfo white--text">Total Amount : {{handy.formatCur(this.lUniformOutwardBase.tot_amt)}}</v-chip>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-form>
    </v-flex>
    <v-flex xs12 mx-auto v-if = "lUniformOutwardBase.uniform_outward_base_id">
      <v-flex>
        <v-card flat>
          <v-card-title class="pa-1">
            Distribution Details
            <v-spacer></v-spacer>
            <v-btn icon v-if="config.IS_EDITED_BY_USER" @click="prepareCreateUniformOutwardDetail(lUniformOutwardBase)"><v-icon>mdi-playlist-plus</v-icon></v-btn>
          </v-card-title>
          <v-card-text class="pa-1">
            <v-layout row wrap>
              <v-card-text class="ma-0 pa-0">
                <v-data-table
                :headers="uniformOutwardDetailHeader"
                :items="uniformOutwardDetail"
                fixed-header
                hide-default-header
                hide-default-footer
                class="elevation-3"
                :mobile-breakpoint="0"
                disable-pagination
                dense
                height="300px"
                >
                <template v-slot:header="{ props: { headers } }">
                  <thead>
                    <tr>
                      <th class="uniformtableheader white--text" style="font-size: 13px; width: 50px; text-align: center">{{headers[0].text}}</th>
                      <th class="uniformtableheader white--text" style="font-size: 13px; width: 110px; text-align: center">{{headers[1].text}}</th>
                      <th class="uniformtableheader white--text" style="font-size: 13px; width: 250px; text-align: left">{{headers[2].text}}</th>
                      <th class="uniformtableheader white--text" style="font-size: 13px; width: 150px; text-align: left">{{headers[3].text}}</th>
                      <th class="uniformtableheader white--text" style="font-size: 13px; width: 140px; text-align: left">{{headers[4].text}}</th>
                      <th class="uniformtableheader white--text" style="font-size: 13px; width: 170px; text-align: left">{{headers[5].text}}</th>
                      <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: center">{{headers[6].text}}</th>
                      <th class="uniformtableheader white--text" style="font-size: 13px; width: 70px; text-align: center">{{headers[7].text}}</th>
                      <th class="uniformtableheader white--text" style="font-size: 13px; width: 70px; text-align: right">{{headers[8].text}}</th>
                      <th class="uniformtableheader white--text" style="font-size: 13px; width: 70px; text-align: center">{{headers[9].text}}</th>
                    </tr>
                  </thead>
                </template>
                <template slot="item" slot-scope="props">
                  <tr>
                    <td style="text-align:center; font-size: 12px"> {{ props.index + 1 }} </td>
                    <td style="text-align:center; font-size: 12px"> {{ props.item.outward_date ? handy.formatDate(props.item.outward_date) : '-' }} </td>
                    <td style="text-align:left; font-size: 12px"> {{ props.item.emp_name_with_id ? props.item.emp_name_with_id : '-' }} </td>
                    <td style="text-align:left; font-size: 12px"> {{ props.item.designation ? props.item.designation : '-' }} </td>
                    <td style="text-align:left; font-size: 12px"> {{ props.item.uniform_cat ? props.item.uniform_cat : '-' }} </td>
                    <td style="text-align:left; font-size: 12px"> {{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : '-' }} </td>
                    <td style="text-align:center; font-size: 12px"> {{ props.item.uniform_size ? props.item.uniform_size : '-' }} </td>
                    <td style="text-align:center; font-size: 12px"> {{ props.item.qty ? props.item.qty : '-' }} </td>
                    <td style="text-align:right; font-size: 12px"> {{ props.item.unit_rate ? handy.formatCur(props.item.unit_rate) : '-' }} </td>
                    <td style="text-align:center; font-size: 12px">
                      <v-menu
                      :close-on-content-click="false"
                      top right class="mt-0">
                      <template v-slot:activator="{ on }">
                        <v-btn icon small v-on="on">
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <!-- list of menuitems -->
                      <v-list class="py-0">
                        <!-- menu with submenus of status -->
                        <v-list-item v-if="config.IS_EDITED_BY_USER" :disabled="uniformEmpMappingOutwarDetailIDs.find(rec => rec.uniform_outward_det_id === props.item.uniform_outward_det_id) && uniformEmpMappingOutwarDetailIDs.find(rec => rec.uniform_outward_det_id === props.item.uniform_outward_det_id).uniform_outward_det_id === props.item.uniform_outward_det_id" @click="prepareUpdateUniformOutwardDetail(props.item)">
                          <v-list-item-avatar><v-icon :disabled="uniformEmpMappingOutwarDetailIDs.find(rec => rec.uniform_outward_det_id === props.item.uniform_outward_det_id) && uniformEmpMappingOutwarDetailIDs.find(rec => rec.uniform_outward_det_id === props.item.uniform_outward_det_id).uniform_outward_det_id === props.item.uniform_outward_det_id">mdi-pencil</v-icon></v-list-item-avatar>
                          <v-list-item-title>Edit</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="config.IS_EDITED_BY_USER" :disabled="uniformEmpMappingOutwarDetailIDs.find(rec => rec.uniform_outward_det_id === props.item.uniform_outward_det_id) && uniformEmpMappingOutwarDetailIDs.find(rec => rec.uniform_outward_det_id === props.item.uniform_outward_det_id).uniform_outward_det_id === props.item.uniform_outward_det_id" @click="prepareCloneUniformOutwardDetail(props.item)">
                          <v-list-item-avatar><v-icon :disabled="uniformEmpMappingOutwarDetailIDs.find(rec => rec.uniform_outward_det_id === props.item.uniform_outward_det_id) && uniformEmpMappingOutwarDetailIDs.find(rec => rec.uniform_outward_det_id === props.item.uniform_outward_det_id).uniform_outward_det_id === props.item.uniform_outward_det_id">mdi-content-copy</v-icon></v-list-item-avatar>
                          <v-list-item-title>Clone</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="config.IS_EDITED_BY_USER" :disabled="uniformEmpMappingOutwarDetailIDs.find(rec => rec.uniform_outward_det_id === props.item.uniform_outward_det_id) && uniformEmpMappingOutwarDetailIDs.find(rec => rec.uniform_outward_det_id === props.item.uniform_outward_det_id).uniform_outward_det_id === props.item.uniform_outward_det_id" @click="deleteUniformOutwardDetail(props.item)">
                          <v-list-item-avatar><v-icon :disabled="uniformEmpMappingOutwarDetailIDs.find(rec => rec.uniform_outward_det_id === props.item.uniform_outward_det_id) && uniformEmpMappingOutwarDetailIDs.find(rec => rec.uniform_outward_det_id === props.item.uniform_outward_det_id).uniform_outward_det_id === props.item.uniform_outward_det_id">mdi-delete</v-icon></v-list-item-avatar>
                          <v-list-item-title>Delete</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="config.IS_EDITED_BY_USER && uniformEmpMappingOutwarDetailIDs.find(rec => rec.uniform_outward_det_id === props.item.uniform_outward_det_id) && uniformEmpMappingOutwarDetailIDs.find(rec => rec.uniform_outward_det_id === props.item.uniform_outward_det_id).uniform_outward_det_id === props.item.uniform_outward_det_id" @click="loadUniformOutwardEmpMapInfo(props.item)">
                          <v-list-item-avatar><v-icon>mdi-information-outline</v-icon></v-list-item-avatar>
                          <v-list-item-title>Info</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-else disabled>
                          <v-list-item-avatar><v-icon disabled>mdi-information-outline</v-icon></v-list-item-avatar>
                          <v-list-item-title>Info</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu> </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex>
      <v-card flat>
        <v-card-title class="pa-1">
          Bulk Distribution Details
          <v-chip small class="mr-0 ml-8 font-weight-bold" color="uniformchipinfo white--text">Total Bulk Qty :  {{uniformBulkDistributionQtyChipSummary.find(rec => rec.proj_id === lUniformOutwardBase.proj_id) && uniformBulkDistributionQtyChipSummary.find(rec => rec.proj_id === lUniformOutwardBase.proj_id).total_bulk_qty}}  Units</v-chip>
          <v-chip small class="mr-0 ml-8 font-weight-bold" color="uniformchipinfo white--text">Emp Mapped Qty :  {{uniformBulkDistributionQtyChipSummary.find(rec => rec.proj_id === lUniformOutwardBase.proj_id) && uniformBulkDistributionQtyChipSummary.find(rec => rec.proj_id === lUniformOutwardBase.proj_id).total_allocated_qty}}  Units</v-chip>
          <v-chip small class="mr-0 ml-8 font-weight-bold" color="uniformchipinfo white--text">Pending Emp Mapping :  {{uniformBulkDistributionQtyChipSummary.find(rec => rec.proj_id === lUniformOutwardBase.proj_id) && uniformBulkDistributionQtyChipSummary.find(rec => rec.proj_id === lUniformOutwardBase.proj_id).total_balance_qty}}  Units</v-chip>
          <v-spacer></v-spacer>
          <v-btn icon v-if="config.IS_EDITED_BY_USER" @click="prepareCreateUniformBulkDistributionDetail(lUniformOutwardBase)"><v-icon>mdi-playlist-plus</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pa-1">
          <v-layout row wrap>
            <v-card-text class="ma-0 pa-0">
              <v-data-table
              :headers="uniformBulkDistributionDetailHeader"
              :items="uniformBulkDistributionDetail"
              hide-default-header
              hide-default-footer
              fixed-header
              class="elevation-3"
              :mobile-breakpoint="0"
              disable-pagination
              dense
              height="200px"
              >
              <template v-slot:header="{ props: { headers } }">
                <thead>
                  <tr>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 50px; text-align: center">{{headers[0].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 110px; text-align: center">{{headers[1].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 250px; text-align: left">{{headers[2].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 160px; text-align: left">{{headers[3].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 200px; text-align: left">{{headers[4].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: left">{{headers[5].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: center">{{headers[6].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: center">{{headers[7].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 70px; text-align: center">{{headers[8].text}}</th>
                  </tr>
                </thead>
              </template>
              <template slot="item" slot-scope="props">
                <tr>
                  <td style="text-align:center; font-size: 12px"> {{ props.index + 1 }} </td>
                  <td style="text-align:center; font-size: 12px"> {{ props.item.bulk_outward_date ? handy.formatDate(props.item.bulk_outward_date) : '-' }} </td>
                  <td style="text-align:left; font-size: 12px"> {{ props.item.emp_name_or_taken_by ? props.item.emp_name_or_taken_by : '-' }} </td>
                  <td style="text-align:left; font-size: 12px"> {{ props.item.uniform_cat ? props.item.uniform_cat : '-' }} </td>
                  <td style="text-align:left; font-size: 12px"> {{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : '-' }} </td>
                  <td style="text-align:left; font-size: 12px"> {{ props.item.uniform_size ? props.item.uniform_size : '-' }} </td>
                  <td style="text-align:center; font-size: 12px"> {{ props.item.qty ? props.item.qty : '-' }} </td>
                  <td style="text-align:center; font-size: 12px"> {{ props.item.balance_qty ? props.item.balance_qty : '-' }} </td>
                  <td style="text-align:center; font-size: 12px">
                    <v-menu
                    :close-on-content-click="false"
                    top right class="mt-0">
                    <template v-slot:activator="{ on }">
                      <v-btn icon small v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <!-- list of menuitems -->
                    <v-list class="py-0" v-if="config.IS_EDITED_BY_USER">
                      <!-- menu with submenus of status -->
                      <v-list-item @click="loadEmployeeMappingSummary(props.item)">
                        <v-list-item-avatar><v-icon>mdi-account-multiple-plus</v-icon></v-list-item-avatar>
                        <v-list-item-title>Emp Mapping</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="prepareReturnUniformBulkDistribution(props.item)">
                        <v-list-item-avatar><v-icon>mdi-keyboard-return</v-icon></v-list-item-avatar>
                        <v-list-item-title>Return Qty</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="prepareUpdateUniformBulkDistributionDetail(props.item)">
                        <v-list-item-avatar><v-icon>mdi-pencil</v-icon></v-list-item-avatar>
                        <v-list-item-title>Edit</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="prepareCloneUniformBulkDistributionDetail(props.item)">
                        <v-list-item-avatar><v-icon>mdi-content-copy</v-icon></v-list-item-avatar>
                        <v-list-item-title>Clone</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="deleteUniformBulkDistributionDetail(props.item)">
                        <v-list-item-avatar><v-icon>mdi-delete</v-icon></v-list-item-avatar>
                        <v-list-item-title>Delete</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu> </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-flex>
</v-flex>
</v-layout>
</v-container>

<v-dialog v-model="manageUniformOutwardDetail" persistent max-width="600px">
  <v-form>
    <!-- Create, Edit and Delete Uniform Outward Detail -->
    <v-container v-if="lMAction === 'create' || lMAction === 'update'" class="pa-0" fluid grid-list-md>
      <v-form ref="lFormUniformOutwardDetail" @submit.prevent="saveUniformOutwardDetail(lMAction)">
        <v-card flat class="pa-0">
          <v-card-title class="title py-1 uniformtableheader white--text">
            {{ handy.startWithUpper(lMAction) }} Uniform Outward Detail
          </v-card-title>
          <v-card-text>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs8>
                  <v-autocomplete
                  v-model="lUniformOutwardDetail.proj_id"
                  :items="activeProjects"
                  label="Project Name"
                  item-text="proj_name"
                  item-value="proj_id"
                  hide-details
                  :rules="[rules.required]"
                  disabled
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs4>
                  <v-dialog ref="dlgDate_outward"
                  persistent v-model="dlgDate_outward"
                  max-width="290px"
                  :return-value.sync="lUniformOutwardDetail.outward_date">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                    slot="activator" label="Date"
                    v-model="lUniformOutwardDetail.outward_date" append-icon="mdi-calendar-today"
                    readonly clearable
                    :rules="[rules.required]"
                    v-on="on"
                    :disabled="lMAction === 'update'"
                    hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="lUniformOutwardDetail.outward_date"
                  first-day-of-week="1">
                  <v-spacer></v-spacer>
                  <v-btn text @click="dlgDate_outward = false">Cancel</v-btn>
                  <v-btn text color="accent" @click="$refs.dlgDate_outward.save(lUniformOutwardDetail.outward_date)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs6>
              <v-autocomplete
              v-model="lUniformOutwardDetail.outward_emp_id"
              :items="projectEmployees"
              label="Employee Name"
              item-text="emp_name_with_id"
              item-value="emp_id"
              hide-details
              :disabled="lMAction === 'update'"
              @input="loadEmployeeDesignation(lUniformOutwardDetail, 'OutwardDetail')"
              :rules="[rules.required]"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6>
              <v-text-field
              v-model="lUniformOutwardDetail.designation"
              label="Designation"
              :rules="[rules.required]"
              hide-details
              disabled
              maxlength="25">
            </v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 class="pt-3" v-if="lUniformOutwardDetail.undeployedDate">
        <div class="font-weight-bold white--text" style="background-color:red; text-align:center; font-size: 14px">Selected Employee is Already left from the Project</div>
      </v-flex>
      <v-flex xs12>
        <v-card-text class="ma-0 pa-0 pt-3">
          <v-data-table
          :headers="uniformDistributionHistoryForEmployeeHeader"
          hide-default-header
          :items="uniformDistributionHistoryForEmployee"
          hide-default-footer
          class="elevation-3"
          :mobile-breakpoint="0"
          disable-pagination
          :hidden="lMAction === 'update'"
          dense
          >
          <template v-slot:header="{ props: { headers } }">
            <thead>
              <tr>
                <th class="grey white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[0].text}}</th>
                <th class="grey white--text" style="font-size: 13px; width: 150px; text-align: left">{{headers[1].text}}</th>
                <th class="grey white--text" style="font-size: 13px; width: 80px; text-align: center">{{headers[2].text}}</th>
                <th class="grey white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[3].text}}</th>
              </tr>
            </thead>
          </template>
          <template slot="item" slot-scope="props">
            <tr>
              <td style="color:red; text-align:center; font-size: 12px"> {{ props.item.outward_date ? handy.formatDate(props.item.outward_date) : '-' }} </td>
              <td style="color:red; text-align:left; font-size: 12px"> {{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : '-' }} </td>
              <td style="color:red; text-align:center; font-size: 12px"> {{ props.item.qty ? props.item.qty : '-' }} </td>
              <td style="color:red; text-align:center; font-size: 12px"> {{ props.item.duration ? props.item.duration : '-' }} </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-flex>
    <v-flex xs12>
      <v-layout row wrap>
        <v-flex xs6>
          <v-autocomplete
          v-model="lUniformOutwardDetail.uniform_cat_id"
          :items="uniformCat"
          label="Uniform Category"
          item-text="uniform_cat"
          item-value="uniform_cat_id"
          hide-details
          :disabled="lMAction === 'update'"
          @input="loadOutwardUniformSubCatByCatID(lUniformOutwardDetail)"
          :rules="[rules.required]"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs6>
          <v-autocomplete
          v-model="lUniformOutwardDetail.uniform_sub_cat_id"
          :items="uniformOutwardSubCat"
          label="Uniform Sub Category"
          item-text="uniform_sub_cat"
          item-value="uniform_sub_cat_id"
          hide-details
          :disabled="lMAction === 'update'"
          @input="loadOutwardUniformSizeBySubCatID(lUniformOutwardDetail.uniform_sub_cat_id)"
          :rules="[rules.required]"
          ></v-autocomplete>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex>
      <v-layout row wrap>
        <v-flex xs3>
          <v-autocomplete
          v-model="lUniformOutwardDetail.uniform_size_id"
          :items="uniformOutwardSize"
          label="Uniform Size"
          item-text="uniform_size"
          item-value="uniform_size_id"
          hide-details
          :disabled="lMAction === 'update'"
          @input="loadOutwardStockSequenceDetail(lUniformOutwardDetail)"
          :rules="[rules.required]"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs3>
          <v-text-field
          v-model="lUniformOutwardDetail.qty"
          label="Qty"
          :rules="[rules.required]"
          @input="changeOutwardStockSequenceDetail(lUniformOutwardDetail)"
          hide-details
          type="Number"
          maxlength="5">
        </v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-select
        v-model="lUniformOutwardDetail.uniform_stock_sequence_id"
        :items="uniformStockSeqWithRate"
        label="Available stock with Rate &amp; Tax"
        item-text="disply_value"
        item-value="uniform_stock_sequence_id"
        hide-details
        :disabled="lMAction === 'update' || (lUniformOutwardDetail.qty <= 0)"
        @input="loadUniformStockAllocationInstruction(lUniformOutwardDetail)"
        :rules="[rules.required]"
        ></v-select>
      </v-flex>
    </v-layout>
  </v-flex>
  <v-flex xs12>
    <v-card-text class="ma-0 pa-0 pt-3">
      <v-data-table
      :items="uniformAllocationInstruction"
      hide-default-footer
      class="elevation-3"
      :mobile-breakpoint="0"
      disable-pagination
      >
      <template slot="item" slot-scope="props">
        <tr>
          <td> {{ props.item.instruction ? props.item.instruction : '-' }} </td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-flex>
</v-card-text>
<v-card-actions>
  <v-spacer></v-spacer>
  <v-btn @click.stop="cancelChangesUniformOutwardDetail">Cancel</v-btn>
  <v-btn v-if="lMAction === 'update'" :disabled="beingSaved" @click="deleteUniformOutwardDetail(lUniformOutwardDetail)">delete</v-btn>
  <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
</v-card-actions>
</v-card>
</v-form>
</v-container>
<v-container v-if="lMAction === 'info'" class="pa-0" fluid grid-list-md>
  <v-card flat class="pa-0">
    <v-card-title class="title pb-0">
      Uniform Outward Details - Information
      <v-spacer></v-spacer>
      <v-btn icon small @click="manageUniformOutwardDetail = false"><v-icon> mdi-close </v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md class="pt-3 px-0">
        <v-layout row wrap>
          <v-flex xs12 class="uniformchipinfo">
            <v-layout row wrap>
              <v-flex xs5>
                <div class="caption white--text">Project Name.</div>
                <div class="white--text font-weight-bold">{{uniformEmpMapOutwardIdInfo.proj_name ? uniformEmpMapOutwardIdInfo.proj_name : '-'}}</div>
              </v-flex>
              <v-flex xs3>
                <div class="caption white--text">Bulk Distribution Date.</div>
                <div class="white--text font-weight-bold">{{uniformEmpMapOutwardIdInfo.bulk_outward_date ? handy.formatDate(uniformEmpMapOutwardIdInfo.bulk_outward_date) : '-'}}</div>
              </v-flex>
              <v-flex xs4>
                <div class="caption white--text">Bulk Distributed To.</div>
                <div class="white--text font-weight-bold">{{uniformEmpMapOutwardIdInfo.emp_name_with_id ? uniformEmpMapOutwardIdInfo.emp_name_with_id : uniformEmpMapOutwardIdInfo.taken_by}}</div>
              </v-flex>
              <v-flex xs4 pt-3>
                <div class="caption white--text">Sub Category.</div>
                <div class="white--text font-weight-bold">{{uniformEmpMapOutwardIdInfo.uniform_sub_cat ? uniformEmpMapOutwardIdInfo.uniform_sub_cat : '-'}}</div>
              </v-flex>
              <v-flex xs2 pt-3>
                <div class="caption white--text text-center">Uniform Size.</div>
                <div class="white--text text-center font-weight-bold">{{uniformEmpMapOutwardIdInfo.uniform_size ? uniformEmpMapOutwardIdInfo.uniform_size : '-'}}</div>
              </v-flex>
              <v-flex xs2 pt-3>
                <div class="caption white--text text-center">Bulk Qty.</div>
                <div class="white--text text-center font-weight-bold">{{uniformEmpMapOutwardIdInfo.qty ? uniformEmpMapOutwardIdInfo.qty : '-'}}</div>
              </v-flex>
              <v-flex xs2 pt-3>
                <div class="caption white--text text-center">Emp Mapped.</div>
                <div class="white--text lighten-4 text-center font-weight-bold">{{uniformEmpMapOutwardIdInfo.allocated_qty ? uniformEmpMapOutwardIdInfo.allocated_qty : '-'}}</div>
              </v-flex>
              <v-flex xs2 pt-3>
                <div class="caption white--text text-center">Bal Emp Map.</div>
                <div class="white--text text-center font-weight-bold">{{uniformEmpMapOutwardIdInfo.balance_qty ? uniformEmpMapOutwardIdInfo.balance_qty : '-'}}</div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</v-container>
</v-form>
</v-dialog>

<v-dialog v-model="manageUniformBulkDistributionDetail" persistent max-width="600px">
  <v-form>
    <!-- Create, Edit and Delete Uniform Bulk Distribution Detail -->
    <v-container v-if="lMAction === 'create' || lMAction === 'update'" class="pa-0" fluid grid-list-md>
      <v-form ref="lFormUniformBulkDistributionDetail" @submit.prevent="saveUniformBulkDistributionDetail(lMAction)">
        <v-card flat class="pa-0">
          <v-card-title class="title py-1 uniformtableheader white--text">
            {{ handy.startWithUpper(lMAction) }} Uniform Bulk Distribution Detail
          </v-card-title>
          <v-card-text>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs8>
                  <v-autocomplete
                  v-model="lUniformBulkDistributionDetail.proj_id"
                  :items="activeProjects"
                  label="Project Name"
                  item-text="proj_name"
                  item-value="proj_id"
                  hide-details
                  :rules="[rules.required]"
                  disabled
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs4>
                  <v-dialog ref="dlgDate_bulkoutward"
                  persistent v-model="dlgDate_bulkoutward"
                  max-width="290px"
                  :return-value.sync="lUniformBulkDistributionDetail.bulk_outward_date">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                    slot="activator" label="Date"
                    v-model="lUniformBulkDistributionDetail.bulk_outward_date" append-icon="mdi-calendar-today"
                    readonly clearable
                    :rules="[rules.required]"
                    v-on="on"
                    :disabled="lMAction === 'update'"
                    hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="lUniformBulkDistributionDetail.bulk_outward_date"
                  first-day-of-week="1">
                  <v-spacer></v-spacer>
                  <v-btn text @click="dlgDate_bulkoutward = false">Cancel</v-btn>
                  <v-btn text color="accent" @click="$refs.dlgDate_bulkoutward.save(lUniformBulkDistributionDetail.bulk_outward_date)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs6>
              <v-autocomplete
              v-model="lUniformBulkDistributionDetail.bulk_outward_emp_id"
              :items="projectEmployees"
              label="Employee Name"
              item-text="emp_name_with_id"
              item-value="emp_id"
              hide-details
              :disabled="lMAction === 'update'"
              @input="loadEmployeeDesignation(lUniformBulkDistributionDetail, 'BulkDistributionDetail')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6>
              <v-text-field
              v-model="lUniformBulkDistributionDetail.designation"
              label="Designation"
              hide-details
              disabled
              maxlength="25">
            </v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
            v-model="lUniformBulkDistributionDetail.taken_by"
            label="Taken By (Employee Name, Eemployee ID & Designation)"
            hide-details
            :disabled="lMAction === 'update'"
            maxlength="100">
          </v-text-field>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12>
      <v-layout row wrap>
        <v-flex xs6>
          <v-autocomplete
          v-model="lUniformBulkDistributionDetail.uniform_cat_id"
          :items="uniformCat"
          label="Uniform Category"
          item-text="uniform_cat"
          item-value="uniform_cat_id"
          hide-details
          :disabled="lMAction === 'update'"
          @input="loadOutwardUniformSubCatByCatID(lUniformBulkDistributionDetail)"
          :rules="[rules.required]"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs6>
          <v-autocomplete
          v-model="lUniformBulkDistributionDetail.uniform_sub_cat_id"
          :items="uniformOutwardSubCat"
          label="Uniform Sub Category"
          item-text="uniform_sub_cat"
          item-value="uniform_sub_cat_id"
          hide-details
          :disabled="lMAction === 'update'"
          @input="loadOutwardUniformSizeBySubCatID(lUniformBulkDistributionDetail.uniform_sub_cat_id)"
          :rules="[rules.required]"
          ></v-autocomplete>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex>
      <v-layout row wrap>
        <v-flex xs3>
          <v-autocomplete
          v-model="lUniformBulkDistributionDetail.uniform_size_id"
          :items="uniformOutwardSize"
          label="Uniform Size"
          item-text="uniform_size"
          item-value="uniform_size_id"
          hide-details
          :disabled="lMAction === 'update'"
          @input="loadOutwardStockSequenceDetail(lUniformBulkDistributionDetail)"
          :rules="[rules.required]"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs3>
          <v-text-field
          v-model="lUniformBulkDistributionDetail.qty"
          label="Qty"
          :rules="[rules.required]"
          @input="changeOutwardStockSequenceDetail(lUniformBulkDistributionDetail)"
          hide-details
          type="Number"
          maxlength="5">
        </v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-select
        v-model="lUniformBulkDistributionDetail.uniform_stock_sequence_id"
        :items="uniformStockSeqWithRate"
        label="Available stock with Rate &amp; Tax"
        item-text="disply_value"
        item-value="uniform_stock_sequence_id"
        hide-details
        :disabled="lMAction === 'update' || (lUniformBulkDistributionDetail.qty <= 0)"
        @input="loadUniformStockAllocationInstruction(lUniformBulkDistributionDetail)"
        :rules="[rules.required]"
        ></v-select>
      </v-flex>
    </v-layout>
  </v-flex>
  <v-flex xs12>
    <v-card-text class="ma-0 pa-0 pt-3">
      <v-data-table
      :items="uniformAllocationInstruction"
      hide-default-footer
      class="elevation-3"
      :mobile-breakpoint="0"
      disable-pagination
      >
      <template slot="item" slot-scope="props">
        <tr>
          <td> {{ props.item.instruction ? props.item.instruction : '-' }} </td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-flex>
</v-card-text>
<v-card-actions>
  <v-spacer></v-spacer>
  <v-btn @click.stop="cancelChangesUniformBulkDistributionDetail">Cancel</v-btn>
  <v-btn v-if="lMAction === 'update'" :disabled="beingSaved" @click="deleteUniformBulkDistributionDetail(lUniformBulkDistributionDetail)">delete</v-btn>
  <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
</v-card-actions>
</v-card>
</v-form>
</v-container>
</v-form>
</v-dialog>

<v-dialog v-model="manageUniformBulkDistributionReturn" persistent max-width="600px">
  <v-form>
    <!-- Create, Edit and Delete Uniform bulk Outward Return Detail -->
    <v-container v-if="lMAction === 'return'" class="pa-0" fluid grid-list-md>
      <v-form ref="lFormUniformBulkDistributionReturn" @submit.prevent="returnUniformBulkDistribution(lMAction)">
        <v-card flat class="pa-0">
          <v-card-title class="title py-1 uniformtableheader white--text">
            {{ handy.startWithUpper(lMAction) }} Uniform Bulk Distribution
          </v-card-title>
          <v-card-text>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs8>
                  <v-autocomplete
                  v-model="lUniformBulkDistributionReturn.proj_id"
                  :items="activeProjects"
                  label="Project Name"
                  item-text="proj_name"
                  item-value="proj_id"
                  hide-details
                  :rules="[rules.required]"
                  disabled
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs4>
                  <v-dialog ref="dlgDate_bulkoutwardreturn"
                  persistent v-model="dlgDate_bulkoutwardreturn"
                  max-width="290px"
                  :return-value.sync="lUniformBulkDistributionReturn.bulk_outward_date">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                    slot="activator" label="Date"
                    v-model="lUniformBulkDistributionReturn.bulk_outward_date" append-icon="mdi-calendar-today"
                    readonly clearable
                    :rules="[rules.required]"
                    v-on="on"
                    disabled
                    hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="lUniformBulkDistributionReturn.bulk_outward_date"
                  first-day-of-week="1">
                  <v-spacer></v-spacer>
                  <v-btn text @click="dlgDate_bulkoutwardreturn = false">Cancel</v-btn>
                  <v-btn text color="accent" @click="$refs.dlgDate_bulkoutwardreturn.save(lUniformBulkDistributionReturn.bulk_outward_date)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs6>
              <v-autocomplete
              v-model="lUniformBulkDistributionReturn.bulk_outward_emp_id"
              :items="projectEmployees"
              label="Employee Name"
              item-text="emp_name_with_id"
              item-value="emp_id"
              hide-details
              disabled
              @input="loadEmployeeDesignation(lUniformBulkDistributionReturn, 'BulkDistributionReturn')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6>
              <v-text-field
              v-model="lUniformBulkDistributionReturn.designation"
              label="Designation"
              hide-details
              disabled
              maxlength="25">
            </v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
            v-model="lUniformBulkDistributionReturn.taken_by"
            label="Taken By (Employee Name, Eemployee ID & Designation)"
            hide-details
            disabled
            maxlength="100">
          </v-text-field>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12>
      <v-layout row wrap>
        <v-flex xs6>
          <v-autocomplete
          v-model="lUniformBulkDistributionReturn.uniform_cat_id"
          :items="uniformCat"
          label="Uniform Category"
          item-text="uniform_cat"
          item-value="uniform_cat_id"
          hide-details
          disabled
          :rules="[rules.required]"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs6>
          <v-autocomplete
          v-model="lUniformBulkDistributionReturn.uniform_sub_cat_id"
          :items="uniformOutwardSubCat"
          label="Uniform Sub Category"
          item-text="uniform_sub_cat"
          item-value="uniform_sub_cat_id"
          hide-details
          disabled
          :rules="[rules.required]"
          ></v-autocomplete>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex>
      <v-layout row wrap>
        <v-flex xs3>
          <v-autocomplete
          v-model="lUniformBulkDistributionReturn.uniform_size_id"
          :items="uniformOutwardSize"
          label="Uniform Size"
          item-text="uniform_size"
          item-value="uniform_size_id"
          hide-details
          disabled
          :rules="[rules.required]"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs3>
          <v-text-field
          v-model="lUniformBulkDistributionReturn.qty"
          label="Qty"
          :rules="[rules.required]"
          hide-details
          type="Number"
          maxlength="5">
        </v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-text-field
        v-model="lUniformBulkDistributionReturn.available_stock"
        label="Available Stock"
        hide-details
        disabled
        maxlength="5">
      </v-text-field>
    </v-flex>
  </v-layout>
</v-flex>
</v-card-text>
<v-card-actions>
  <v-spacer></v-spacer>
  <v-btn @click.stop="cancelChangesUniformBulkDistributionReturn">Cancel</v-btn>
  <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
</v-card-actions>
</v-card>
</v-form>
</v-container>
</v-form>
</v-dialog>

<v-dialog v-model="manageUniformEmpMappingBase" persistent max-width="800px">
  <v-card flat class="pa-0">
    <v-card-title class="title pb-0">
      Bulk Distribution - Employee Mapping
      <v-spacer></v-spacer>
      <v-btn icon small @click="manageUniformEmpMappingBase = false"><v-icon> mdi-close </v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md class="pt-3 px-0">
        <v-layout row wrap>
          <v-flex xs12 class="uniformchipinfo">
            <v-layout row wrap>
              <v-flex xs5>
                <div class="caption white--text">Project Name.</div>
                <div class="white--text font-weight-bold">{{uniformBulkDistributionDetailForID.proj_name}}</div>
              </v-flex>
              <v-flex xs3>
                <div class="caption white--text">Distribution Date.</div>
                <div class="white--text font-weight-bold">{{uniformBulkDistributionDetailForID.bulk_outward_date ? handy.formatDate(uniformBulkDistributionDetailForID.bulk_outward_date) : ''}}</div>
              </v-flex>
              <v-flex xs4>
                <div class="caption white--text">Distributed To.</div>
                <div class="white--text font-weight-bold">{{uniformBulkDistributionDetailForID.emp_name_with_id ? uniformBulkDistributionDetailForID.emp_name_with_id : uniformBulkDistributionDetailForID.taken_by}}</div>
              </v-flex>
              <v-flex xs4 pt-3>
                <div class="caption white--text">Sub Category.</div>
                <div class="white--text font-weight-bold">{{uniformBulkDistributionDetailForID.uniform_sub_cat}}</div>
              </v-flex>
              <v-flex xs2 pt-3>
                <div class="caption white--text text-center">Uniform Size.</div>
                <div class="white--text text-center font-weight-bold">{{uniformBulkDistributionDetailForID.uniform_size}}</div>
              </v-flex>
              <v-flex xs2 pt-3>
                <div class="caption white--text text-center">Total Bulk Qty.</div>
                <div class="white--text text-center font-weight-bold">{{uniformBulkDistributionDetailForID.qty}}</div>
              </v-flex>
              <v-flex xs2 pt-3>
                <div class="caption white--text text-center">Emp Mapped.</div>
                <div class="white--text lighten-4 text-center font-weight-bold">{{uniformBulkDistributionDetailForID.allocated_qty}}</div>
              </v-flex>
              <v-flex xs2 pt-3>
                <div class="caption white--text text-center">Bal Emp Mapping.</div>
                <div class="white--text text-center font-weight-bold">{{uniformBulkDistributionDetailForID.balance_qty}}</div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout pt-1>
          <v-flex xs11 pt-2>
            <div class="subtitle black--text font-weight-bold">
              Employee Maping Detail
            </div>
          </v-flex>
          <v-flex xs1 pt-2>
            <v-btn icon small :disabled="uniformBulkDistributionDetailForID.balance_qty <= 0" @click="prepareCreateUniformEmpMappingDetail(lUniformBulkDistributionDetail)"><v-icon>mdi-playlist-plus</v-icon></v-btn>
          </v-flex>
        </v-layout>
        <v-layout row wrap pt-1>
          <v-card-text class="ma-0 pa-0">
            <v-data-table
            :headers="uniformBulkDistributionEmpMappingDetailHeader"
            :items="uniformBulkDistributionEmpMappingDetail"
            hide-default-header
            hide-default-footer
            fixed-header
            class="elevation-3"
            :mobile-breakpoint="0"
            disable-pagination
            dense
            height="200px"
            >
            <template v-slot:header="{ props: { headers } }">
              <thead>
                <tr>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 50px; text-align: center">{{headers[0].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 130px; text-align: center">{{headers[1].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 250px; text-align: left">{{headers[2].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 220px; text-align: left">{{headers[3].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: center">{{headers[4].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[5].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: center">{{headers[6].text}}</th>
                </tr>
              </thead>
            </template>
            <template slot="item" slot-scope="props">
              <tr>
                <td style="text-align:center; font-size: 12px"> {{ props.index + 1 }} </td>
                <td style="text-align:center; font-size: 12px"> {{ props.item.mapping_date ? handy.formatDate(props.item.mapping_date) : '-' }} </td>
                <td style="text-align:left; font-size: 12px"> {{ props.item.emp_name_with_id ? props.item.emp_name_with_id : '-' }} </td>
                <td style="text-align:left; font-size: 12px"> {{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : '-' }} </td>
                <td style="text-align:center; font-size: 12px"> {{ props.item.uniform_size ? props.item.uniform_size : '-' }} </td>
                <td style="text-align:center; font-size: 12px"> {{ props.item.qty ? props.item.qty : '-' }} </td>
                <td style="text-align:center; font-size: 12px">
                  <v-menu
                  :close-on-content-click="false"
                  top right class="mt-0">
                  <template v-slot:activator="{ on }">
                    <v-btn icon small v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <!-- list of menuitems -->
                  <v-list class="py-0">
                    <!-- menu with submenus of status -->
                    <v-list-item @click="prepareUpdateUniformEmpMappingDetail(props.item)">
                      <v-list-item-avatar><v-icon>mdi-pencil</v-icon></v-list-item-avatar>
                      <v-list-item-title>Edit</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="deleteUniformEmpMappingDetail(props.item)">
                      <v-list-item-avatar><v-icon>mdi-delete</v-icon></v-list-item-avatar>
                      <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu> </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-layout>
    </v-container>
  </v-card-text>
</v-card>
</v-dialog>

<v-dialog v-model="manageUniformEmpMappingDetail" persistent max-width="600px">
  <v-form>
    <!-- Create, Edit and Delete Uniform Outward Detail -->
    <v-container v-if="lMAction === 'create' || lMAction === 'update'" class="pa-0" fluid grid-list-md>
      <v-form ref="lFormUniformEmpMappingDetail" @submit.prevent="saveUniformEmpMappingDetail(lMAction)">
        <v-card flat class="pa-0">
          <v-card-title class="title py-1 uniformtableheader white--text">
            {{ handy.startWithUpper(lMAction) }} Uniform Employee Mapping
          </v-card-title>
          <v-card-text>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs8>
                  <v-autocomplete
                  v-model="lUniformBulkDistributionEmpMappingDetail.proj_id"
                  :items="activeProjects"
                  label="Project Name"
                  item-text="proj_name"
                  item-value="proj_id"
                  hide-details
                  :rules="[rules.required]"
                  disabled
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs4>
                  <v-dialog ref="dlgDate_empmap"
                  persistent v-model="dlgDate_empmap"
                  max-width="290px"
                  :return-value.sync="lUniformBulkDistributionEmpMappingDetail.mapping_date">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                    slot="activator" label="Date"
                    v-model="lUniformBulkDistributionEmpMappingDetail.mapping_date" append-icon="mdi-calendar-today"
                    readonly clearable
                    :rules="[rules.required]"
                    v-on="on"
                    :disabled="lMAction === 'update'"
                    hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="lUniformBulkDistributionEmpMappingDetail.mapping_date"
                  first-day-of-week="1">
                  <v-spacer></v-spacer>
                  <v-btn text @click="dlgDate_empmap = false">Cancel</v-btn>
                  <v-btn text color="accent" @click="$refs.dlgDate_empmap.save(lUniformBulkDistributionEmpMappingDetail.mapping_date)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs6>
              <v-autocomplete
              v-model="lUniformBulkDistributionEmpMappingDetail.empmap_emp_id"
              :items="projectEmployees"
              label="Employee Name"
              item-text="emp_name_with_id"
              item-value="emp_id"
              hide-details
              :disabled="lMAction === 'update'"
              @input="loadEmployeeDesignation(lUniformBulkDistributionEmpMappingDetail, 'BulkDistributionDetailEmpMapping')"
              :rules="[rules.required]"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6>
              <v-text-field
              v-model="lUniformBulkDistributionEmpMappingDetail.designation"
              label="Designation"
              :rules="[rules.required]"
              hide-details
              disabled
              maxlength="5">
            </v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-card-text class="ma-0 pa-0 pt-3">
          <v-data-table
          :headers="uniformDistributionHistoryForEmployeeHeader"
          hide-default-header
          :items="uniformDistributionHistoryForEmployee"
          hide-default-footer
          class="elevation-3"
          :mobile-breakpoint="0"
          disable-pagination
          :hidden="lMAction === 'update'"
          dense
          >
          <template v-slot:header="{ props: { headers } }">
            <thead>
              <tr>
                <th class="grey white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[0].text}}</th>
                <th class="grey white--text" style="font-size: 13px; width: 150px; text-align: left">{{headers[1].text}}</th>
                <th class="grey white--text" style="font-size: 13px; width: 80px; text-align: center">{{headers[2].text}}</th>
                <th class="grey white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[3].text}}</th>
              </tr>
            </thead>
          </template>
          <template slot="item" slot-scope="props">
            <tr>
              <td style="color:red; text-align:center; font-size: 12px"> {{ props.item.outward_date ? handy.formatDate(props.item.outward_date) : '-' }} </td>
              <td style="color:red; text-align:left; font-size: 12px"> {{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : '-' }} </td>
              <td style="color:red; text-align:center; font-size: 12px"> {{ props.item.qty ? props.item.qty : '-' }} </td>
              <td style="color:red; text-align:center; font-size: 12px"> {{ props.item.duration ? props.item.duration : '-' }} </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-flex>
    <v-flex xs12>
      <v-layout row wrap>
        <v-flex xs6>
          <v-autocomplete
          v-model="lUniformBulkDistributionEmpMappingDetail.uniform_cat_id"
          :items="uniformCat"
          label="Uniform Category"
          item-text="uniform_cat"
          item-value="uniform_cat_id"
          hide-details
          disabled
          :rules="[rules.required]"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs6>
          <v-autocomplete
          v-model="lUniformBulkDistributionEmpMappingDetail.uniform_sub_cat_id"
          :items="uniformOutwardSubCat"
          label="Uniform Sub Category"
          item-text="uniform_sub_cat"
          item-value="uniform_sub_cat_id"
          hide-details
          disabled
          :rules="[rules.required]"
          ></v-autocomplete>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex>
      <v-layout row wrap>
        <v-flex xs3>
          <v-autocomplete
          v-model="lUniformBulkDistributionEmpMappingDetail.uniform_size_id"
          :items="uniformOutwardSize"
          label="Uniform Size"
          item-text="uniform_size"
          item-value="uniform_size_id"
          hide-details
          disabled
          :rules="[rules.required]"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs3>
          <v-text-field
          v-model="lUniformBulkDistributionEmpMappingDetail.qty"
          label="Qty"
          :rules="[rules.required]"
          hide-details
          type="Number"
          maxlength="5">
        </v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-text-field
        v-model="lUniformBulkDistributionEmpMappingDetail.available_stock"
        label="Available Stock"
        hide-details
        disabled
        maxlength="5">
      </v-text-field>
    </v-flex>
  </v-layout>
</v-flex>
</v-card-text>
<v-card-actions>
  <v-spacer></v-spacer>
  <v-btn @click.stop="cancelChangesUniformEmpMappingDetail">Cancel</v-btn>
  <v-btn v-if="lMAction === 'update'" :disabled="beingSaved" @click="deleteUniformEmpMappingDetail(lUniformBulkDistributionEmpMappingDetail)">delete</v-btn>
  <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
</v-card-actions>
</v-card>
</v-form>
</v-container>
</v-form>
</v-dialog>

<!-- Reports Blocks -->
<!-- Sub Category wise stock report -->
<v-container class="pa-0" v-if="lAction === 'subcat-stockreport'" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12 mx-auto>
      <v-flex xs12>
        <v-card flat>
          <v-card-title class="title pt-2 pl-0 pb-2">
            <v-btn icon class="ma-0" @click="lAction = prevScr || 'view'"><v-icon>mdi-chevron-left</v-icon></v-btn>
            Sub Category Wise Stock Report
            <v-spacer></v-spacer>
            <v-text-field
            v-model="searchSubCatWiseStockReport"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            clearable
            hide-details
            class="mt-0 pt-0"
            ></v-text-field>
            <v-flex xs3>
              <v-download-as
              :headers="uniformReportSubCatWiseStockHeader"
              :items="uniformReportSubCatWiseStock"
              title="Sub Category Wise Stock Report"
              :landscape="true"
              ></v-download-as>
            </v-flex>
          </v-card-title>
          <v-card-text class="pa-2">
            <v-data-table
            :headers="uniformReportSubCatWiseStockHeader"
            :items="uniformReportSubCatWiseStock"
            hide-default-footer
            hide-default-header
            class="elevation-3"
            :mobile-breakpoint="0"
            disable-pagination
            fixed-header
            dense
            :search="searchSubCatWiseStockReport"
            height="650px"
            >
            <template v-slot:header="{ props: { headers } }">
              <thead>
                <tr>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 50px; text-align: center">{{headers[0].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 200px; text-align: left">{{headers[1].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 150px; text-align: center">{{headers[2].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 120px; text-align: center">{{headers[3].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 120px; text-align: center">{{headers[4].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 120px; text-align: center">{{headers[5].text}}</th>
                </tr>
              </thead>
            </template>
            <template slot="item" slot-scope="props">
              <tr v-if="!props.item.sno && props.item.uniform_size === 'Sub-Total'" :style="!props.item.sno ? 'color:#00000; background-color: #D5D8D0' : 'border-bottom:1px solid black;'">
                <td style="text-align:center; font-size: 13px"> <strong>{{ props.item.sno ? props.item.sno : ' ' }}</strong> </td>
                <td style="text-align:left; font-size: 13px"> <strong>{{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : ' ' }}</strong> </td>
                <td style="text-align:center; font-size: 13px"> <strong>{{ props.item.uniform_size ? props.item.uniform_size : '-' }}</strong> </td>
                <td style="text-align:center; font-size: 13px"> <strong>{{ props.item.inward_qty ? handy.formatNum(props.item.inward_qty) : '-' }}</strong> </td>
                <td style="text-align:center; font-size: 13px"> <strong>{{ props.item.outward_qty ? handy.formatNum(props.item.outward_qty) : '-' }}</strong> </td>
                <td style="text-align:center; font-size: 13px"> <strong>{{ props.item.stock_qty ? handy.formatNum(props.item.stock_qty) : '-' }}</strong> </td>
              </tr>
              <tr v-else-if="!props.item.sno && props.item.uniform_size === 'Grand-Total'" :style="!props.item.sno ? 'color:#0000FF; background-color: #A2A1A3' : 'border-bottom:1px solid black;'">
                <td style="text-align:center; font-size: 14px"> <strong>{{ props.item.sno ? props.item.sno : ' ' }}</strong> </td>
                <td style="text-align:left; font-size: 14px"> <strong>{{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : ' ' }}</strong> </td>
                <td style="text-align:center; font-size: 14px"> <strong>{{ props.item.uniform_size ? props.item.uniform_size : '-' }}</strong> </td>
                <td style="text-align:center; font-size: 14px"> <strong>{{ props.item.inward_qty ? handy.formatNum(props.item.inward_qty) : '-' }}</strong> </td>
                <td style="text-align:center; font-size: 14px"> <strong>{{ props.item.outward_qty ? handy.formatNum(props.item.outward_qty) : '-' }}</strong> </td>
                <td style="text-align:center; font-size: 14px"> <strong>{{ props.item.stock_qty ? handy.formatNum(props.item.stock_qty) : '-' }}</strong> </td>
              </tr>
              <tr v-else>
                <td style="text-align:center; font-size: 12px"> {{ props.item.sno ? props.item.sno : '-' }} </td>
                <td style="text-align:left; font-size: 12px"> {{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : '-' }} </td>
                <td style="text-align:center; font-size: 12px"> {{ props.item.uniform_size ? props.item.uniform_size : '-' }} </td>
                <td style="text-align:center; font-size: 12px"> {{ props.item.inward_qty ? handy.formatNum(props.item.inward_qty) : '-' }} </td>
                <td style="text-align:center; font-size: 12px"> {{ props.item.outward_qty ? handy.formatNum(props.item.outward_qty) : '-' }} </td>
                <td style="text-align:center; font-size: 12px"> {{ props.item.stock_qty ? handy.formatNum(props.item.stock_qty) : '-' }} </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-flex>
</v-layout>
</v-container>

<!-- Employee Wise Distribution Report -->
<v-layout row wrap v-if="lAction === 'empwise-distribreport'">
  <v-flex xs12 mx-auto>
    <v-flex xs12>
      <v-card flat>
        <v-card-title class="title pt-2 pl-0 pb-2">
          <v-btn icon class="ma-0" @click="lAction = prevScr || 'view'"><v-icon>mdi-chevron-left</v-icon></v-btn>
          Employee Wise Distribution Report
          <v-spacer></v-spacer>
          <v-text-field
          v-model="searchEmpWiseDistributionReport"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          clearable
          hide-details
          class="mt-0 pt-0"
          ></v-text-field>
          <v-flex xs3>
            <v-download-as
            :headers="uniformReportEmployeeWiseDistributionHeader"
            :items="uniformReportEmployeeWiseDistribution"
            title="Employee Wise Distribution Report"
            :landscape="true"
            ></v-download-as>
          </v-flex>
        </v-card-title>
        <v-card-text class="pl-2 pr-2">
          <v-flex xs12 style="border: 1px solid grey; border-radius:7px" class="pb-4">
            <v-layout row wrap>
              <v-flex xs3 class="pt-4">
                <v-combobox
                v-model="lUniformEmpWiseDistributionReport.proj_id_pair"
                :items="uniformAllProjects"
                label="Project Name"
                item-text="proj_name"
                item-value="proj_id"
                hide-details
                return-object
                clearable
                dense
                ></v-combobox>
              </v-flex>
              <v-flex xs3 class="pt-4">
                <v-combobox
                v-model="lUniformEmpWiseDistributionReport.emp_id_pair"
                :items="uniformAllEmployees"
                label="Employee Name"
                item-text="emp_name_with_id"
                item-value="emp_id"
                hide-details
                return-object
                clearable
                dense
                ></v-combobox>
              </v-flex>
              <v-flex xs2>
                <v-dialog ref="dlgDate_from_empwiserpt"
                persistent v-model="dlgDate_from_empwiserpt"
                max-width="290px"
                :return-value.sync="lUniformEmpWiseDistributionReport.from_date">
                <template v-slot:activator="{ on }">
                  <v-text-field
                  slot="activator" label="From Date"
                  v-model="lUniformEmpWiseDistributionReport.from_date" append-icon="mdi-calendar-today"
                  readonly clearable
                  v-on="on"
                  hide-details
                  ></v-text-field>
                </template>
                <v-date-picker v-model="lUniformEmpWiseDistributionReport.from_date"
                first-day-of-week="1">
                <v-spacer></v-spacer>
                <v-btn text @click="dlgDate_from_empwiserpt = false">Cancel</v-btn>
                <v-btn text color="accent" @click="$refs.dlgDate_from_empwiserpt.save(lUniformEmpWiseDistributionReport.from_date)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs2>
            <v-dialog ref="dlgDate_to_empwiserpt"
            persistent v-model="dlgDate_to_empwiserpt"
            max-width="290px"
            :return-value.sync="lUniformEmpWiseDistributionReport.to_date">
            <template v-slot:activator="{ on }">
              <v-text-field
              slot="activator" label="To Date"
              v-model="lUniformEmpWiseDistributionReport.to_date" append-icon="mdi-calendar-today"
              readonly clearable
              v-on="on"
              hide-details
              ></v-text-field>
            </template>
            <v-date-picker v-model="lUniformEmpWiseDistributionReport.to_date"
            first-day-of-week="1">
            <v-spacer></v-spacer>
            <v-btn text @click="dlgDate_to_empwiserpt = false">Cancel</v-btn>
            <v-btn text color="accent" @click="$refs.dlgDate_to_empwiserpt.save(lUniformEmpWiseDistributionReport.to_date)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
      <v-flex xs2 class="pt-4 pl-2">
        <v-btn fab small color="accent" @click="loadEmpWiseDistributionReport(lUniformEmpWiseDistributionReport)">Go</v-btn>
        <v-chip small class="ml-2 font-weight-bold" :color="empwisedistrichipselection === 'All' ? 'success white--text': 'uniformchipinfo white--text'" @click="loadUniformEmpWiseDistributionChipFilter('All')">All</v-chip>
        <v-chip small class="ml-1 font-weight-bold" :color="empwisedistrichipselection === 'Left' ? 'success white--text': 'uniformchipinfo white--text'" @click="loadUniformEmpWiseDistributionChipFilter('Left')">Left</v-chip>
        <v-chip small class="ml-1 font-weight-bold" :color="empwisedistrichipselection === 'On-Job' ? 'success white--text': 'uniformchipinfo white--text'" @click="loadUniformEmpWiseDistributionChipFilter('On-Job')">On-Job</v-chip>
      </v-flex>
    </v-layout>
  </v-flex>
  <v-flex>
    <v-data-table
    :headers="uniformReportEmployeeWiseDistributionHeader"
    :items="empwisedistrichipselection === 'All' ? uniformReportEmployeeWiseDistribution : uniformReportEmployeeWiseDistribution.filter(rec => rec.filter_status === empwisedistrichipselection)"
    hide-default-header
    hide-default-footer
    class="elevation-3"
    :mobile-breakpoint="0"
    disable-pagination
    fixed-header
    dense
    :search="searchEmpWiseDistributionReport"
    height="550px"
    >
    <template v-slot:header="{ props: { headers } }">
      <thead>
        <tr>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 250px; text-align: left">{{headers[0].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 200px; text-align: left">{{headers[1].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 150px; text-align: left">{{headers[2].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 170px; text-align: left">{{headers[3].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[4].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: center">{{headers[5].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 110px; text-align: right">{{headers[6].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 110px; text-align: right">{{headers[7].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 110px; text-align: right">{{headers[8].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[9].text}}</th>
        </tr>
      </thead>
    </template>
    <template slot="item" slot-scope="props">
      <tr>
        <td style="text-align:left; font-size: 12px"> {{ props.item.proj_name ? props.item.proj_name : '-' }} </td>
        <td style="text-align:left; font-size: 12px"> {{ props.item.emp_name_with_id ? props.item.emp_name_with_id : '-' }} </td>
        <td style="text-align:left; font-size: 12px"> {{ props.item.uniform_cat ? props.item.uniform_cat : '-' }} </td>
        <td style="text-align:left; font-size: 12px"> {{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : '-' }} </td>
        <td style="text-align:center; font-size: 12px"> {{ props.item.uniform_size ? props.item.uniform_size : '-' }} </td>
        <td style="text-align:center; font-size: 12px"> {{ props.item.outward_qty ? props.item.outward_qty : '-' }} </td>
        <td style="text-align:right; font-size: 12px"> {{ props.item.amount ? handy.formatCur(props.item.amount) : '-' }} </td>
        <td style="text-align:right; font-size: 12px"> {{ props.item.tax_amount ? handy.formatCur(props.item.tax_amount) : '-' }} </td>
        <td style="text-align:right; font-size: 12px"> {{ props.item.tot_amount ? handy.formatCur(props.item.tot_amount) : '-' }} </td>
        <td style="text-align:center; font-size: 12px"> {{ props.item.filter_status? props.item.filter_status: '-'}} </td>
      </tr>
    </template>
  </v-data-table>
</v-flex>
</v-card-text>
</v-card>
</v-flex>
</v-flex>
</v-layout>

<!-- Bulk Distribution & Employee Mapping Comparison Report -->
<v-layout row wrap v-if="lAction === 'bulk-distrib-empmap-compare-rpt'">
  <v-flex xs12 mx-auto>
    <v-flex xs12>
      <v-card flat>
        <v-card-title class="title pt-2 pl-0 pb-2">
          <v-btn icon class="ma-0" @click="lAction = prevScr || 'view'"><v-icon>mdi-chevron-left</v-icon></v-btn>
          Bulk Distribution Employee Mapping Comparison Report
          <v-spacer></v-spacer>
          <v-text-field
          v-model="searchBulkDistribEmpMapComparRpt"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          clearable
          hide-details
          class="mt-0 pt-0"
          ></v-text-field>
          <v-flex xs3>
            <v-download-as
            :headers="uniformBulkDistribMapCompReportHeader"
            :items="uniformBulkDistribMapCompReport"
            title="Bulk Distribution Emp Mapping Comparison Report"
            :landscape="true"
            ></v-download-as>
          </v-flex>
        </v-card-title>
        <v-card-text class="pl-2 pr-2">
          <v-flex xs12 style="border: 1px solid grey; border-radius:7px" class="pb-4">
            <v-layout row wrap>
              <v-flex xs6 class="pt-4">
                <v-combobox
                v-model="lUniformBulkDistribMapCompReport.proj_id_pair"
                :items="uniformAllProjects"
                label="Project Name"
                item-text="proj_name"
                item-value="proj_id"
                hide-details
                return-object
                clearable
                dense
                ></v-combobox>
              </v-flex>
              <v-flex xs2>
                <v-dialog ref="dlgDate_from_bulkempmapcomprpt"
                persistent v-model="dlgDate_from_bulkempmapcomprpt"
                max-width="290px"
                :return-value.sync="lUniformBulkDistribMapCompReport.from_date">
                <template v-slot:activator="{ on }">
                  <v-text-field
                  slot="activator" label="From Date"
                  v-model="lUniformBulkDistribMapCompReport.from_date" append-icon="mdi-calendar-today"
                  readonly clearable
                  v-on="on"
                  hide-details
                  ></v-text-field>
                </template>
                <v-date-picker v-model="lUniformBulkDistribMapCompReport.from_date"
                first-day-of-week="1">
                <v-spacer></v-spacer>
                <v-btn text @click="dlgDate_from_bulkempmapcomprpt = false">Cancel</v-btn>
                <v-btn text color="accent" @click="$refs.dlgDate_from_bulkempmapcomprpt.save(lUniformBulkDistribMapCompReport.from_date)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs2>
            <v-dialog ref="dlgDate_to_bulkempmapcomprpt"
            persistent v-model="dlgDate_to_bulkempmapcomprpt"
            max-width="290px"
            :return-value.sync="lUniformBulkDistribMapCompReport.to_date">
            <template v-slot:activator="{ on }">
              <v-text-field
              slot="activator" label="To Date"
              v-model="lUniformBulkDistribMapCompReport.to_date" append-icon="mdi-calendar-today"
              readonly clearable
              v-on="on"
              hide-details
              ></v-text-field>
            </template>
            <v-date-picker v-model="lUniformBulkDistribMapCompReport.to_date"
            first-day-of-week="1">
            <v-spacer></v-spacer>
            <v-btn text @click="dlgDate_to_bulkempmapcomprpt = false">Cancel</v-btn>
            <v-btn text color="accent" @click="$refs.dlgDate_to_bulkempmapcomprpt.save(lUniformBulkDistribMapCompReport.to_date)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
      <v-flex xs2 class="pt-4 pl-2">
        <v-btn fab small color="accent" @click="loadUniformBulkDistribMappingComparisonReport(lUniformBulkDistribMapCompReport)">Go</v-btn>
      </v-flex>
    </v-layout>
  </v-flex>
  <v-flex>
    <v-data-table
    :headers="uniformBulkDistribMapCompReportHeader"
    :items="uniformBulkDistribMapCompReport"
    hide-default-header
    hide-default-footer
    class="elevation-3"
    :mobile-breakpoint="0"
    disable-pagination
    fixed-header
    dense
    :search="searchBulkDistribEmpMapComparRpt"
    height="550px"
    >
    <template v-slot:header="{ props: { headers } }">
      <thead>
        <tr>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[0].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 250px; text-align: left">{{headers[1].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 150px; text-align: left">{{headers[2].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[3].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[4].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[5].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[6].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[7].text}}</th>
        </tr>
      </thead>
    </template>
    <template slot="item" slot-scope="props">
      <tr>
        <td style="text-align:center; font-size: 12px"> {{ props.item.outward_date ? props.item.outward_date : '-' }} </td>
        <td style="text-align:left; font-size: 12px"> {{ props.item.proj_name ? props.item.proj_name : '-' }} </td>
        <td style="text-align:left; font-size: 12px"> {{ props.item.emp_name_or_taken_by ? props.item.emp_name_or_taken_by : '-' }} </td>
        <td style="text-align:center; font-size: 12px"> {{ props.item.outward_qty ? props.item.outward_qty : '-' }} </td>
        <td style="text-align:center; font-size: 12px"> {{ props.item.bulk_pending_qty ? props.item.bulk_pending_qty : '-' }} </td>
        <td style="text-align:center; font-size: 12px"> {{ props.item.allocated_qty ? props.item.allocated_qty : '-' }} </td>
        <td style="text-align:center; font-size: 12px"> {{ props.item.mapped_qty ? props.item.mapped_qty : '-' }} </td>
        <td style="text-align:center; font-size: 12px"> {{ props.item.result ? props.item.result : '-' }} </td>
      </tr>
    </template>
  </v-data-table>
</v-flex>
</v-card-text>
</v-card>
</v-flex>
</v-flex>
</v-layout>

<!-- Purchase History Summary -->
<v-layout row wrap v-if="lAction === 'purchase-history-summary'">
  <v-flex xs12 mx-auto>
    <v-flex xs12>
      <v-card flat>
        <v-card-title class="title pt-2 pl-0 pb-2">
          <v-btn icon class="ma-0" @click="lAction = prevScr || 'view'"><v-icon>mdi-chevron-left</v-icon></v-btn>
          Purchase History Summary
          <v-spacer></v-spacer>
          <v-flex xs3>
            <v-download-as
            :headers="uniformPurchaseHistorySummaryHeader"
            :items="uniformPurchaseHistorySummary"
            title="Purchase History Summary"
            :landscape="true"
            ></v-download-as>
          </v-flex>
        </v-card-title>
        <v-card-text class="pl-2 pr-2">
          <v-flex xs12 style="border: 1px solid grey; border-radius:7px" class="pb-4">
            <v-layout row wrap>
              <v-flex xs3>
                <v-dialog ref="dlgDate_from_purhistorysummary"
                persistent v-model="dlgDate_from_purhistorysummary"
                max-width="290px"
                :return-value.sync="lUniformPurchaseHistorySummary.from_date">
                <template v-slot:activator="{ on }">
                  <v-text-field
                  slot="activator" label="From Date"
                  v-model="lUniformPurchaseHistorySummary.from_date" append-icon="mdi-calendar-today"
                  readonly clearable
                  v-on="on"
                  hide-details
                  ></v-text-field>
                </template>
                <v-date-picker v-model="lUniformPurchaseHistorySummary.from_date"
                first-day-of-week="1">
                <v-spacer></v-spacer>
                <v-btn text @click="dlgDate_from_purhistorysummary = false">Cancel</v-btn>
                <v-btn text color="accent" @click="$refs.dlgDate_from_purhistorysummary.save(lUniformPurchaseHistorySummary.from_date)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs3>
            <v-dialog ref="dlgDate_to_purhistorysummary"
            persistent v-model="dlgDate_to_purhistorysummary"
            max-width="290px"
            :return-value.sync="lUniformPurchaseHistorySummary.to_date">
            <template v-slot:activator="{ on }">
              <v-text-field
              slot="activator" label="To Date"
              v-model="lUniformPurchaseHistorySummary.to_date" append-icon="mdi-calendar-today"
              readonly clearable
              v-on="on"
              hide-details
              ></v-text-field>
            </template>
            <v-date-picker v-model="lUniformPurchaseHistorySummary.to_date"
            first-day-of-week="1">
            <v-spacer></v-spacer>
            <v-btn text @click="dlgDate_to_purhistorysummary = false">Cancel</v-btn>
            <v-btn text color="accent" @click="$refs.dlgDate_to_purhistorysummary.save(lUniformPurchaseHistorySummary.to_date)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
      <v-flex xs1 class="pt-4 pl-2">
        <v-btn fab small color="accent" @click="loadUniformPurchaseHistorySummary(lUniformPurchaseHistorySummary)">Go</v-btn>
      </v-flex>
      <v-flex xs5 class="pt-4">
        <v-text-field
        v-model="searchUniformPurchaseHistorySummary"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        clearable
        hide-details
        class="mt-0 pt-0"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </v-flex>
  <v-flex>
    <v-data-table
    :headers="uniformPurchaseHistorySummaryHeader"
    :items="uniformPurchaseHistorySummary"
    hide-default-header
    hide-default-footer
    class="elevation-3"
    :mobile-breakpoint="0"
    disable-pagination
    fixed-header
    dense
    :search="searchUniformPurchaseHistorySummary"
    height="550px"
    >
    <template v-slot:header="{ props: { headers } }">
      <thead>
        <tr>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 50px; text-align: center">{{headers[0].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 120px; text-align: center">{{headers[1].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 250px; text-align: left">{{headers[2].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 120px; text-align: center">{{headers[3].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[4].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: right">{{headers[5].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: right">{{headers[6].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: right">{{headers[7].text}}</th>
        </tr>
      </thead>
    </template>
    <template slot="item" slot-scope="props">
      <tr v-if="!props.item.sno && props.item.uniform_size === 'Sub-Total'" :style="!props.item.sno ? 'color:#00000; background-color: #D5D8D0' : 'border-bottom:1px solid black;'">
        <td style="text-align:center; font-size: 13px"> <strong>{{ props.item.sno ? props.item.sno : ' ' }} </strong></td>
        <td style="text-align:center; font-size: 13px"> <strong>{{ props.item.invoice_date ? handy.formatDate(props.item.invoice_date) : ' ' }} </strong></td>
        <td style="text-align:left; font-size: 13px"> <strong>{{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : ' ' }} </strong></td>
        <td style="text-align:center; font-size: 13px"> <strong>{{ props.item.uniform_size ? props.item.uniform_size : ' ' }} </strong></td>
        <td style="text-align:center; font-size: 13px"> <strong>{{ props.item.pur_qty ? props.item.pur_qty : '-' }} </strong></td>
        <td style="text-align:right; font-size: 13px"> <strong>{{ props.item.amount_bf_tax ? handy.formatCur(props.item.amount_bf_tax) : '-' }} </strong></td>
        <td style="text-align:right; font-size: 13px"> <strong>{{ props.item.tax_amount ? handy.formatCur(props.item.tax_amount) : '-' }} </strong></td>
        <td style="text-align:right; font-size: 13px"> <strong>{{ props.item.amount_af_tax ? handy.formatCur(props.item.amount_af_tax) : '-' }} </strong></td>
      </tr>
      <tr v-else-if="!props.item.sno && props.item.uniform_size === 'Grand-Total'" :style="!props.item.sno ? 'color:#0000FF; background-color: #A2A1A3' : 'border-bottom:1px solid black;'">
        <td style="text-align:center; font-size: 14px"> <strong>{{ props.item.sno ? props.item.sno : ' ' }} </strong></td>
        <td style="text-align:center; font-size: 14px"> <strong>{{ props.item.invoice_date ? handy.formatDate(props.item.invoice_date) : ' ' }} </strong></td>
        <td style="text-align:left; font-size: 14px"> <strong>{{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : ' ' }} </strong></td>
        <td style="text-align:center; font-size: 14px"> <strong>{{ props.item.uniform_size ? props.item.uniform_size : ' ' }} </strong></td>
        <td style="text-align:center; font-size: 14px"> <strong>{{ props.item.pur_qty ? props.item.pur_qty : '-' }} </strong></td>
        <td style="text-align:right; font-size: 14px"> <strong>{{ props.item.amount_bf_tax ? handy.formatCur(props.item.amount_bf_tax) : '-' }} </strong></td>
        <td style="text-align:right; font-size: 14px"> <strong>{{ props.item.tax_amount ? handy.formatCur(props.item.tax_amount) : '-' }} </strong></td>
        <td style="text-align:right; font-size: 14px"> <strong>{{ props.item.amount_af_tax ? handy.formatCur(props.item.amount_af_tax) : '-' }} </strong></td>
      </tr>
      <tr v-else>
        <td style="text-align:center; font-size: 12px"> {{ props.item.sno ? props.item.sno : '-' }} </td>
        <td style="text-align:center; font-size: 12px"> {{ props.item.invoice_date ? handy.formatDate(props.item.invoice_date) : '-' }} </td>
        <td style="text-align:left; font-size: 12px"> {{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : '-' }} </td>
        <td style="text-align:center; font-size: 12px"> {{ props.item.uniform_size ? props.item.uniform_size : '-' }} </td>
        <td style="text-align:center; font-size: 12px"> {{ props.item.pur_qty ? props.item.pur_qty : '-' }} </td>
        <td style="text-align:right; font-size: 12px"> {{ props.item.amount_bf_tax ? handy.formatCur(props.item.amount_bf_tax) : '-' }} </td>
        <td style="text-align:right; font-size: 12px"> {{ props.item.tax_amount ? handy.formatCur(props.item.tax_amount) : '-' }} </td>
        <td style="text-align:right; font-size: 12px"> {{ props.item.amount_af_tax ? handy.formatCur(props.item.amount_af_tax) : '-' }} </td>
      </tr>
    </template>
  </v-data-table>
</v-flex>
</v-card-text>
</v-card>
</v-flex>
</v-flex>
</v-layout>

<!-- Stock Sequence Report -->
<v-container class="pa-0" v-if="lAction === 'stocksequence-stockreport'" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12 mx-auto>
      <v-flex xs12>
        <v-card flat>
          <v-card-title class="title pt-2 pl-0 pb-2">
            <v-btn icon class="ma-0" @click="lAction = prevScr || 'view'"><v-icon>mdi-chevron-left</v-icon></v-btn>
            Stock Sequence Wise Report
            <v-spacer></v-spacer>
            <v-text-field
            v-model="searchStockSequenceWiseReport"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            clearable
            hide-details
            class="mt-0 pt-0"
            ></v-text-field>
            <v-flex xs3>
              <v-download-as
              :headers="uniformStockSequenceWiseReportHeader"
              :items="uniformStockSequenceWiseReport"
              title="Stock Sequence Wise Report"
              :landscape="true"
              ></v-download-as>
            </v-flex>
          </v-card-title>
          <v-card-text class="pa-2">
            <v-data-table
            :headers="uniformStockSequenceWiseReportHeader"
            :items="uniformStockSequenceWiseReport"
            hide-default-header
            hide-default-footer
            class="elevation-3"
            :mobile-breakpoint="0"
            disable-pagination
            dense
            fixed-header
            :search="searchStockSequenceWiseReport"
            height="650px"
            >
            <template v-slot:header="{ props: { headers } }">
              <thead>
                <tr>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 50px; text-align: left">{{headers[0].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 200px; text-align: left">{{headers[1].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 150px; text-align: center">{{headers[2].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[3].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 120px; text-align: right">{{headers[4].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 120px; text-align: center">{{headers[5].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 120px; text-align: center">{{headers[6].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 120px; text-align: center">{{headers[7].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 120px; text-align: center">{{headers[8].text}}</th>
                </tr>
              </thead>
            </template>
            <template slot="item" slot-scope="props">
              <tr v-if="!props.item.sno && props.item.unit_rate === 'Sub-Total'" :style="!props.item.sno ? 'color:#00000; background-color: #D5D8D0' : 'border-bottom:1px solid black;'">
                <td style="text-align:center; font-size: 13px"> <strong>{{ props.item.sno ? props.item.sno : '' }}</strong> </td>
                <td style="text-align:left; font-size: 13px"> <strong>{{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : '' }}</strong> </td>
                <td style="text-align:center; font-size: 13px"> <strong>{{ props.item.uniform_size ? props.item.uniform_size : '' }}</strong> </td>
                <td style="text-align:center; font-size: 13px"> <strong>{{ props.item.unit ? props.item.unit : '' }}</strong> </td>
                <td style="text-align:right; font-size: 13px"> <strong>{{ props.item.unit_rate ? handy.formatCur(props.item.unit_rate) : '-' }}</strong> </td>
                <td style="text-align:center; font-size: 13px"> <strong>{{ props.item.tax_percent ? props.item.tax_percent + ' %' : '' }}</strong> </td>
                <td style="text-align:center; font-size: 13px"> <strong>{{ props.item.inward_qty ? handy.formatNum(props.item.inward_qty) : '-' }}</strong> </td>
                <td style="text-align:center; font-size: 13px"> <strong>{{ props.item.outward_qty ? handy.formatNum(props.item.outward_qty) : '-' }}</strong> </td>
                <td style="text-align:center; font-size: 13px"> <strong>{{ props.item.stock_qty ? handy.formatNum(props.item.stock_qty) : '-' }}</strong> </td>
              </tr>
              <tr v-else-if="!props.item.sno && props.item.unit_rate === 'Grand-Total'" :style="!props.item.sno ? 'color:#0000FF; background-color: #A2A1A3' : 'border-bottom:1px solid black;'">
                <td style="text-align:center; font-size: 14px"> <strong>{{ props.item.sno ? props.item.sno : '' }}</strong> </td>
                <td style="text-align:left; font-size: 14px"> <strong>{{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : '' }}</strong> </td>
                <td style="text-align:center; font-size: 14px"> <strong>{{ props.item.uniform_size ? props.item.uniform_size : '' }}</strong> </td>
                <td style="text-align:center; font-size: 14px"> <strong>{{ props.item.unit ? props.item.unit : '' }}</strong> </td>
                <td style="text-align:right; font-size: 14px"> <strong>{{ props.item.unit_rate ? handy.formatCur(props.item.unit_rate) : '-' }}</strong> </td>
                <td style="text-align:center; font-size: 14px"> <strong>{{ props.item.tax_percent ? props.item.tax_percent + ' %' : '' }}</strong> </td>
                <td style="text-align:center; font-size: 14px"> <strong>{{ props.item.inward_qty ? handy.formatNum(props.item.inward_qty) : '-' }}</strong> </td>
                <td style="text-align:center; font-size: 14px"> <strong>{{ props.item.outward_qty ? handy.formatNum(props.item.outward_qty) : '-' }}</strong> </td>
                <td style="text-align:center; font-size: 14px"> <strong>{{ props.item.stock_qty ? handy.formatNum(props.item.stock_qty) : '-' }}</strong> </td>
              </tr>
              <tr v-else>
                <td style="text-align:center; font-size: 12px"> {{ props.item.sno ? props.item.sno : '-' }} </td>
                <td style="text-align:left; font-size: 12px"> {{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : '-' }} </td>
                <td style="text-align:center; font-size: 12px"> {{ props.item.uniform_size ? props.item.uniform_size : '-' }} </td>
                <td style="text-align:center; font-size: 12px"> {{ props.item.unit ? props.item.unit : '-' }} </td>
                <td style="text-align:right; font-size: 12px"> {{ props.item.unit_rate ? handy.formatCur(props.item.unit_rate) : '-' }} </td>
                <td style="text-align:center; font-size: 12px"> {{ props.item.tax_percent ? props.item.tax_percent + ' %' : '-' }} </td>
                <td style="text-align:center; font-size: 12px"> {{ props.item.inward_qty ? handy.formatNum(props.item.inward_qty) : '-' }} </td>
                <td style="text-align:center; font-size: 12px"> {{ props.item.outward_qty ? handy.formatNum(props.item.outward_qty) : '-' }} </td>
                <td style="text-align:center; font-size: 12px"> {{ props.item.stock_qty ? handy.formatNum(props.item.stock_qty) : '-' }} </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-flex>
</v-layout>
</v-container>

<!-- Stock Value Report -->
<v-container class="pa-0" v-if="lAction === 'stock-value-report'" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12 mx-auto>
      <v-flex xs12>
        <v-card flat>
          <v-card-title class="title pt-2 pl-0 pb-2">
            <v-btn icon class="ma-0" @click="lAction = prevScr || 'view'"><v-icon>mdi-chevron-left</v-icon></v-btn>
            Stock Value Report
            <v-spacer></v-spacer>
            <v-text-field
            v-model="searchStockValueReport"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            clearable
            hide-details
            class="mt-0 pt-0"
            ></v-text-field>
            <v-flex xs3>
              <v-download-as
              :headers="uniformStockValueReportHeader"
              :items="uniformStockValueReport"
              title="Stock Value Report"
              :landscape="true"
              ></v-download-as>
            </v-flex>
          </v-card-title>
          <v-card-text class="pa-2">
            <v-data-table
            :headers="uniformStockValueReportHeader"
            :items="uniformStockValueReport"
            hide-default-header
            hide-default-footer
            class="elevation-3"
            :mobile-breakpoint="0"
            disable-pagination
            dense
            fixed-header
            :search="searchStockValueReport"
            height="650px"
            >
            <template v-slot:header="{ props: { headers } }">
              <thead>
                <tr>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 50px; text-align: left">{{headers[0].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 200px; text-align: left">{{headers[1].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 150px; text-align: left">{{headers[2].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: left">{{headers[3].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 120px; text-align: left">{{headers[4].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 120px; text-align: center">{{headers[5].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 120px; text-align: right">{{headers[6].text}}</th>
                </tr>
              </thead>
            </template>
            <template slot="item" slot-scope="props">
              <tr v-if="!props.item.sno && props.item.uniform_size === 'Sub-Total'" :style="!props.item.sno ? 'color:#00000; background-color: #D5D8D0' : 'border-bottom:1px solid black;'">
                <td style="text-align:center; font-size: 13px"> <strong>{{ props.item.sno ? props.item.sno : '' }}</strong> </td>
                <td style="text-align:left; font-size: 13px"> <strong>{{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : '' }}</strong> </td>
                <td style="text-align:left; font-size: 13px"> <strong>{{ props.item.uniform_size ? props.item.uniform_size : '' }}</strong> </td>
                <td style="text-align:center; font-size: 13px"> <strong>{{ props.item.inward_qty ? handy.formatNum(props.item.inward_qty) : '-' }}</strong> </td>
                <td style="text-align:center; font-size: 13px"> <strong>{{ props.item.outward_qty ? handy.formatNum(props.item.outward_qty) : '-' }}</strong> </td>
                <td style="text-align:center; font-size: 13px"> <strong>{{ props.item.stock_qty ? handy.formatNum(props.item.stock_qty) : '-' }}</strong> </td>
                <td style="text-align:right; font-size: 13px"> <strong>{{ props.item.stock_value ? handy.formatCur(props.item.stock_value) : '-' }}</strong> </td>
              </tr>
              <tr v-else-if="!props.item.sno && props.item.uniform_size === 'Grand-Total'" :style="!props.item.sno ? 'color:#0000FF; background-color: #A2A1A3' : 'border-bottom:1px solid black;'">
                <td style="text-align:center; font-size: 14px"> <strong>{{ props.item.sno ? props.item.sno : '' }}</strong> </td>
                <td style="text-align:left; font-size: 14px"> <strong>{{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : '' }}</strong> </td>
                <td style="text-align:left; font-size: 14px"> <strong>{{ props.item.uniform_size ? props.item.uniform_size : '' }}</strong> </td>
                <td style="text-align:center; font-size: 14px"> <strong>{{ props.item.inward_qty ? handy.formatNum(props.item.inward_qty) : '-' }}</strong> </td>
                <td style="text-align:center; font-size: 14px"> <strong>{{ props.item.outward_qty ? handy.formatNum(props.item.outward_qty) : '-' }}</strong> </td>
                <td style="text-align:center; font-size: 14px"> <strong>{{ props.item.stock_qty ? handy.formatNum(props.item.stock_qty) : '-' }}</strong> </td>
                <td style="text-align:right; font-size: 14px"> <strong>{{ props.item.stock_value ? handy.formatCur(props.item.stock_value) : '-' }}</strong> </td>
              </tr>
              <tr v-else>
                <td style="text-align:center; font-size: 12px"> {{ props.item.sno ? props.item.sno : '-' }} </td>
                <td style="text-align:left; font-size: 12px"> {{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : '-' }} </td>
                <td style="text-align:left; font-size: 12px"> {{ props.item.uniform_size ? props.item.uniform_size : '-' }} </td>
                <td style="text-align:center; font-size: 12px"> {{ props.item.inward_qty ? handy.formatNum(props.item.inward_qty) : '-' }} </td>
                <td style="text-align:center; font-size: 12px"> {{ props.item.outward_qty ? handy.formatNum(props.item.outward_qty) : '-' }} </td>
                <td style="text-align:center; font-size: 12px"> {{ props.item.stock_qty ? handy.formatNum(props.item.stock_qty) : '-' }} </td>
                <td style="text-align:right; font-size: 12px"> {{ props.item.stock_value ? handy.formatCur(props.item.stock_value) : '-' }} </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-flex>
</v-layout>
</v-container>

<v-container class="pa-0" v-if="lAction === 'stocksequence-tabledata-temp'" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12 mx-auto>
      <v-flex xs12>
        <v-card flat>
          <v-card-title class="title pt-2 pl-0 pb-2">
            <v-btn icon class="ma-0" @click="lAction = prevScr || 'view'"><v-icon>mdi-chevron-left</v-icon></v-btn>
            Stock Sequence Table Data
            <v-spacer></v-spacer>
            <v-text-field
            v-model="searchStockSequenceTableData"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            clearable
            hide-details
            class="mt-0 pt-0"
            ></v-text-field>
            <v-flex xs3>
              <v-download-as
              :headers="uniformStockSequenceTableReportHeader"
              :items="uniformStockSequenceTableReport"
              title="Stock Sequence Table Data"
              :landscape="true"
              ></v-download-as>
            </v-flex>
          </v-card-title>
          <v-card-text class="pa-2">
            <v-data-table
            :headers="uniformStockSequenceTableReportHeader"
            :items="uniformStockSequenceTableReport"
            hide-default-header
            hide-default-footer
            class="elevation-3"
            :mobile-breakpoint="0"
            disable-pagination
            fixed-header
            dense
            :search="searchStockSequenceTableData"
            height="650px"
            >
            <template v-slot:header="{ props: { headers } }">
              <thead>
                <tr>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 50px; text-align: center">{{headers[0].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 300px; text-align: left">{{headers[1].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 150px; text-align: center">{{headers[2].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 150px; text-align: center">{{headers[3].text}}</th>
                </tr>
              </thead>
            </template>
            <template slot="item" slot-scope="props">
              <tr>
                <td style="text-align:center; font-size: 12px"> {{ props.item.sno ? props.item.sno : '-' }} </td>
                <td style="text-align:left; font-size: 12px"> {{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : '-' }} </td>
                <td style="text-align:center; font-size: 12px"> {{ props.item.uniform_size ? props.item.uniform_size : '-' }} </td>
                <td style="text-align:center; font-size: 12px"> {{ props.item.cur_stock ? props.item.cur_stock : '-' }} </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-flex>
</v-layout>
</v-container>

<!-- Stock Sequence Audit Log -->
<v-container class="pa-0" v-if="lAction === 'stocksequence-auditlog'" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12 mx-auto>
      <v-flex xs12>
        <v-card flat>
          <v-card-title class="title pt-2 pl-0 pb-2">
            <v-btn icon class="ma-0" @click="lAction = prevScr || 'view'"><v-icon>mdi-chevron-left</v-icon></v-btn>
            Stock Sequence Audit Log
            <v-spacer></v-spacer>
            <v-text-field
            v-model="searchStocksequenceAuditlog"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            clearable
            hide-details
            ></v-text-field>
          </v-card-title>
          <v-card-text class="pa-2">
            <v-data-table
            :headers="uniformStockSequenceAuditLogHeader"
            :items="uniformStockSequenceAuditLog"
            hide-default-header
            hide-default-footer
            class="elevation-3"
            :mobile-breakpoint="0"
            disable-pagination
            :search="searchStocksequenceAuditlog"
            fixed-header
            dense
            height="550px"
            >
            <template v-slot:header="{ props: { headers } }">
              <thead>
                <tr>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 200px; text-align: left">{{headers[0].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 110px; text-align: left">{{headers[1].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: center">{{headers[2].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: right">{{headers[3].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[4].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[5].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 170px; text-align: center">{{headers[6].text}}</th>
                  <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: center">{{headers[7].text}}</th>
                </tr>
              </thead>
            </template>
            <template slot="item" slot-scope="props">
              <tr>
                <td style="text-align:left; font-size: 12px"> {{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : '-' }} </td>
                <td style="text-align:left; font-size: 12px"> {{ props.item.uniform_size ? props.item.uniform_size : '-' }} </td>
                <td style="text-align:center; font-size: 12px"> {{ props.item.uniform_stock_sequence_id ? props.item.uniform_stock_sequence_id : '-' }} </td>
                <td style="text-align:right; font-size: 12px"> {{ props.item.unit_rate ? handy.formatCur(props.item.unit_rate) : '-' }} </td>
                <td style="text-align:center; font-size: 12px"> {{ props.item.tax_percent ? props.item.tax_percent + ' %' : '-' }} </td>
                <td style="text-align:center; font-size: 12px"> {{ props.item.stock_qty ? props.item.stock_qty : '-' }} </td>
                <td style="text-align:center; font-size: 12px"> {{ props.item.updated_date ? handy.formatDBDateTime(props.item.updated_date) : '-' }} </td>
                <td style="text-align:center; font-size: 12px"> {{ props.item.vendor_id ? props.item.vendor_id : '-' }} </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-flex>
</v-layout>
</v-container>

<!-- Inward Audit Log -->
<v-layout row wrap v-if="lAction === 'inward-auditlog'">
  <v-flex xs12 mx-auto>
    <v-flex xs12>
      <v-card flat>
        <v-card-title class="title pt-2 pl-0 pb-2">
          <v-btn icon class="ma-0" @click="lAction = prevScr || 'view'"><v-icon>mdi-chevron-left</v-icon></v-btn>
          Inward Audit Log
          <v-spacer></v-spacer>
          <v-text-field
          v-model="searchInwardAuditlog"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          clearable
          hide-details
          ></v-text-field>
        </v-card-title>
        <v-card-text class="pa-2">
          <v-data-table
          :headers="uniformInwardAuditLogHeader"
          :items="uniformInwardAuditLog"
          hide-default-header
          hide-default-footer
          class="elevation-3"
          :mobile-breakpoint="0"
          disable-pagination
          :search="searchInwardAuditlog"
          fixed-header
          dense
          height="600px"
          >
          <template v-slot:header="{ props: { headers } }">
            <thead>
              <tr>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[0].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 110px; text-align: center">{{headers[1].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 150px; text-align: left">{{headers[2].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 150px; text-align: left">{{headers[3].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: left">{{headers[4].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 90px; text-align: right">{{headers[5].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: center">{{headers[6].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: center">{{headers[7].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 120px; text-align: center">{{headers[8].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: center">{{headers[9].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: center">{{headers[10].text}}</th>
              </tr>
            </thead>
          </template>
          <template slot="item" slot-scope="props">
            <tr>
              <td style="text-align:center; font-size: 12px"> {{ props.item.invoice_date ? handy.formatDBDate(props.item.invoice_date) : '-' }} </td>
              <td style="text-align:center; font-size: 12px"> {{ props.item.invoice_no ? props.item.invoice_no : '-' }} </td>
              <td style="text-align:left; font-size: 12px"> {{ props.item.vendorsupplier_name ? props.item.vendorsupplier_name : '-' }} </td>
              <td style="text-align:left; font-size: 12px"> {{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : '-' }} </td>
              <td style="text-align:left; font-size: 12px"> {{ props.item.uniform_size ? props.item.uniform_size : '-' }} </td>
              <td style="text-align:right; font-size: 12px"> {{ props.item.unit_rate ? handy.formatCur(props.item.unit_rate) : '-' }} </td>
              <td style="text-align:center; font-size: 12px"> {{ props.item.tax_percent ? props.item.tax_percent + ' %' : '-' }} </td>
              <td style="text-align:center; font-size: 12px"> {{ props.item.log_qty ? props.item.log_qty : '-' }} </td>
              <td style="text-align:center; font-size: 12px"> {{ props.item.log_source ? props.item.log_source : '-' }} </td>
              <td style="text-align:center; font-size: 12px"> {{ props.item.updated_by ? props.item.updated_by : '-' }} </td>
              <td style="text-align:center; font-size: 12px"> {{ props.item.vendor_id ? props.item.vendor_id : '-' }} </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-flex>
</v-flex>
</v-layout>

<!-- Outward Audit Log -->
<v-layout row wrap v-if="lAction === 'outward-auditlog'">
  <v-flex xs12 mx-auto>
    <v-flex xs12>
      <v-card flat>
        <v-card-title class="title pt-2 pl-0 pb-2">
          <v-btn icon class="ma-0" @click="lAction = prevScr || 'view'"><v-icon>mdi-chevron-left</v-icon></v-btn>
          Distribution Audit Log
          <v-spacer></v-spacer>
          <v-text-field
          v-model="searchOutwardAuditlog"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          clearable
          hide-details
          ></v-text-field>
        </v-card-title>
        <v-card-text class="pa-2">
          <v-data-table
          :headers="uniformOutwardAuditLogHeader"
          :items="uniformOutwardAuditLog"
          hide-default-header
          hide-default-footer
          class="elevation-3"
          :mobile-breakpoint="0"
          disable-pagination
          fixed-header
          :search="searchOutwardAuditlog"
          dense
          height="550px"
          >
          <template v-slot:header="{ props: { headers } }">
            <thead>
              <tr>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[0].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 250px; text-align: left">{{headers[1].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 150px; text-align: left">{{headers[2].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 150px; text-align: left">{{headers[3].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: left">{{headers[4].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: right">{{headers[5].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: center">{{headers[6].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: center">{{headers[7].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 120px; text-align: center">{{headers[8].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: center">{{headers[9].text}}</th>
              </tr>
            </thead>
          </template>
          <template slot="item" slot-scope="props">
            <tr>
              <td style="text-align:center; font-size: 12px"> {{ props.item.outward_date ? handy.formatDBDate(props.item.outward_date) : '-' }} </td>
              <td style="text-align:left; font-size: 12px"> {{ props.item.proj_name ? props.item.proj_name : '-' }} </td>
              <td style="text-align:left; font-size: 12px"> {{ props.item.emp_name_with_id ? props.item.emp_name_with_id : '-' }} </td>
              <td style="text-align:left; font-size: 12px"> {{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : '-' }} </td>
              <td style="text-align:left; font-size: 12px"> {{ props.item.uniform_size ? props.item.uniform_size : '-' }} </td>
              <td style="text-align:right; font-size: 12px"> {{ props.item.unit_rate ? handy.formatCur(props.item.unit_rate) : '-' }} </td>
              <td style="text-align:center; font-size: 12px"> {{ props.item.tax_percent ? props.item.tax_percent + ' %' : '-' }} </td>
              <td style="text-align:center; font-size: 12px"> {{ props.item.log_qty ? props.item.log_qty : '-' }} </td>
              <td style="text-align:center; font-size: 12px"> {{ props.item.log_source ? props.item.log_source : '-' }} </td>
              <td style="text-align:center; font-size: 12px"> {{ props.item.vendor_id ? props.item.vendor_id : '-' }} </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-flex>
</v-flex>
</v-layout>

<!-- Bulk Outward Audit Log -->
<v-layout row wrap v-if="lAction === 'bulk-outward-auditlog'">
  <v-flex xs12 mx-auto>
    <v-flex xs12>
      <v-card flat>
        <v-card-title class="title pt-2 pl-0 pb-2">
          <v-btn icon class="ma-0" @click="lAction = prevScr || 'view'"><v-icon>mdi-chevron-left</v-icon></v-btn>
          Bulk Distribution Audit Log
          <v-spacer></v-spacer>
          <v-text-field
          v-model="searchBulkOutwardAuditlog"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          clearable
          hide-details
          ></v-text-field>
        </v-card-title>
        <v-card-text class="pa-2">
          <v-data-table
          :headers="uniformBulkOutwardAuditLogHeader"
          :items="uniformBulkOutwardAuditLog"
          hide-default-header
          hide-default-footer
          class="elevation-3"
          :mobile-breakpoint="0"
          disable-pagination
          :search = "searchBulkOutwardAuditlog"
          fixed-header
          dense
          height="550px"
          >
          <template v-slot:header="{ props: { headers } }">
            <thead>
              <tr>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 110px; text-align: center">{{headers[0].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 200px; text-align: left">{{headers[1].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 170px; text-align: left">{{headers[2].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 150px; text-align: left">{{headers[3].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[4].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: right">{{headers[5].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 70px; text-align: center">{{headers[6].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 70px; text-align: center">{{headers[7].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 70px; text-align: center">{{headers[8].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 150px; text-align: center">{{headers[9].text}}</th>
              </tr>
            </thead>
          </template>
          <template slot="item" slot-scope="props">
            <tr>
              <td style="text-align:center; font-size: 12px"> {{ props.item.bulk_outward_date ? handy.formatDBDate(props.item.bulk_outward_date) : '-' }} </td>
              <td style="text-align:left; font-size: 12px"> {{ props.item.proj_name ? props.item.proj_name : '-' }} </td>
              <td style="text-align:left; font-size: 12px"> {{ props.item.emp_name_or_taken_by ? props.item.emp_name_or_taken_by : '-' }} </td>
              <td style="text-align:left; font-size: 12px"> {{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : '-' }} </td>
              <td style="text-align:center; font-size: 12px"> {{ props.item.uniform_size ? props.item.uniform_size : '-' }} </td>
              <td style="text-align:right; font-size: 12px"> {{ props.item.unit_rate ? handy.formatCur(props.item.unit_rate) : '-' }} </td>
              <td style="text-align:center; font-size: 12px"> {{ props.item.tax_percent ? props.item.tax_percent + ' %' : '-' }} </td>
              <td style="text-align:center; font-size: 12px"> {{ props.item.log_qty ? props.item.log_qty : '-' }} </td>
              <td style="text-align:center; font-size: 12px"> {{ props.item.allocated_qty ? props.item.allocated_qty : '-' }} </td>
              <td style="text-align:center; font-size: 12px"> {{ props.item.log_source ? props.item.log_source : '-' }} </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-flex>
</v-flex>
</v-layout>

<!-- All Project Wise Distribution Summary -->
<v-layout row wrap v-if="lAction === 'all-projectwise-distribution-summary'">
  <v-flex xs12 mx-auto>
    <v-flex xs12>
      <v-card flat>
        <v-card-title class="title pt-2 pl-0 pb-2">
          <v-btn icon class="ma-0" @click="lAction = prevScr || 'view'"><v-icon>mdi-chevron-left</v-icon></v-btn>
          Project Wise Distribution Report
          <v-spacer></v-spacer>
          <v-text-field
          v-model="searchProjWiseDistSummary"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          clearable
          hide-details
          ></v-text-field>
          <v-flex xs3>
            <v-download-as
            :headers="uniformProjectWiseDistributionSummaryReportHeader"
            :items="uniformProjectWiseDistributionSummaryReport"
            title="Project Wise Distribution Summary Report"
            :landscape="true"
            ></v-download-as>
          </v-flex>
        </v-card-title>
        <v-card-text class="pa-2">
          <v-data-table
          :headers="uniformProjectWiseDistributionSummaryReportHeader"
          hide-default-header
          :items="uniformProjectWiseDistributionSummaryReport"
          hide-default-footer
          class="elevation-3"
          :mobile-breakpoint="0"
          disable-pagination
          fixed-header
          dense
          :search="searchProjWiseDistSummary"
          height="650px"
          >
          <template v-slot:header="{ props: { headers } }">
            <thead>
              <tr>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 300px; text-align: left">{{headers[0].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: center">{{headers[1].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: right">{{headers[2].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: right">{{headers[3].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: right">{{headers[4].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[5].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: right">{{headers[6].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: right">{{headers[7].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: right">{{headers[8].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: right">{{headers[9].text}}</th>
              </tr>
            </thead>
          </template>
          <template slot="item" slot-scope="props">
            <tr @click="loadUniformProjectwiseMonthlyDistributionReports(props.item)">
              <td style="background-color:#E7FAF0; text-align: left; font-size: 12px"> {{ props.item.proj_name ? props.item.proj_name : '-' }} </td>
              <td style="background-color:#BDE9D1; text-align: center; font-size: 12px"> {{ props.item.outward_qty ? props.item.outward_qty : '-' }} </td>
              <td style="background-color:#BDE9D1; text-align: right; font-size: 12px"> {{ props.item.amount ? handy.formatCur(props.item.amount) : '-' }} </td>
              <td style="background-color:#BDE9D1; text-align: right; font-size: 12px"> {{ props.item.tax_amount ? handy.formatCur(props.item.tax_amount) : '-' }} </td>
              <td style="background-color:#BDE9D1; text-align: right; font-size: 12px"> {{ props.item.total_amount ? handy.formatCur(props.item.total_amount) : '-' }} </td>
              <td style="background-color:#F1D4A8; text-align: center; font-size: 12px"> {{ props.item.bulk_pending_qty ? props.item.bulk_pending_qty : '-' }} </td>
              <td style="background-color:#F1D4A8; text-align: right; font-size: 12px"> {{ props.item.bulk_amount ? handy.formatCur(props.item.bulk_amount) : '-' }} </td>
              <td style="background-color:#F1D4A8; text-align: right; font-size: 12px"> {{ props.item.bulk_tax_amount ? handy.formatCur(props.item.bulk_tax_amount) : '-' }} </td>
              <td style="background-color:#F1D4A8; text-align: right; font-size: 12px"> {{ props.item.bulk_total_amount ? handy.formatCur(props.item.bulk_total_amount) : '-' }} </td>
              <td style="background-color:#CCC986; text-align: right; font-size: 12px"> {{ props.item.grand_total_amount ? handy.formatCur(props.item.grand_total_amount) : '-' }} </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-flex>
</v-flex>
</v-layout>

<!-- Project Wise Monthly Distribution Summary -->
<v-layout row wrap v-if="lAction === 'projectwise-month-distribution-summary'">
  <v-flex xs12 mx-auto>
    <v-flex xs12>
      <v-card flat>
        <v-card-title class="title pt-2 pl-0 pb-2">
          <v-btn icon class="ma-0" @click="lAction = prevScr || 'all-projectwise-distribution-summary'"><v-icon>mdi-chevron-left</v-icon></v-btn>
          Project Wise Monthly Distribution Report
          <v-spacer></v-spacer>
          <v-text-field
          v-model="searchProjWiseMonthlyDistSummary"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          clearable
          hide-details
          ></v-text-field>
          <v-flex xs3>
            <v-download-as
            :headers="uniformProjectWiseMonthlyDistributionSummaryReportHeader"
            :items="uniformProjectWiseMonthlyDistributionSummaryReport"
            title="Project Wise Monthly Distribution Summary Report"
            :landscape="true"
            ></v-download-as>
          </v-flex>
        </v-card-title>
        <v-card-text class="pa-2">
          <v-data-table
          :headers="uniformProjectWiseMonthlyDistributionSummaryReportHeader"
          hide-default-header
          :items="uniformProjectWiseMonthlyDistributionSummaryReport"
          hide-default-footer
          class="elevation-3"
          :mobile-breakpoint="0"
          disable-pagination
          fixed-header
          dense
          :search="searchProjWiseMonthlyDistSummary"
          height="650px"
          >
          <template v-slot:header="{ props: { headers } }">
            <thead>
              <tr>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 250px; text-align: left">{{headers[0].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[1].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: center">{{headers[2].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: right">{{headers[3].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: right">{{headers[4].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: right">{{headers[5].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[6].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: right">{{headers[7].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: right">{{headers[8].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: right">{{headers[9].text}}</th>
                <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: right">{{headers[10].text}}</th>
              </tr>
            </thead>
          </template>
          <template slot="item" slot-scope="props">
            <tr>
              <td style="background-color:#E7FAF0; text-align: left; font-size: 12px"> {{ props.item.proj_name ? props.item.proj_name : '-' }} </td>
              <td style="background-color:#BDE9D1; text-align: center; font-size: 12px"> {{ props.item.outward_date ? props.item.outward_date : '-' }} </td>
              <td style="background-color:#BDE9D1; text-align: center; font-size: 12px"> {{ props.item.outward_qty ? props.item.outward_qty : '-' }} </td>
              <td style="background-color:#BDE9D1; text-align: right; font-size: 12px"> {{ props.item.amount ? handy.formatCur(props.item.amount) : '-' }} </td>
              <td style="background-color:#BDE9D1; text-align: right; font-size: 12px"> {{ props.item.tax_amount ? handy.formatCur(props.item.tax_amount) : '-' }} </td>
              <td style="background-color:#BDE9D1; text-align: right; font-size: 12px"> {{ props.item.total_amount ? handy.formatCur(props.item.total_amount) : '-' }} </td>
              <td style="background-color:#F1D4A8; text-align: center; font-size: 12px"> {{ props.item.bulk_pending_qty ? props.item.bulk_pending_qty : '-' }} </td>
              <td style="background-color:#F1D4A8; text-align: right; font-size: 12px"> {{ props.item.bulk_amount ? handy.formatCur(props.item.bulk_amount) : '-' }} </td>
              <td style="background-color:#F1D4A8; text-align: right; font-size: 12px"> {{ props.item.bulk_tax_amount ? handy.formatCur(props.item.bulk_tax_amount) : '-' }} </td>
              <td style="background-color:#F1D4A8; text-align: right; font-size: 12px"> {{ props.item.bulk_total_amount ? handy.formatCur(props.item.bulk_total_amount) : '-' }} </td>
              <td style="background-color:#CCC986; text-align: right; font-size: 12px"> {{ props.item.grand_total_amount ? handy.formatCur(props.item.grand_total_amount) : '-' }} </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-flex>
</v-flex>
</v-layout>

<!-- Monthly Distribution Summary Report -->
<v-layout row wrap v-if="lAction === 'monthly-distribution-summary'">
  <v-flex xs12 mx-auto>
    <v-flex xs12>
      <v-card flat>
        <v-card-title class="title pt-2 pl-0 pb-2">
          <v-btn icon class="ma-0" @click="lAction = prevScr || 'view'"><v-icon>mdi-chevron-left</v-icon></v-btn>
          Monthly Distribution Summary Report
          <v-spacer></v-spacer>
          <v-text-field
          v-model="searchMonthlyDistSummary"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          clearable
          hide-details
          class="mt-0 pt-0"
          ></v-text-field>
          <v-flex xs3>
            <v-download-as
            :headers="uniformMonthlyDistributionSummaryReportHeader"
            :items="uniformMonthlyDistributionSummaryReport"
            title="Monthly Distribution Summary Report"
            :landscape="true"
            ></v-download-as>
          </v-flex>
        </v-card-title>
        <v-card-text class="pl-2 pr-2">
          <v-flex xs12 style="border: 1px solid grey; border-radius:7px" class="pb-2">
            <v-layout row wrap>
              <v-flex xs3 class="pt-2 pl-8">
                <v-combobox
                v-model="lUniformMonthlyDistributionSummaryReport.uniform_cat_pair"
                :items="uniformCatRpt"
                label="Uniform Category"
                item-text="uniform_cat"
                item-value="uniform_cat_id"
                hide-details
                return-object
                clearable
                dense
                outlined
                return-object
                color="primary"
                ></v-combobox>
              </v-flex>
              <v-flex xs3 class="pt-2 pl-8">
                <v-combobox
                v-model="lUniformMonthlyDistributionSummaryReport.uniform_sub_cat_pair"
                :items="uniformSubCat"
                label="Uniform Sub Category"
                item-text="uniform_sub_cat"
                item-value="uniform_sub_cat_id"
                hide-details
                return-object
                clearable
                dense
                outlined
                return-object
                color="primary"
                ></v-combobox>
              </v-flex>
              <v-flex xs2 class="pl-8" style="margin-top: 5px;">
                <v-dialog ref="dlgDate_from_mondistrpt"
                persistent v-model="dlgDate_from_mondistrpt"
                max-width="290px"
                :return-value.sync="lUniformMonthlyDistributionSummaryReport.from_date">
                <template v-slot:activator="{ on }">
                  <v-text-field
                  slot="activator" label="From Date"
                  v-model="lUniformMonthlyDistributionSummaryReport.from_date" append-icon="mdi-calendar-today"
                  readonly clearable
                  v-on="on"
                  hide-details
                  outlined
                  dense
                  color="primary"
                  style="font-size: 14px"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="lUniformMonthlyDistributionSummaryReport.from_date"
                first-day-of-week="1">
                <v-spacer></v-spacer>
                <v-btn text @click="dlgDate_from_mondistrpt = false">Cancel</v-btn>
                <v-btn text color="accent" @click="$refs.dlgDate_from_mondistrpt.save(lUniformMonthlyDistributionSummaryReport.from_date)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs2 class="pl-8" style="margin-top: 5px;">
            <v-dialog ref="dlgDate_to_mondistrpt"
            persistent v-model="dlgDate_to_mondistrpt"
            max-width="290px"
            :return-value.sync="lUniformMonthlyDistributionSummaryReport.to_date">
            <template v-slot:activator="{ on }">
              <v-text-field
              slot="activator" label="To Date"
              v-model="lUniformMonthlyDistributionSummaryReport.to_date" append-icon="mdi-calendar-today"
              readonly clearable
              v-on="on"
              hide-details
              outlined
              dense
              color="primary"
              style="font-size: 14px"
              ></v-text-field>
            </template>
            <v-date-picker v-model="lUniformMonthlyDistributionSummaryReport.to_date"
            first-day-of-week="1">
            <v-spacer></v-spacer>
            <v-btn text @click="dlgDate_to_mondistrpt = false">Cancel</v-btn>
            <v-btn text color="accent" @click="$refs.dlgDate_to_mondistrpt.save(lUniformMonthlyDistributionSummaryReport.to_date)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
      <v-flex xs1 class="pt-2 pl-8">
        <v-btn fab small color="accent" @click="loadUniformMonthlyDistributionSummaryReport(lUniformMonthlyDistributionSummaryReport)">Go</v-btn>
      </v-flex>
    </v-layout>
  </v-flex>
  <v-flex>
    <v-data-table
    :headers="uniformMonthlyDistributionSummaryReportHeader"
    hide-default-header
    :items="uniformMonthlyDistributionSummaryReport"
    hide-default-footer
    class="elevation-3"
    :mobile-breakpoint="0"
    disable-pagination
    fixed-header
    :search="searchMonthlyDistSummary"
    dense
    height="600px"
    >
    <template v-slot:header="{ props: { headers } }">
      <thead>
        <tr>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 50px; text-align: center">{{headers[0].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 100px; text-align: center">{{headers[1].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 250px; text-align: left">{{headers[2].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 250px; text-align: left">{{headers[3].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 75px; text-align: center">{{headers[4].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: right">{{headers[5].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: right">{{headers[6].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: right">{{headers[7].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: center">{{headers[8].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: right">{{headers[9].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: right">{{headers[10].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: right">{{headers[11].text}}</th>
          <th class="uniformtableheader white--text" style="font-size: 13px; width: 80px; text-align: right">{{headers[12].text}}</th>
        </tr>
      </thead>
    </template>
    <template slot="item" slot-scope="props">
      <tr v-if="!props.item.sno && props.item.uniform_sub_cat === 'Sub-Total'" :style="!props.item.sno ? 'color:#00000; background-color: #D5D8D0' : 'border-bottom:1px solid black;'">
        <td style="text-align: center; font-size: 13px"> <strong>{{ props.item.sno ? props.item.sno : '' }}</strong> </td>
        <td style="text-align: center; font-size: 13px"> <strong>{{ props.item.outward_date ? props.item.outward_date : '' }}</strong> </td>
        <td style="text-align: left; font-size: 13px"> <strong>{{ props.item.proj_name ? props.item.proj_name : '' }}</strong> </td>
        <td style="text-align: left; font-size: 13px"> <strong>{{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : '' }}</strong> </td>
        <td style="text-align: center; font-size: 13px"> <strong>{{ props.item.outward_qty ? props.item.outward_qty : '-' }}</strong> </td>
        <td style="text-align: right; font-size: 13px"> <strong>{{ props.item.amount ? handy.formatCur(props.item.amount) : '-' }}</strong> </td>
        <td style="text-align: right; font-size: 13px"> <strong>{{ props.item.tax_amount ? handy.formatCur(props.item.tax_amount) : '-' }}</strong> </td>
        <td style="text-align: right; font-size: 13px"> <strong>{{ props.item.total_amount ? handy.formatCur(props.item.total_amount) : '-' }}</strong> </td>
        <td style="text-align: center; font-size: 13px"> <strong>{{ props.item.bulk_pending_qty ? props.item.bulk_pending_qty : '-' }}</strong> </td>
        <td style="text-align: right; font-size: 13px"> <strong>{{ props.item.bulk_amount ? handy.formatCur(props.item.bulk_amount) : '-' }}</strong> </td>
        <td style="text-align: right; font-size: 13px"> <strong>{{ props.item.bulk_tax_amount ? handy.formatCur(props.item.bulk_tax_amount) : '-' }}</strong> </td>
        <td style="text-align: right; font-size: 13px"> <strong>{{ props.item.bulk_total_amount ? handy.formatCur(props.item.bulk_total_amount) : '-' }}</strong> </td>
        <td style="text-align: right; font-size: 13px"> <strong>{{ props.item.grand_total_amount ? handy.formatCur(props.item.grand_total_amount) : '-' }}</strong> </td>
      </tr>
      <tr v-else-if="!props.item.sno && props.item.uniform_sub_cat === 'Grand-Total'" :style="!props.item.sno ? 'color:#0000FF; background-color: #A1A1A1' : 'border-bottom:1px solid black;'">
        <td style="text-align: center; font-size: 14px"> <strong>{{ props.item.sno ? props.item.sno : '' }}</strong> </td>
        <td style="text-align: center; font-size: 14px"> <strong>{{ props.item.outward_date ? props.item.outward_date : '' }}</strong> </td>
        <td style="text-align: left; font-size: 14px"> <strong>{{ props.item.proj_name ? props.item.proj_name : '' }}</strong> </td>
        <td style="text-align: left; font-size: 14px"> <strong>{{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : '' }}</strong> </td>
        <td style="text-align: center; font-size: 14px"> <strong>{{ props.item.outward_qty ? props.item.outward_qty : '-' }}</strong> </td>
        <td style="text-align: right; font-size: 14px"> <strong>{{ props.item.amount ? handy.formatCur(props.item.amount) : '-' }}</strong> </td>
        <td style="text-align: right; font-size: 14px"> <strong>{{ props.item.tax_amount ? handy.formatCur(props.item.tax_amount) : '-' }}</strong> </td>
        <td style="text-align: right; font-size: 14px"> <strong>{{ props.item.total_amount ? handy.formatCur(props.item.total_amount) : '-' }}</strong> </td>
        <td style="text-align: center; font-size: 14px"> <strong>{{ props.item.bulk_pending_qty ? props.item.bulk_pending_qty : '-' }}</strong> </td>
        <td style="text-align: right; font-size: 14px"> <strong>{{ props.item.bulk_amount ? handy.formatCur(props.item.bulk_amount) : '-' }}</strong> </td>
        <td style="text-align: right; font-size: 14px"> <strong>{{ props.item.bulk_tax_amount ? handy.formatCur(props.item.bulk_tax_amount) : '-' }}</strong> </td>
        <td style="text-align: right; font-size: 14px"> <strong>{{ props.item.bulk_total_amount ? handy.formatCur(props.item.bulk_total_amount) : '-' }}</strong> </td>
        <td style="text-align: right; font-size: 14px"> <strong>{{ props.item.grand_total_amount ? handy.formatCur(props.item.grand_total_amount) : '-' }}</strong> </td>
      </tr>
      <tr v-else>
        <td style="background-color:#E7FAF0; text-align: center; font-size: 12px"> {{ props.item.sno ? props.item.sno : '' }} </td>
        <td style="background-color:#E7FAF0; text-align: center; font-size: 12px"> {{ props.item.outward_date ? props.item.outward_date : '-' }} </td>
        <td style="background-color:#E7FAF0; text-align: left; font-size: 12px"> {{ props.item.proj_name ? props.item.proj_name : '-' }} </td>
        <td style="background-color:#E7FAF0; text-align: left; font-size: 12px"> {{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : '-' }} </td>
        <td style="background-color:#BDE9D1; text-align: center; font-size: 12px"> {{ props.item.outward_qty ? props.item.outward_qty : '-' }} </td>
        <td style="background-color:#BDE9D1; text-align: right; font-size: 12px"> {{ props.item.amount ? handy.formatCur(props.item.amount) : '-' }} </td>
        <td style="background-color:#BDE9D1; text-align: right; font-size: 12px"> {{ props.item.tax_amount ? handy.formatCur(props.item.tax_amount) : '-' }} </td>
        <td style="background-color:#BDE9D1; text-align: right; font-size: 12px"> {{ props.item.total_amount ? handy.formatCur(props.item.total_amount) : '-' }} </td>
        <td style="background-color:#F1D4A8; text-align: center; font-size: 12px"> {{ props.item.bulk_pending_qty ? props.item.bulk_pending_qty : '-' }} </td>
        <td style="background-color:#F1D4A8; text-align: right; font-size: 12px"> {{ props.item.bulk_amount ? handy.formatCur(props.item.bulk_amount) : '-' }} </td>
        <td style="background-color:#F1D4A8; text-align: right; font-size: 12px"> {{ props.item.bulk_tax_amount ? handy.formatCur(props.item.bulk_tax_amount) : '-' }} </td>
        <td style="background-color:#F1D4A8; text-align: right; font-size: 12px"> {{ props.item.bulk_total_amount ? handy.formatCur(props.item.bulk_total_amount) : '-' }} </td>
        <td style="background-color:#CCC986; text-align: right; font-size: 12px"> {{ props.item.grand_total_amount ? handy.formatCur(props.item.grand_total_amount) : '-' }} </td>
      </tr>
    </template>
  </v-data-table>
</v-flex>
</v-card-text>
</v-card>
</v-flex>
</v-flex>
</v-layout>

      </v-flex>

      <!-- snack bar for reporting -->
      <v-snackbar :color="sbarCol" v-model="sbar" :timeout="3500" multi-line>
        <span class="mx-auto">{{ sbarMsg }}</span>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import VDownloadAs from './VDownloadAs.vue'

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      // Common Declarations
      lAction: '',
      tab: '',
      beingSaved: false,
      prevScr: '',
      handy: handy,
      config: config,
      sbarCol: '',
      sbarMsg: '',
      sbar: false,
      searchInward: '',
      searchOutward: '',
      searchProjWiseDistSummary: '',
      searchStocksequenceAuditlog: '',
      searchInwardAuditlog: '',
      searchOutwardAuditlog: '',
      searchBulkOutwardAuditlog: '',
      searchEmpWiseDistributionReport: '',
      searchMonthlyDistSummary: '',
      searchSubCatWiseStockReport: '',
      searchStockSequenceWiseReport: '',
      searchStockSequenceTableData: '',
      searchProjWiseMonthlyDistSummary: '',
      searchBulkDistribEmpMapComparRpt: '',
      searchUniformPurchaseHistorySummary: '',
      searchUniformPurchaseHistorySummaryDetails: '',
      searchStockValueReport: '',
      rules: handy.rules,
      dlgDate_inward: false,
      dlgDate_outward: false,
      dlgDate_bulkoutward: false,
      dlgDate_bulkempbase: false,
      dlgDate_empmap: false,
      dlgDate_bulkoutwardreturn: false,
      dlgDate_from_empwiserpt: false,
      dlgDate_to_empwiserpt: false,
      dlgDate_from_mondistrpt: false,
      dlgDate_to_mondistrpt: false,
      dlgDate_from_bulkempmapcomprpt: false,
      dlgDate_to_bulkempmapcomprpt: false,
      dlgDate_from_purhistorysummary: false,
      dlgDate_to_purhistorysummary: false,
      // Component Specific Declarations
      tabitems: ['Uniform Inward', 'Uniform Outward', 'Reports'],
      // Uniform Inward Declarations
      uniformInward: [],
      uniformInwardHeader: [
        { text: 'SNo', value: '' },
        { text: 'Invoice No', value: 'invoice_no' },
        { text: 'Invoice Date', value: 'invoice_date' },
        { text: 'Vendor Name', value: 'vendorsupplier_name' },
        { text: 'Qty', value: 'qty', width:'100px' },
        { text: 'Amount Before Tax', value: 'amount_bf_tax' },
        { text: 'Tax Amount', value: 'tax_amount' },
        { text: 'Amount After Tax', value: 'amount_af_tax' }
      ],
      lUniformInwardBase: [],
      uniformCat: [],
      uniformSubCat:[],
      uniformSize:[],
      vendorSupplier:[],
      lUniformInwardDetail: [],
      uniformInwardDetail: [],
      manageUniformInwardDetail: false,
      lMAction: '',
      uniformInwardDetailHeader: [
        { text: 'SNo', value: '' },
        { text: 'Uniform Sub Category', value: 'uniform_sub_cat' },
        { text: 'Uniform Size', value: 'uniform_size' },
        { text: 'Qty', value: 'qty' },
        { text: 'Unit', value: 'unit' },
        { text: 'Rate', value: 'unit_rate' },
        { text: 'Amt Before Tax', value: 'amount_bf_tax' },
        { text: 'Tax %', value: 'tax_percent' },
        { text: 'Tax Amount', value: 'tax_amount' },
        { text: 'Amount After Tax', value: 'amount_af_tax' },
        { text: 'Action', value: '' }
      ],
      // Uniform Outward Declarations
      uniformOutward: [],
      uniformOutwardHeader: [
        { text: 'SNo', value: '' },
        { text: 'Project Name', value: 'proj_name' },
        { text: 'Account Manager', value: 'proj_manager' },
        { text: 'Total Qty', value: 'qty' },
        { text: 'Amt Before Tax', value: 'amount_bf_tax' },
        { text: 'Tax Amount', value: 'tax_amount' },
        { text: 'Amt After Tax', value: 'amount_af_tax' },
        { text: 'Bulk Distrib', value: 'amount_af_tax' },
        { text: 'Emp Mapped', value: 'amount_af_tax' },
        { text: 'Balance Qty', value: 'amount_af_tax' }
      ],
      lUniformOutwardBase: [],
      uniformOutwardDetail: [],
      lUniformOutwardDetail: [],
      uniformDistributionHistoryForEmployee: [],
      uniformDistributionHistoryForEmployeeHeader: [
        { text: 'Distrib.Date', value: 'outward_date' },
        { text: 'Uniform Sub Category', value: 'uniform_sub_cat' },
        { text: 'Qty', value: 'qty' },
        { text: 'Duration', value: 'duration' },
      ],
      manageUniformOutwardDetail: false,
      uniformOutwardDetailHeader: [
        { text: 'SNo', value: '' },
        { text: 'Distrib.Date', value: 'outward_date' },
        { text: 'Employee Name', value: 'emp_name_with_id' },
        { text: 'Designation', value: 'designation' },
        { text: 'Uniform Category', value: 'uniform_cat' },
        { text: 'Uniform Sub Category', value: 'uniform_sub_cat' },
        { text: 'Size', value: 'uniform_size' },
        { text: 'Qty', value: 'qty' },
        { text: 'Rate', value: 'unit_rate' },
        { text: 'Action', value: '' }
      ],
      uniformBulkDistributionDetail: [],
      lUniformBulkDistributionDetail: [],
      manageUniformBulkDistributionDetail: false,
      uniformBulkDistributionDetailHeader: [
        { text: 'SNo', value: '' },
        { text: 'Distrib.Date', value: 'outward_date' },
        { text: 'Employee Name or Taken By', value: 'emp_name_with_id' },
        { text: 'Uniform Category', value: 'uniform_cat' },
        { text: 'Uniform Sub Category', value: 'uniform_sub_cat' },
        { text: 'Size', value: 'uniform_size' },
        { text: 'Bulk Qty', value: 'qty' },
        { text: 'Pend.Map', value: 'balance_qty' },
        { text: 'Action', value: '' }
      ],
      activeProjects: [],
      projectEmployees: [],
      uniformStockSeqWithRate: [],
      uniformOutwardSubCat: [],
      uniformOutwardSize: [],
      uniformAllocationInstruction: [],
      manageUniformBulkDistributionReturn: false,
      lUniformBulkDistributionReturn: [],
      uniformBulkDistributionQtyChipSummary: [],
      uniformBulkDistributionDetailForID: [],
      manageUniformEmpMappingBase: false,
      lUniformBulkDistributionEmpMappingDetail: [],
      uniformBulkDistributionEmpMappingDetail: [],
      uniformBulkDistributionEmpMappingDetailHeader: [
        { text: 'SNo', value: '' },
        { text: 'Map Date', value: 'mapping_date'},
        { text: 'Employee Name', value: 'emp_name_with_id' },
        { text: 'Uniform Sub Category', value: 'uniform_sub_cat' },
        { text: 'Size', value: 'uniform_size' },
        { text: 'Map Qty', value: 'qty' },
        { text: 'Action', value: '' }
      ],
      manageUniformEmpMappingDetail: false,
      uniformEmpMappingOutwarDetailIDs: [],
      uniformEmpMapOutwardIdInfo: [],
      // Reporting Declarations
      uniformStockSequenceWiseReport: [],
      uniformStockSequenceWiseReportHeader: [
        { text: 'SNo', value: 'sno' },
        { text: 'Uniform Sub Category', value: 'uniform_sub_cat' },
        { text: 'Uniform Size', value: 'uniform_size' },
        { text: 'Unit', value: 'unit' },
        { text: 'Rate', value: 'unit_rate' },
        { text: 'Tax Percent', value: 'tax_percent' },
        { text: 'Inward Qty', value: 'inward_qty' },
        { text: 'Outward Qty', value: 'outward_qty' },
        { text: 'Stock Qty', value: 'stock_qty' }
      ],
      uniformStockSequenceAuditLog: [],
      uniformStockSequenceAuditLogHeader: [
        { text: 'Uniform Sub Category', value: 'uniform_sub_cat' },
        { text: 'Uniform Size', value: 'uniform_size' },
        { text: 'Seq.Id', value: 'uniform_stock_sequence_id' },
        { text: 'Rate', value: 'unit_rate' },
        { text: 'Tax Percent', value: 'tax_percent' },
        { text: 'Stock Qty', value: 'stock_qty' },
        { text: 'Updated Date', value: 'updated_date' },
        { text: 'Vendor Id', value: 'vendor_id' }
      ],
      uniformInwardAuditLog: [],
      uniformInwardAuditLogHeader: [
        { text: 'Inward Date', value: 'invoice_date' },
        { text: 'Invoice No', value: 'invoice_no' },
        { text: 'Supplier Name', value: 'vendorsupplier_name' },
        { text: 'Uniform Sub Category', value: 'uniform_sub_cat' },
        { text: 'Uniform Size', value: 'uniform_size' },
        { text: 'Rate', value: 'unit_rate' },
        { text: 'Tax %', value: 'tax_percent' },
        { text: 'Log Qty', value: 'log_qty' },
        { text: 'Log Source', value: 'log_source' },
        { text: 'User ID', value: 'updated_by' },
        { text: 'Ven.Id', value: 'vendor_id' }
      ],
      uniformOutwardAuditLog: [],
      uniformOutwardAuditLogHeader: [
        { text: 'Outward Date', value: 'outward_date' },
        { text: 'Project Name', value: 'proj_name' },
        { text: 'Distributed To', value: 'emp_name_with_id' },
        { text: 'Uniform Sub Category', value: 'uniform_sub_cat' },
        { text: 'Uni.Size', value: 'uniform_size' },
        { text: 'Rate', value: 'unit_rate' },
        { text: 'Tax %', value: 'tax_percent' },
        { text: 'Log Qty', value: 'log_qty' },
        { text: 'Log Source', value: 'log_source' },
        { text: 'Ven.Id', value: 'vendor_id' }
      ],
      uniformBulkOutwardAuditLog: [],
      uniformBulkOutwardAuditLogHeader: [
        { text: 'Outward Date', value: 'outward_date' },
        { text: 'Project Name', value: 'proj_name' },
        { text: 'Distributed To', value: 'emp_name_or_taken_by' },
        { text: 'Uniform Sub Category', value: 'uniform_sub_cat' },
        { text: 'Uni.Size', value: 'uniform_size' },
        { text: 'Rate', value: 'unit_rate' },
        { text: 'Tax %', value: 'tax_percent' },
        { text: 'Qty', value: 'log_qty' },
        { text: 'Alc.Qty', value: 'allocated_qty' },
        { text: 'Log Source', value: 'log_source' }
      ],
      uniformProjectWiseDistributionSummaryReport: [],
      uniformProjectWiseDistributionSummaryReportHeader: [
        { text: 'Project Name', value: 'proj_name' },
        { text: 'Distrb.Qty', value: 'outward_qty' },
        { text: 'Amount', value: 'amount' },
        { text: 'Tax.Amt', value: 'tax_amount' },
        { text: 'Tot.Amt', value: 'total_amount' },
        { text: 'Pnd.Map.Qty', value: 'bulk_pending_qty' },
        { text: 'Amount', value: 'bulk_amount' },
        { text: 'Tax.Amt', value: 'bulk_tax_amount' },
        { text: 'Tot.Amt', value: 'bulk_total_amount' },
        { text: 'Grnd.Tot.Amt', value: 'grand_total_amount' }
      ],
      uniformStockValueReport:[],
      uniformStockValueReportHeader: [
        { text: 'SNo', value: 'sno' },
        { text: 'Uniform Sub Category', value: 'uniform_sub_cat' },
        { text: 'Uniform Size', value: 'uniform_size' },
        { text: 'Inward Qty', value: 'inward_qty' },
        { text: 'Outward Qty', value: 'outward_qty' },
        { text: 'Stock Qty', value: 'stock_qty' },
        { text: 'Stock Amount', value: 'stock_value' }
      ],
      uniformReportSubCatWiseStock: [],
      uniformReportSubCatWiseStockHeader: [
        { text: 'SNo', value: 'sno'},
        { text: 'Uniform Sub Category', value: 'uniform_sub_cat' },
        { text: 'Uniform Size', value: 'uniform_size' },
        { text: 'Inward Qty', value: 'inward_qty' },
        { text: 'Outward Qty', value: 'outward_qty' },
        { text: 'Balance Qty', value: 'stock_qty' }
      ],
      uniformReportEmployeeWiseDistribution: [],
      uniformReportEmployeeWiseDistributionHeader: [
        { text: 'Project Name', value: 'proj_name' },
        { text: 'Employee Name', value: 'emp_name_with_id' },
        { text: 'Uniform Category', value: 'uniform_cat' },
        { text: 'Uniform Sub Category', value: 'uniform_sub_cat' },
        { text: 'Size', value: 'uniform_size' },
        { text: 'Qty', value: 'outward_qty' },
        { text: 'Amount', value: 'amount' },
        { text: 'Tax.Amt', value: 'tax_amount' },
        { text: 'Tot.Amt', value: 'tot_amount' },
        { text: 'Status', value: 'filter_status' }
      ],
      lUniformEmpWiseDistributionReport: [],
      empwisedistrichipselection: '',
      uniformAllProjects: [],
      uniformAllEmployees: [],
      uniformMonthlyDistributionSummaryReport: [],
      lUniformMonthlyDistributionSummaryReport: [],
      uniformCatRpt: [],
      uniformMonthlyDistributionSummaryReportHeader: [
        { text: 'Sno', value: 'sno' },
        { text: 'Month', value: 'outward_date' },
        { text: 'Project Name', value: 'proj_name' },
        { text: 'Sub-Category', value: 'uniform_sub_cat' },
        { text: 'Distrb.Qty', value: 'outward_qty' },
        { text: 'Amount', value: 'amount' },
        { text: 'Tax.Amt', value: 'tax_amount' },
        { text: 'Tot.Amt', value: 'total_amount' },
        { text: 'Pnd.Map', value: 'bulk_pending_qty' },
        { text: 'Amount', value: 'bulk_amount' },
        { text: 'Tax.Amt', value: 'bulk_tax_amount' },
        { text: 'Tot.Amt', value: 'bulk_total_amount' },
        { text: 'Grnd.Tot.Amt', value: 'grand_total_amount' }
      ],
      uniformProjectWiseMonthlyDistributionSummaryReport: [],
      uniformProjectWiseMonthlyDistributionSummaryReportHeader: [
        { text: 'Project Name', value: 'proj_name' },
        { text: 'Month', value: 'outward_date' },
        { text: 'Distrb.Qty', value: 'outward_qty' },
        { text: 'Amount', value: 'amount' },
        { text: 'Tax.Amt', value: 'tax_amount' },
        { text: 'Tot.Amt', value: 'total_amount' },
        { text: 'Pnd.Map.Qty', value: 'bulk_pending_qty' },
        { text: 'Amount', value: 'bulk_amount' },
        { text: 'Tax.Amt', value: 'bulk_tax_amount' },
        { text: 'Tot.Amt', value: 'bulk_total_amount' },
        { text: 'Grnd.Tot.Amt', value: 'grand_total_amount' }
      ],
      lUniformBulkDistribMapCompReport: [],
      uniformBulkDistribMapCompReport: [],
      uniformBulkDistribMapCompReportHeader: [
        { text: 'Distrib.Date', value: 'outward_date' },
        { text: 'Project Name', value: 'proj_name' },
        { text: 'Distrb.To', value: 'emp_name_or_taken_by' },
        { text: 'Bulk.Dis.Qty', value: 'outward_qty' },
        { text: 'Pend.Qty', value: 'bulk_pending_qty' },
        { text: 'Alloc.Qty', value: 'allocated_qty' },
        { text: 'Mapped.Qty', value: 'mapped_qty' },
        { text: 'Result', value: 'result' }
      ],
      lUniformPurchaseHistorySummary: [],
      uniformPurchaseHistorySummary: [],
      uniformPurchaseHistorySummaryHeader: [
        { text: 'SNo', value: 'sno' },
        { text: 'Invoice Date', value: 'invoice_date' },
        { text: 'Uniform Sub Category', value: 'uniform_sub_cat' },
        { text: 'Uniform Size', value: 'uniform_size' },
        { text: 'Purchase Qty', value: 'pur_qty' },
        { text: 'Amount Before Tax', value: 'amount_bf_tax' },
        { text: 'Tax Amount', value: 'tax_amount' },
        { text: 'Amount After Tax', value: 'amount_af_tax' }
      ],
      // temp
      uniformStockSequenceTableReport: [],
      uniformStockSequenceTableReportHeader: [
        { text: 'SNo', value: 'sno' },
        { text: 'Uniform Sub Category', value: 'uniform_sub_cat' },
        { text: 'Uniform Size', value: 'uniform_size' },
        { text: 'Current Stock Qty', value: 'cur_stock' }
      ]
    }
  },
  created () {
    this.lAction = 'view'
    this.loadUniformInward()
    this.tab = 'tab-0'
  },
  methods: {
    // Common methods
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    cancelChanges () {
      this.lAction = 'view'
    },
    refreshTab (curTab) {
      if (curTab === 'Uniform Inward') {
        this.loadUniformInward()
        this.tab = 'tab-0'
      } else if (curTab === 'Uniform Outward') {
        this.loadUniformOutward()
        this.tab = 'tab-1'
      } else {
        this.tab = 'tab-2'
      }
      this.lAction = 'view'
    },
    // Uniform Inward Declarations
    loadUniformInward () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUniformInward/', qry)
      .then(response => {
        this.uniformInward = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    prepareCreateUniformInwardBase () {
      this.lUniformInwardBase = {
        vendorsupplier_id: null,
        invoice_no: '',
        invoice_date: null,
        vendor_id: config.VENDOR_ID,
        emp_id: config.EMP_ID
      }
      this.loadVendorSupplier()
      this.lAction = 'create'
    },
    prepareUpdateUniformInwardBase(curInwardBase){
      this.lUniformInwardBase = Object.assign({}, curInwardBase)
      this.loadVendorSupplier()
      this.loadUniformInwardDetail(this.lUniformInwardBase)
      this.lUniformInwardBase.invoice_date = handy.formatDBDate(curInwardBase.invoice_date)
      this.lUniformInwardBase.vendor_id = config.VENDOR_ID
      this.lUniformInwardBase.emp_id = config.EMP_ID
      this.lAction = 'update'
    },
    loadVendorSupplier () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getVendorSupplier/', qry)
      .then(response => {
        this.vendorSupplier = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    saveUniformInwardBase (action) {
      var qry = {
        params: {
          vendorsupplier_id: this.lUniformInwardBase.vendorsupplier_id,
          invoice_no: this.lUniformInwardBase.invoice_no,
          invoice_date: this.lUniformInwardBase.invoice_date,
          vendor_id: config.VENDOR_ID,
          emp_id: config.EMP_ID
        }
      }
      if (this.$refs.lFormUniformInwardBase.validate()) {
        if (!this.lUniformInwardBase.vendorsupplier_id || !this.lUniformInwardBase.invoice_no || !this.lUniformInwardBase.invoice_date ) {
          this.msg('Please Enter Vendor, Invoice No and Invoice Date', 0)
        } else {
          this.axios.get(config.API_URL + '/getUniformInwardBaseExists/', qry)
          .then(resp => {
            if (resp.data.length > 0) {
              this.msg('Invoice Number & Invoice Date is already exists for selected vendor', 0)
            } else {
              this.axios.post(config.API_URL + '/uniformInwardBase/' + action, this.lUniformInwardBase)
              .then(response => {
                if( action === "create" ) {
                  this.lUniformInwardBase.uniform_inward_base_id = response.data
                }
                this.loadUniformInward()
                this.loadUniformInwardDetail(this.lUniformInwardBase)
                this.msg('Saved Successfully', 1)
                this.beingSaved = false
                this.lAction = 'update'
              })
              .catch(err => {
                this.msg(err, 0)
                this.beingSaved = false
              })
            }
          })
          .catch(err => {
            this.msg(err, 0)
            this.beingSaved = false
          })
        }
      }
    },
    deleteUniformInwardBase(curInwardBase) {
      if (!confirm('Sure, you want to delete the Uniform Inward "' + curInwardBase.vendorsupplier_name + ' -> ' + curInwardBase.invoice_no + ' -> ' + curInwardBase.invoice_date + '"?')) {
        return
      }
      this.beingSaved = true
      this.axios.post(config.API_URL + '/uniformInwardBase/delete', curInwardBase)
      .then(response => {
        // Load Uniform Inward
        this.loadUniformInward()
        this.lAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    prepareCreateUniformInwardDetail (curInwardBase) {
      this.lUniformInwardDetail = {
        uniform_inward_base_id: curInwardBase.uniform_inward_base_id,
        uniform_sub_cat_id: null,
        uniform_size_id: null,
        uniform_size: '',
        qty: null,
        unit: '',
        unit_rate: null,
        tax_percent: null,
        tax_amount: null,
        amount_bf_tax: null,
        amount_af_tax: null,
        vendor_id: config.VENDOR_ID,
        emp_id: config.EMP_ID
      }
      this.loadUniformSubCat()
      this.uniformSize = []
      this.lMAction = 'create'
      this.manageUniformInwardDetail = true
    },
    prepareUpdateUniformInwardDetail(curInwardDetail){
      this.lUniformInwardDetail = Object.assign({}, curInwardDetail)
      this.lUniformInwardDetail.old_uniform_sub_cat_id = curInwardDetail.uniform_sub_cat_id
      this.lUniformInwardDetail.old_uniform_size_id = curInwardDetail.uniform_size_id
      this.lUniformInwardDetail.old_unit_rate = curInwardDetail.unit_rate
      this.lUniformInwardDetail.old_qty = curInwardDetail.qty
      this.lUniformInwardDetail.old_tax_percent = curInwardDetail.tax_percent
      this.lUniformInwardDetail.vendor_id = config.VENDOR_ID
      this.lUniformInwardDetail.emp_id = config.EMP_ID
      this.loadUniformSubCat()
      this.loadUniformSize(curInwardDetail.uniform_sub_cat_id)
      this.lMAction = 'update'
      this.manageUniformInwardDetail = true
    },
    prepareCloneUniformInwardDetail(curInwardDetail){
      this.lUniformInwardDetail = Object.assign({}, curInwardDetail)
      this.loadUniformSubCat()
      this.loadUniformSize(curInwardDetail.uniform_sub_cat_id)
      this.lUniformInwardDetail.uniform_size_id = null
      this.lUniformInwardDetail.qty = null
      this.lUniformInwardDetail.unit_rate = null
      this.lUniformInwardDetail.tax_amount = null
      this.lUniformInwardDetail.amount_bf_tax = null
      this.lUniformInwardDetail.amount_af_tax = null
      this.lUniformInwardDetail.vendor_id = config.VENDOR_ID
      this.lUniformInwardDetail.emp_id = config.EMP_ID
      this.lMAction = 'create'
      this.manageUniformInwardDetail = true
    },
    saveUniformInwardDetail (action) {
      var qry = {
        params: {
          uniform_inward_base_id: this.lUniformInwardBase.uniform_inward_base_id,
          uniform_inward_det_id: this.lUniformInwardDetail.uniform_inward_det_id,
          uniform_sub_cat_id: this.lUniformInwardDetail.uniform_sub_cat_id,
          uniform_size_id: this.lUniformInwardDetail.uniform_size_id,
          unit: this.lUniformInwardDetail.unit,
          qty: this.lUniformInwardDetail.qty,
          old_qty: this.lUniformInwardDetail.old_qty,
          diff_qty: this.lUniformInwardDetail.qty - this.lUniformInwardDetail.old_qty,
          unit_rate: this.lUniformInwardDetail.unit_rate,
          tax_percent: this.lUniformInwardDetail.tax_percent,
          vendor_id: config.VENDOR_ID,
          emp_id: config.EMP_ID
        }
      }
      if (this.$refs.lFormUniformInwardDetail.validate()) {
        if (!this.lUniformInwardDetail.uniform_sub_cat_id || !this.lUniformInwardDetail.uniform_size_id || !this.lUniformInwardDetail.unit || !this.lUniformInwardDetail.qty || (this.lUniformInwardDetail.qty <= 0) || !this.lUniformInwardDetail.unit_rate || !this.lUniformInwardDetail.tax_percent) {
          this.msg('Please enter all the given fields', 0)
        } else {
          this.axios.get(config.API_URL + '/getUniformInwardDetailExists/', qry)
          .then(resp => {
            if (resp.data.length > 0) {
              this.msg('Entered Uniform Inward Detail Combination Already Exists', 0)
            } else {
              this.axios.post(config.API_URL + '/uniformInwardDetail/' + action, this.lUniformInwardDetail)
              .then(response => {
                this.loadUniformInward()
                this.loadUniformInwardDetail(this.lUniformInwardBase)
                if (action === 'create') {
                  this.msg('Saved Successfully', 1)
                }
                if (action === 'update') {
                  if (response.data.result === 'SUCCESS') {
                    this.msg('Saved Successfully', 1)
                  } else {
                    this.msg(response.data.msg + ' with outward excess qty ' + response.data.outward_excess_qty, 0)
                  }
                }
                this.beingSaved = false
                this.manageUniformInwardDetail = false
                this.lMAction = 'update'
              })
              .catch(err => {
                this.msg(err, 0)
                this.beingSaved = false
              })
            }
          })
          .catch(err => {
            this.msg(err, 0)
            this.beingSaved = false
          })
        }
      }
    },
    deleteUniformInwardDetail (curInwardDetail) {
      if (!confirm('Sure, you want to delete the Uniform Inward Detail : "' + curInwardDetail.uniform_sub_cat + ' -> ' + curInwardDetail.uniform_size + ' -> ' + curInwardDetail.qty + '"?')) {
        return
      }
      this.beingSaved = true
      curInwardDetail.emp_id = config.EMP_ID
      this.axios.post(config.API_URL + '/uniformInwardDetail/delete', curInwardDetail)
      .then(response => {
        if (response.data.result === 'SUCCESS') {
          this.msg('Deleted Successfully', 1)
          this.loadUniformInwardDetail(this.lUniformInwardBase)
          this.loadUniformInward()
          this.manageUniformInwardDetail = false
          this.lMAction = 'view'
        } else {
          this.msg(response.data.msg, 0)
        }
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    loadUniformInwardDetail (curInwardBase) {
      var qry = {
        params: {
          uniform_inward_base_id: curInwardBase.uniform_inward_base_id,
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUniformInwardDetail/', qry)
      .then(response => {
        this.uniformInwardDetail = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    cancelChangesUniformInwardDetail () {
      this.manageUniformInwardDetail = false
    },
    loadUniformSubCat () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUniformSubCategory/', qry)
      .then(response => {
        this.uniformSubCat = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadUniformSize (uniformSubCatId) {
      var qry = {
        params: {
          uniform_sub_cat_id: uniformSubCatId,
          vendor_id: config.VENDOR_ID
        }
      }
      this.uniformSize = []
      if (this.lUniformInwardDetail.uniform_sub_cat_id != this.lUniformInwardDetail.old_uniform_sub_cat_id) {
        this.lUniformInwardDetail.uniform_size_id = null
      }
      this.axios.get(config.API_URL + '/getUniformSizeBySubCategory/', qry)
      .then(response => {
        this.uniformSize = response.data
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    calculateAmount (curUniformInwardDetail) {
      if (curUniformInwardDetail.qty && curUniformInwardDetail.unit_rate) {
        curUniformInwardDetail.amount_bf_tax = curUniformInwardDetail.qty * curUniformInwardDetail.unit_rate
        this.calculateTaxAmount(curUniformInwardDetail)
      } else {
        curUniformInwardDetail.amount_bf_tax = ''
        curUniformInwardDetail.tax_amount = ''
        curUniformInwardDetail.amount_af_tax = ''
      }
    },
    calculateTaxAmount (curUniformInwardDetail) {
      if (curUniformInwardDetail.amount_bf_tax) {
        curUniformInwardDetail.tax_amount = curUniformInwardDetail.amount_bf_tax * (curUniformInwardDetail.tax_percent/100)
        curUniformInwardDetail.amount_af_tax =curUniformInwardDetail.amount_bf_tax + curUniformInwardDetail.tax_amount
      } else {
        curUniformInwardDetail.tax_amount = ''
        curUniformInwardDetail.amount_af_tax = ''
      }
    },
    // Uniform Outward Declarations
    loadUniformOutward () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUniformOutward/', qry)
      .then(response => {
        this.uniformOutward = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    prepareCreateUniformOutwardBase () {
      this.lUniformOutwardBase = {
        proj_id: null,
        vendor_id: config.VENDOR_ID,
        emp_id: config.EMP_ID
      }
      this.loadActiveMaintenanceProjects()
      this.lAction = 'create'
    },
    prepareUpdateUniformOutwardBase (curOutwardBase) {
      this.lUniformOutwardBase = Object.assign({}, curOutwardBase)
      this.loadActiveMaintenanceProjects()
      this.loadUniformOutwardDetail(this.lUniformOutwardBase)
      this.loadUniformBulkDistributionDetail(this.lUniformOutwardBase)
      this.lUniformOutwardBase.vendor_id = config.VENDOR_ID
      this.lUniformOutwardBase.emp_id = config.EMP_ID
      this.lAction = 'update'
    },
    loadActiveMaintenanceProjects () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getActiveMaintenanceProject/', qry)
      .then(response => {
        this.activeProjects = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    saveUniformOutwardBase (action) {
      var qry = {
        params: {
          proj_id: this.lUniformOutwardBase.proj_id,
          vendor_id: config.VENDOR_ID,
          emp_id: config.EMP_ID
        }
      }
      if (this.$refs.lFormUniformOutwardBase.validate()) {
        if (!this.lUniformOutwardBase.proj_id ) {
          this.msg('Please Select Project', 0)
        } else {
          this.axios.get(config.API_URL + '/getUniformOutwardBaseExists/', qry)
          .then(resp => {
            if (resp.data.length > 0) {
              this.msg('Project already exists. Select project from Uniform Outward List', 0)
            } else {
              this.axios.post(config.API_URL + '/uniformOutwardBase/' + action, this.lUniformOutwardBase)
              .then(response => {
                if( action === "create" ) {
                  this.lUniformOutwardBase.uniform_outward_base_id = response.data
                }
                this.loadUniformOutward()
                this.loadUniformOutwardDetail(this.lUniformOutwardBase)
                this.loadUniformBulkDistributionDetail(this.lUniformOutwardBase)
                this.msg('Saved Successfully', 1)
                this.beingSaved = false
                this.lAction = 'update'
              })
              .catch(err => {
                this.msg(err, 0)
                this.beingSaved = false
              })
            }
          })
          .catch(err => {
            this.msg(err, 0)
            this.beingSaved = false
          })
        }
      }
    },
    deleteUniformOutwardBase(curOutwardBase) {
      if (!confirm('Sure, you want to delete the Uniform Outward for Project : "' + curOutwardBase.proj_name + '"?')) {
        return
      }
      this.beingSaved = true
      this.axios.post(config.API_URL + '/uniformOutwardBase/delete', curOutwardBase)
      .then(response => {
        this.loadUniformOutward()
        this.lAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    prepareCreateUniformOutwardDetail (curOutwardBase) {
      this.lUniformOutwardDetail = {
        uniform_outward_base_id: curOutwardBase.uniform_outward_base_id,
        proj_id: curOutwardBase.proj_id,
        outward_date: null,
        outward_emp_id: null,
        designation: '',
        uniform_cat_id: null,
        uniform_sub_cat_id: null,
        uniform_size_id: null,
        qty: null,
        uniform_stock_sequence_id: null,
        unit_rate: null,
        vendor_id: config.VENDOR_ID,
        emp_id: config.EMP_ID
      }
      this.projectEmployees = []
      this.uniformOutwardSubCat = []
      this.uniformOutwardSize = []
      this.uniformStockSeqWithRate = []
      this.uniformAllocationInstruction = []
      this.uniformDistributionHistoryForEmployee = []
      this.loadUniformCat()
      this.loadActiveEmployeesForProject(curOutwardBase.proj_id)
      this.lMAction = 'create'
      this.manageUniformOutwardDetail = true
    },
    prepareCloneUniformOutwardDetail (curOutwardDetail) {
      this.lUniformOutwardDetail = Object.assign({}, curOutwardDetail)
      this.lUniformOutwardDetail.outward_date = handy.formatDBDate(curOutwardDetail.outward_date)
      this.lUniformOutwardDetail.proj_id = this.lUniformOutwardBase.proj_id
      this.loadUniformCat()
      this.loadOutwardUniformSubCatByCatID(curOutwardDetail)
      this.loadActiveEmployeesForProject(this.lUniformOutwardBase.proj_id)
      this.lUniformOutwardDetail.outward_emp_id = curOutwardDetail.emp_id
      this.lUniformOutwardDetail.uniform_sub_cat_id = null
      this.lUniformOutwardDetail.uniform_size_id = null
      this.lUniformOutwardDetail.qty = null
      this.lUniformOutwardDetail.uniform_stock_sequence_id = null
      this.lUniformOutwardDetail.unit_rate = null
      this.uniformDistributionHistoryForEmployee = []
      this.loadUniformDistributionHistoryForEmp(curOutwardDetail.emp_id)
      this.lUniformOutwardDetail.vendor_id = config.VENDOR_ID
      this.lUniformOutwardDetail.emp_id = config.EMP_ID
      this.lMAction = 'create'
      this.manageUniformOutwardDetail = true
    },
    prepareUpdateUniformOutwardDetail(curOutwardDetail){
      this.lUniformOutwardDetail = Object.assign({}, curOutwardDetail)
      this.lUniformOutwardDetail.outward_date = handy.formatDBDate(curOutwardDetail.outward_date)
      this.lUniformOutwardDetail.proj_id = this.lUniformOutwardBase.proj_id
      this.loadUniformCat()
      this.loadOutwardUniformSubCatByCatID(curOutwardDetail)
      this.loadOutwardUniformSizeBySubCatID(curOutwardDetail.uniform_sub_cat_id)
      this.loadActiveEmployeesForProject(this.lUniformOutwardBase.proj_id)
      this.loadOutwardStockSequenceDetail(curOutwardDetail)
      this.lUniformOutwardDetail.outward_emp_id = curOutwardDetail.emp_id
      this.lUniformOutwardDetail.uniform_stock_sequence_id = curOutwardDetail.uniform_stock_sequence_id
      this.lUniformOutwardDetail.old_qty = curOutwardDetail.qty
      this.lUniformOutwardDetail.vendor_id = config.VENDOR_ID
      this.lUniformOutwardDetail.emp_id = config.EMP_ID
      this.lMAction = 'update'
      this.manageUniformOutwardDetail = true
    },
    loadUniformOutwardEmpMapInfo (curOutwardDetail) {
      this.lUniformOutwardDetail = Object.assign({}, curOutwardDetail)
      this.lUniformOutwardDetail.vendor_id = config.VENDOR_ID
      this.lUniformOutwardDetail.emp_id = config.EMP_ID
      this.uniformEmpMapOutwardIdInfo = []
      this.loadUniformEmpMapOutwardIdInfo(curOutwardDetail)
      this.lMAction = 'info'
      this.manageUniformOutwardDetail = true
    },
    loadUniformEmpMapOutwardIdInfo(curOutwardDetail) {
      var qry = {
        params: {
          uniform_outward_det_id: curOutwardDetail.uniform_outward_det_id,
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUniformEmpMapOutwardIdInfo/', qry)
      .then(response => {
        this.uniformEmpMapOutwardIdInfo = response.data[0]
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadUniformDistributionHistoryForEmp (curEmpId) {
      var qry = {
        params: {
          emp_id: curEmpId,
          vendor_id: config.VENDOR_ID
        }
      }
      this.uniformDistributionHistoryForEmployee = []
      this.axios.get(config.API_URL + '/getDistributionHistoryForEmployee/', qry)
      .then(response => {
        this.uniformDistributionHistoryForEmployee = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    saveUniformOutwardDetail (action) {
      var qry = {
        params: {
          uniform_outward_base_id: this.lUniformOutwardBase.uniform_outward_base_id,
          proj_id: this.lUniformOutwardBase.proj_id,
          uniform_outward_det_id: this.lUniformOutwardDetail.uniform_outward_det_id,
          outward_date: this.lUniformOutwardDetail.outward_date,
          outward_emp_id: this.lUniformOutwardDetail.outward_emp_id,
          designation: this.lUniformOutwardDetail.designation,
          uniform_cat_id: this.lUniformOutwardDetail.uniform_cat_id,
          uniform_sub_cat_id: this.lUniformOutwardDetail.uniform_sub_cat_id,
          uniform_size_id: this.lUniformOutwardDetail.uniform_size_id,
          qty: this.lUniformOutwardDetail.qty,
          uniform_stock_sequence_id: this.lUniformOutwardDetail.uniform_stock_sequence_id,
          unit_rate: this.lUniformOutwardDetail.unit_rate,
          v_action: action,
          old_qty: this.lUniformOutwardDetail.old_qty,
          vendor_id: config.VENDOR_ID,
          emp_id: config.EMP_ID
        }
      }
      if (this.$refs.lFormUniformOutwardDetail.validate()) {
        if (!this.lUniformOutwardDetail.proj_id || !this.lUniformOutwardDetail.outward_date || !this.lUniformOutwardDetail.outward_emp_id || !this.lUniformOutwardDetail.designation || !this.lUniformOutwardDetail.uniform_cat_id || !this.lUniformOutwardDetail.uniform_sub_cat_id || !this.lUniformOutwardDetail.uniform_size_id || !this.lUniformOutwardDetail.qty || this.lUniformOutwardDetail.qty <= 0 || !this.lUniformOutwardDetail.uniform_stock_sequence_id) {
          this.msg('Please enter all the given fields', 0)
        } else {
          this.axios.get(config.API_URL + '/getUniformOutwardDetailExistsForEmployeeForDate/', qry)
          .then(resp => {
            if (resp.data.length > 0 && action === 'create') {
              this.msg('Uniform already distributed to selected employee for selected date', 0)
            } else {
              // Check the total available stock for the combination
              // if the stock is available proceed with entered qty
              // if stock is not enough show message to enter the qty with in the stock limit
              this.axios.get(config.API_URL + '/getIsStockExists/', qry)
              .then(respon => {
                if (respon.data.result === 'ERROR') {
                  this.msg(respon.data.msg, 0)
                } else {
                  this.axios.post(config.API_URL + '/uniformOutwardDetail/' + action, this.lUniformOutwardDetail)
                  .then(response => {
                    this.loadUniformOutward()
                    this.loadUniformOutwardDetail(this.lUniformOutwardDetail)
                    if (action === 'create') {
                      this.msg('Saved Successfully', 1)
                    }
                    if (action === 'update') {
                      if (response.data.result === 'SUCCESS') {
                        this.msg('Saved Successfully', 1)
                      } else {
                        this.msg(response.data.msg, 0)
                      }
                    }
                    this.beingSaved = false
                    this.manageUniformOutwardDetail = false
                    this.lMAction = 'update'
                  })
                  .catch(err => {
                    this.msg(err, 0)
                    this.beingSaved = false
                  })
                }
              })
              .catch(err => {
                this.msg(err, 0)
                this.beingSaved = false
              })
            }
          })
          .catch(err => {
            this.msg(err, 0)
            this.beingSaved = false
          })
        }
      } else {
        this.msg('Please enter all the given fields', 0)
      }
    },
    deleteUniformOutwardDetail (curOutwardDetail) {
      if (!confirm('Sure, you want to delete the selected Uniform Outward Detail : "' + curOutwardDetail.uniform_sub_cat + ' -> ' + curOutwardDetail.uniform_size + ' -> ' + curOutwardDetail.qty + '"?')) {
        return
      }
      this.beingSaved = true
      curOutwardDetail.emp_id = config.EMP_ID
      this.axios.post(config.API_URL + '/uniformOutwardDetail/delete', curOutwardDetail)
      .then(response => {
        if (response.data.result === 'SUCCESS') {
          this.msg('Deleted Successfully', 1)
          this.loadUniformOutwardDetail(this.lUniformOutwardBase)
          this.loadUniformOutward()
          this.manageUniformOutwardDetail = false
          this.lMAction = 'view'
        } else {
          this.msg('Error in deleting seleted Outward Detail', 0)
        }
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    loadUniformCat () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.uniformOutwardSubCat = []
      this.uniformOutwardSize = []
      this.uniformStockSeqWithRate = []
      this.axios.get(config.API_URL + '/getUniformCategory/', qry)
      .then(response => {
        this.uniformCat = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadOutwardUniformSubCatByCatID (curUniformOutwardOrBulkDistributionDetail) {
      var qry = {
        params: {
          uniform_cat_id: curUniformOutwardOrBulkDistributionDetail.uniform_cat_id,
          vendor_id: config.VENDOR_ID
        }
      }
      this.uniformOutwardSize = []
      this.uniformStockSeqWithRate = []
      this.uniformAllocationInstruction = []
      this.axios.get(config.API_URL + '/getUniformSubCategoryByCategoryId/', qry)
      .then(response => {
        this.uniformOutwardSubCat = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadOutwardUniformSizeBySubCatID (curUniformSubCatId) {
      var qry = {
        params: {
          uniform_sub_cat_id: curUniformSubCatId,
          vendor_id: config.VENDOR_ID
        }
      }
      this.uniformOutwardSize = []
      this.uniformStockSeqWithRate = []
      this.axios.get(config.API_URL + '/getUniformSizeBySubCategory/', qry)
      .then(response => {
        this.uniformOutwardSize = response.data
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadActiveEmployeesForProject (curProj_id) {
      var qry = {
        params: {
          proj_id: curProj_id,
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getActiveEmployeesForProject/', qry)
      .then(response => {
        this.projectEmployees = response.data[0]
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadUniformOutwardDetail (curOutwardBase) {
      var qry = {
        params: {
          uniform_outward_base_id: curOutwardBase.uniform_outward_base_id,
          proj_id: curOutwardBase.proj_id,
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUniformOutwardDetail/', qry)
      .then(response => {
        this.uniformOutwardDetail = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
      this.loadEmpMappingOutwardDetailIdForOutwardBaseId(curOutwardBase.uniform_outward_base_id)
    },
    loadEmployeeDesignation(curUniformOutwardOrBulkDistributionDetail, page_name) {
      if (page_name === 'OutwardDetail') {
        this.loadUniformDistributionHistoryForEmp(curUniformOutwardOrBulkDistributionDetail.outward_emp_id)
        curUniformOutwardOrBulkDistributionDetail.designation = ''
        curUniformOutwardOrBulkDistributionDetail.designation = this.projectEmployees.find(rec => rec.emp_id === curUniformOutwardOrBulkDistributionDetail.outward_emp_id).staff_role
        curUniformOutwardOrBulkDistributionDetail.undeployedDate = ''
        curUniformOutwardOrBulkDistributionDetail.undeployedDate = this.projectEmployees.find(rec => rec.emp_id === curUniformOutwardOrBulkDistributionDetail.outward_emp_id).undeployed_on
      } else if (page_name === 'BulkDistributionDetail') {
        curUniformOutwardOrBulkDistributionDetail.designation = ''
        curUniformOutwardOrBulkDistributionDetail.designation = this.projectEmployees.find(rec => rec.emp_id === curUniformOutwardOrBulkDistributionDetail.bulk_outward_emp_id) && this.projectEmployees.find(rec => rec.emp_id === curUniformOutwardOrBulkDistributionDetail.bulk_outward_emp_id).staff_role
        curUniformOutwardOrBulkDistributionDetail.undeployedDate = ''
        curUniformOutwardOrBulkDistributionDetail.undeployedDate = this.projectEmployees.find(rec => rec.emp_id === curUniformOutwardOrBulkDistributionDetail.bulk_outward_emp_id) && this.projectEmployees.find(rec => rec.emp_id === curUniformOutwardOrBulkDistributionDetail.bulk_outward_emp_id).undeployed_on
      } else if (page_name === 'BulkDistributionDetailEmpMapping') {
        this.loadUniformDistributionHistoryForEmp(curUniformOutwardOrBulkDistributionDetail.empmap_emp_id)
        curUniformOutwardOrBulkDistributionDetail.designation = ''
        curUniformOutwardOrBulkDistributionDetail.designation = this.projectEmployees.find(rec => rec.emp_id === curUniformOutwardOrBulkDistributionDetail.empmap_emp_id) && this.projectEmployees.find(rec => rec.emp_id === curUniformOutwardOrBulkDistributionDetail.empmap_emp_id).staff_role
        curUniformOutwardOrBulkDistributionDetail.undeployedDate = ''
        curUniformOutwardOrBulkDistributionDetail.undeployedDate = this.projectEmployees.find(rec => rec.emp_id === curUniformOutwardOrBulkDistributionDetail.empmap_emp_id) && this.projectEmployees.find(rec => rec.emp_id === curUniformOutwardOrBulkDistributionDetail.empmap_emp_id).undeployed_on
      } else if (page_name === 'BulkDistributionReturn') {
        curUniformOutwardOrBulkDistributionDetail.designation = ''
        curUniformOutwardOrBulkDistributionDetail.designation = this.projectEmployees.find(rec => rec.emp_id === curUniformOutwardOrBulkDistributionDetail.bulk_outward_emp_id) && this.projectEmployees.find(rec => rec.emp_id === curUniformOutwardOrBulkDistributionDetail.bulk_outward_emp_id).staff_role
        curUniformOutwardOrBulkDistributionDetail.undeployedDate = ''
        curUniformOutwardOrBulkDistributionDetail.undeployedDate = this.projectEmployees.find(rec => rec.emp_id === curUniformOutwardOrBulkDistributionDetail.bulk_outward_emp_id) && this.projectEmployees.find(rec => rec.emp_id === curUniformOutwardOrBulkDistributionDetail.bulk_outward_emp_id).undeployed_on
      }
    },
    loadOutwardStockSequenceDetail (curUniformOutwardDetail) {
      var qry = {
        params: {
          uniform_sub_cat_id: curUniformOutwardDetail.uniform_sub_cat_id,
          uniform_size_id: curUniformOutwardDetail.uniform_size_id,
          vendor_id: config.VENDOR_ID
        }
      }
      this.uniformStockSeqWithRate = []
      this.uniformAllocationInstruction = []
      this.lUniformOutwardDetail.uniform_stock_sequence_id = null
      this.axios.get(config.API_URL + '/getUniformStockSeqWithRate/', qry)
      .then(response => {
        this.uniformStockSeqWithRate = response.data
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    changeOutwardStockSequenceDetail (curUniformOutwardDetail) {
      if (this.lMAction === 'create' && curUniformOutwardDetail.qty <= 0)
      {
        this.uniformAllocationInstruction = []
        this.lUniformOutwardDetail.uniform_stock_sequence_id = null
      }
    },
    loadUniformStockAllocationInstruction (curUniformOutwardOrBulkDistributionDetail) {
      var qry = {
        params: {
          uniform_stock_sequence_id: curUniformOutwardOrBulkDistributionDetail.uniform_stock_sequence_id,
          uniform_sub_cat_id: curUniformOutwardOrBulkDistributionDetail.uniform_sub_cat_id,
          uniform_size_id: curUniformOutwardOrBulkDistributionDetail.uniform_size_id,
          qty: curUniformOutwardOrBulkDistributionDetail.qty,
          vendor_id: config.VENDOR_ID
        }
      }
      this.uniformAllocationInstruction = []
      this.axios.get(config.API_URL + '/getUniformStockAllocationInstruction/', qry)
      .then(response => {
        this.uniformAllocationInstruction = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    cancelChangesUniformOutwardDetail () {
      this.manageUniformOutwardDetail = false
    },
    prepareCreateUniformBulkDistributionDetail (curOutwardBase) {
      this.lUniformBulkDistributionDetail = {
        uniform_outward_base_id: curOutwardBase.uniform_outward_base_id,
        proj_id: curOutwardBase.proj_id,
        bulk_outward_date: null,
        bulk_outward_emp_id: null,
        designation: '',
        taken_by: '',
        uniform_cat_id: null,
        uniform_sub_cat_id: null,
        uniform_size_id: null,
        qty: null,
        uniform_stock_sequence_id: null,
        unit_rate: null,
        vendor_id: config.VENDOR_ID,
        emp_id: config.EMP_ID
      }
      this.projectEmployees = []
      this.uniformOutwardSubCat = []
      this.uniformOutwardSize = []
      this.uniformStockSeqWithRate = []
      this.uniformAllocationInstruction = []
      this.loadUniformCat()
      this.loadActiveEmployeesForProject(curOutwardBase.proj_id)
      this.lMAction = 'create'
      this.manageUniformBulkDistributionDetail = true
    },
    prepareCloneUniformBulkDistributionDetail (curBulkOutwardDetail) {
      this.lUniformBulkDistributionDetail = Object.assign({}, curBulkOutwardDetail)
      this.lUniformBulkDistributionDetail.bulk_outward_date = handy.formatDBDate(curBulkOutwardDetail.bulk_outward_date)
      this.lUniformBulkDistributionDetail.proj_id = this.lUniformOutwardBase.proj_id
      this.loadActiveEmployeesForProject(this.lUniformOutwardBase.proj_id)
      this.lUniformBulkDistributionDetail.bulk_outward_emp_id = curBulkOutwardDetail.emp_id
      this.lUniformBulkDistributionDetail.designation = curBulkOutwardDetail.designation
      this.lUniformBulkDistributionDetail.taken_by = curBulkOutwardDetail.taken_by
      this.uniformOutwardSize = []
      this.uniformStockSeqWithRate = []
      this.uniformAllocationInstruction = []
      this.loadUniformCat()
      this.loadOutwardUniformSubCatByCatID(curBulkOutwardDetail)
      this.lUniformBulkDistributionDetail.uniform_cat_id = curBulkOutwardDetail.uniform_cat_id
      this.lUniformBulkDistributionDetail.uniform_sub_cat_id = null
      this.lUniformBulkDistributionDetail.uniform_size_id = null
      this.lUniformBulkDistributionDetail.qty = null
      this.lUniformBulkDistributionDetail.uniform_stock_sequence_id = null
      this.lUniformBulkDistributionDetail.unit_rate = null
      this.lUniformBulkDistributionDetail.vendor_id = config.VENDOR_ID
      this.lUniformBulkDistributionDetail.emp_id = config.EMP_ID
      this.lMAction = 'create'
      this.manageUniformBulkDistributionDetail = true
    },
    prepareUpdateUniformBulkDistributionDetail (curBulkOutwardDetail) {
      this.lUniformBulkDistributionDetail = Object.assign({}, curBulkOutwardDetail)
      this.lUniformBulkDistributionDetail.bulk_outward_date = handy.formatDBDate(curBulkOutwardDetail.bulk_outward_date)
      this.lUniformBulkDistributionDetail.proj_id = this.lUniformOutwardBase.proj_id
      this.lUniformBulkDistributionDetail.old_qty = curBulkOutwardDetail.qty
      this.loadActiveEmployeesForProject(this.lUniformOutwardBase.proj_id)
      this.lUniformBulkDistributionDetail.bulk_outward_emp_id = curBulkOutwardDetail.emp_id
      this.lUniformBulkDistributionDetail.taken_by = curBulkOutwardDetail.taken_by
      this.uniformOutwardSize = []
      this.uniformStockSeqWithRate = []
      this.uniformAllocationInstruction = []
      this.loadUniformCat()
      this.loadOutwardUniformSubCatByCatID(curBulkOutwardDetail)
      this.loadOutwardUniformSizeBySubCatID(curBulkOutwardDetail.uniform_sub_cat_id)
      this.loadOutwardStockSequenceDetail(curBulkOutwardDetail)
      this.lUniformBulkDistributionDetail.uniform_stock_sequence_id = curBulkOutwardDetail.uniform_stock_sequence_id
      this.lUniformBulkDistributionDetail.unit_rate = null
      this.lUniformBulkDistributionDetail.vendor_id = config.VENDOR_ID
      this.lUniformBulkDistributionDetail.emp_id = config.EMP_ID
      this.lMAction = 'update'
      this.manageUniformBulkDistributionDetail = true
    },
    prepareReturnUniformBulkDistribution(curBulkOutwardDetail) {
      this.lUniformBulkDistributionReturn = Object.assign({}, curBulkOutwardDetail)
      this.lUniformBulkDistributionReturn.bulk_outward_date = handy.formatDBDate(curBulkOutwardDetail.bulk_outward_date)
      this.lUniformBulkDistributionReturn.proj_id = this.lUniformOutwardBase.proj_id
      this.lUniformBulkDistributionReturn.old_qty = curBulkOutwardDetail.qty
      this.loadActiveEmployeesForProject(this.lUniformOutwardBase.proj_id)
      this.lUniformBulkDistributionReturn.bulk_outward_emp_id = curBulkOutwardDetail.emp_id
      this.lUniformBulkDistributionReturn.taken_by = curBulkOutwardDetail.taken_by
      this.uniformOutwardSize = []
      this.uniformStockSeqWithRate = []
      this.uniformAllocationInstruction = []
      this.loadUniformCat()
      this.loadOutwardUniformSubCatByCatID(curBulkOutwardDetail)
      this.loadOutwardUniformSizeBySubCatID(curBulkOutwardDetail.uniform_sub_cat_id)
      // this.loadUniformBulkDistributionDetailByID(curBulkOutwardDetail.uniform_bulk_outward_det_id)
      this.lUniformBulkDistributionReturn.uniform_stock_sequence_id = curBulkOutwardDetail.uniform_stock_sequence_id
      this.lUniformBulkDistributionReturn.available_stock = this.lUniformBulkDistributionReturn.balance_qty
      this.lUniformBulkDistributionReturn.qty = null
      this.lUniformBulkDistributionReturn.unit_rate = null
      this.lUniformBulkDistributionReturn.vendor_id = config.VENDOR_ID
      this.lUniformBulkDistributionReturn.emp_id = config.EMP_ID
      this.lMAction = 'return'
      this.manageUniformBulkDistributionReturn = true
    },
    cancelChangesUniformBulkDistributionReturn () {
      this.manageUniformBulkDistributionReturn = false
    },
    loadEmployeeMappingSummary(curBulkOutwardDetail) {
      this.lUniformBulkDistributionDetail = Object.assign({}, curBulkOutwardDetail)
      this.loadUniformBulkDistributionDetailByID(curBulkOutwardDetail.uniform_bulk_outward_det_id)
      this.loadUniformBulkDistributionEmpMappingDetailsByID(curBulkOutwardDetail.uniform_bulk_outward_det_id)
      this.manageUniformEmpMappingBase = true
    },
    saveUniformBulkDistributionDetail (action) {
      var qry = {
        params: {
          uniform_outward_base_id: this.lUniformOutwardBase.uniform_outward_base_id,
          proj_id: this.lUniformOutwardBase.proj_id,
          uniform_bulk_outward_det_id: this.lUniformBulkDistributionDetail.uniform_bulk_outward_det_id,
          bulk_outward_date: this.lUniformBulkDistributionDetail.bulk_outward_date,
          bulk_outward_emp_id: this.lUniformBulkDistributionDetail.bulk_outward_emp_id,
          designation: this.lUniformBulkDistributionDetail.designation,
          taken_by: this.lUniformBulkDistributionDetail.taken_by,
          uniform_cat_id: this.lUniformBulkDistributionDetail.uniform_cat_id,
          uniform_sub_cat_id: this.lUniformBulkDistributionDetail.uniform_sub_cat_id,
          uniform_size_id: this.lUniformBulkDistributionDetail.uniform_size_id,
          qty: this.lUniformBulkDistributionDetail.qty,
          uniform_stock_sequence_id: this.lUniformBulkDistributionDetail.uniform_stock_sequence_id,
          unit_rate: this.lUniformBulkDistributionDetail.unit_rate,
          v_action: action,
          old_qty: this.lUniformBulkDistributionDetail.old_qty,
          vendor_id: config.VENDOR_ID,
          emp_id: config.EMP_ID
        }
      }
      if (this.$refs.lFormUniformBulkDistributionDetail.validate()) {
        if (!this.lUniformBulkDistributionDetail.proj_id || !this.lUniformBulkDistributionDetail.bulk_outward_date || !this.lUniformBulkDistributionDetail.uniform_cat_id || !this.lUniformBulkDistributionDetail.uniform_sub_cat_id || !this.lUniformBulkDistributionDetail.uniform_size_id || !this.lUniformBulkDistributionDetail.qty || this.lUniformBulkDistributionDetail.qty <= 0 || !this.lUniformBulkDistributionDetail.uniform_stock_sequence_id) {
          this.msg('Please enter all the given fields', 0)
        } else {
          if ((this.lUniformBulkDistributionDetail.bulk_outward_emp_id && this.lUniformBulkDistributionDetail.designation) || (this.lUniformBulkDistributionDetail.taken_by)) {
            this.axios.get(config.API_URL + '/getUniformCombinationDistributedForProjectForDate/', qry)
            .then(resp => {
              if (resp.data.length > 0 && action === 'create') {
                this.msg('Selected Uniform Combination already distributed to selected Project for selected date', 0)
              } else {
                // Check the total available stock for the combination
                // if the stock is available proceed with entered qty
                // if stock is not enough show message to enter the qty with in the stock limit
                this.axios.get(config.API_URL + '/getIsStockExists/', qry)
                .then(respon => {
                  if (respon.data.result === 'ERROR') {
                    this.msg(respon.data.msg, 0)
                  } else {
                    this.axios.post(config.API_URL + '/uniformBulkDistributionDetail/' + action, this.lUniformBulkDistributionDetail)
                    .then(response => {
                      this.loadUniformOutward()
                      this.loadUniformBulkDistributionDetail(this.lUniformOutwardBase)
                      // this.loadUniformBulkDistributionDetailSummaryForBaseID(this.lUniformOutwardBase)
                      if (action === 'create') {
                        this.msg('Saved Successfully', 1)
                      }
                      if (action === 'update') {
                        if (response.data.result === 'SUCCESS') {
                          this.msg('Saved Successfully', 1)
                        } else {
                          this.msg(response.data.msg, 0)
                        }
                      }
                      this.beingSaved = false
                      this.manageUniformBulkDistributionDetail = false
                      this.lMAction = 'update'
                    })
                    .catch(err => {
                      this.msg(err, 0)
                      this.beingSaved = false
                    })
                  }
                })
                .catch(err => {
                  this.msg(err, 0)
                  this.beingSaved = false
                })
              }
            })
            .catch(err => {
              this.msg(err, 0)
              this.beingSaved = false
            })
          } else {
            this.msg('Please enter all the given fields', 0)
          }
        }
      } else {
        this.msg('Please enter all the given fields', 0)
      }
    },
    deleteUniformBulkDistributionDetail (curBulkOutwardDetail) {
      if (!confirm('Sure, you want to delete the selected Bulk Outward Detail : "' + curBulkOutwardDetail.uniform_sub_cat + ' -> ' + curBulkOutwardDetail.uniform_size + ' -> ' + curBulkOutwardDetail.qty + '"?')) {
        return
      }
      this.beingSaved = true
      curBulkOutwardDetail.emp_id = config.EMP_ID
      this.axios.post(config.API_URL + '/uniformBulkDistributionDetail/delete', curBulkOutwardDetail)
      .then(response => {
        if (response.data.result === 'SUCCESS') {
          this.msg('Deleted Successfully', 1)
          this.loadUniformBulkDistributionDetail(this.lUniformOutwardBase)
          this.loadUniformOutward()
          this.manageUniformBulkDistributionDetail = false
          this.lMAction = 'view'
        } else {
          this.msg(response.data.msg, 0)
        }
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    returnUniformBulkDistribution (action) {
      if (this.$refs.lFormUniformBulkDistributionReturn.validate()) {
        if (!this.lUniformBulkDistributionReturn.proj_id || !this.lUniformBulkDistributionReturn.bulk_outward_date || !this.lUniformBulkDistributionReturn.uniform_cat_id || !this.lUniformBulkDistributionReturn.uniform_sub_cat_id || !this.lUniformBulkDistributionReturn.uniform_size_id || !this.lUniformBulkDistributionReturn.qty || this.lUniformBulkDistributionReturn.qty <= 0 || !this.lUniformBulkDistributionReturn.uniform_stock_sequence_id) {
          this.msg('Please enter all the given fields', 0)
        } else {
          if ((this.lUniformBulkDistributionReturn.bulk_outward_emp_id && this.lUniformBulkDistributionReturn.designation) || (this.lUniformBulkDistributionReturn.taken_by)) {
            this.axios.post(config.API_URL + '/uniformBulkEmpMappingDetail/' + action, this.lUniformBulkDistributionReturn)
            .then(response => {
              this.loadUniformOutward()
              this.loadUniformBulkDistributionDetail(this.lUniformOutwardBase)
              this.loadUniformBulkDistributionDetailSummaryForBaseID(this.lUniformOutwardBase)
              if (action === 'return') {
                if (response.data.result === 'SUCCESS') {
                  this.msg('Saved Successfully', 1)
                  this.manageUniformBulkDistributionReturn = false
                  this.lMAction = 'create'
                } else {
                  this.msg(response.data.msg, 0)
                  this.lMAction = 'return'
                }
              }
              this.beingSaved = false
            })
            .catch(err => {
              this.msg(err, 0)
              this.beingSaved = false
            })
          } else {
            this.msg('Please enter all the given fields', 0)
          }
        }
      } else {
        this.msg('Please enter all the given fields', 0)
      }
    },
    loadBulkOutwardUniformSubCatByCatID (curBulkOutwardDetail) {
      var qry = {
        params: {
          uniform_cat_id: curBulkOutwardDetail.uniform_cat_id,
          vendor_id: config.VENDOR_ID
        }
      }
      this.uniformOutwardSize = []
      this.uniformStockSeqWithRate = []
      this.axios.get(config.API_URL + '/getUniformSubCategoryByCategoryId/', qry)
      .then(response => {
        this.uniformOutwardSubCat = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    cancelChangesUniformBulkDistributionDetail () {
      this.manageUniformBulkDistributionDetail = false
    },
    loadUniformBulkDistributionDetail (curOutwardBase) {
      var qry = {
        params: {
          uniform_outward_base_id: curOutwardBase.uniform_outward_base_id,
          proj_id: curOutwardBase.proj_id,
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUniformBulkDistributionDetail/', qry)
      .then(response => {
        this.uniformBulkDistributionDetail = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
      this.loadUniformBulkDistributionDetailSummaryForBaseID(curOutwardBase)
    },
    loadUniformBulkDistributionDetailSummaryForBaseID (curOutwardBase) {
      // Get Sumamry of Toatal bulk Distributed, Total Employee Mapped and Total Pending Mapping to show in chip.
      var qry = {
        params: {
          uniform_outward_base_id: curOutwardBase.uniform_outward_base_id,
          proj_id: curOutwardBase.proj_id,
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUniformBulkDistributionQtyChipSummary/', qry)
      .then(response => {
        this.uniformBulkDistributionQtyChipSummary = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadUniformBulkDistributionDetailByID(curUniform_bulk_outward_det_id) {
      var qry = {
        params: {
          uniform_bulk_outward_det_id: curUniform_bulk_outward_det_id,
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUniformBulkDistributionDetailByID/', qry)
      .then(response => {
        this.uniformBulkDistributionDetailForID = response.data[0]
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadUniformBulkDistributionEmpMappingDetailsByID(curUniform_bulk_outward_det_id) {
      var qry = {
        params: {
          uniform_bulk_outward_det_id: curUniform_bulk_outward_det_id,
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUniformBulkDistributionEmpMappingDetailsByID/', qry)
      .then(response => {
        this.uniformBulkDistributionEmpMappingDetail = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    prepareCreateUniformEmpMappingDetail (curBulkOutwardDetail) {
      this.lUniformBulkDistributionEmpMappingDetail = {
        uniform_outward_base_id: curBulkOutwardDetail.uniform_outward_base_id,
        uniform_bulk_outward_det_id: curBulkOutwardDetail.uniform_bulk_outward_det_id,
        proj_id: this.lUniformOutwardBase.proj_id,
        uniform_stock_sequence_id: curBulkOutwardDetail.uniform_stock_sequence_id,
        uniform_cat_id: curBulkOutwardDetail.uniform_cat_id,
        uniform_sub_cat_id: curBulkOutwardDetail.uniform_sub_cat_id,
        uniform_size_id: curBulkOutwardDetail.uniform_size_id,
        bulk_outward_date: null,
        bulk_outward_emp_id: null,
        designation: '',
        qty: null,
        unit_rate: null,
        vendor_id: config.VENDOR_ID,
        emp_id: config.EMP_ID
      }
      this.projectEmployees = []
      this.uniformOutwardSubCat = []
      this.uniformOutwardSize = []
      this.uniformDistributionHistoryForEmployee = []
      this.loadUniformCat()
      this.loadOutwardUniformSubCatByCatID(this.lUniformBulkDistributionEmpMappingDetail)
      this.loadOutwardUniformSizeBySubCatID(this.lUniformBulkDistributionEmpMappingDetail.uniform_sub_cat_id)
      this.loadActiveEmployeesForProject(this.lUniformBulkDistributionEmpMappingDetail.proj_id)
      this.lUniformBulkDistributionEmpMappingDetail.available_stock = this.uniformBulkDistributionDetailForID.balance_qty
      this.lMAction = 'create'
      this.manageUniformEmpMappingDetail = true
    },
    prepareUpdateUniformEmpMappingDetail (curBulkEmpMappingDetail) {
      this.lUniformBulkDistributionEmpMappingDetail = Object.assign({}, curBulkEmpMappingDetail)
      this.projectEmployees = []
      this.uniformOutwardSubCat = []
      this.uniformOutwardSize = []
      this.loadUniformCat()
      this.loadOutwardUniformSubCatByCatID(this.lUniformBulkDistributionEmpMappingDetail)
      this.loadOutwardUniformSizeBySubCatID(this.lUniformBulkDistributionEmpMappingDetail.uniform_sub_cat_id)
      this.loadActiveEmployeesForProject(this.lUniformOutwardBase.proj_id)
      this.lUniformBulkDistributionEmpMappingDetail.old_qty = curBulkEmpMappingDetail.qty
      this.lUniformBulkDistributionEmpMappingDetail.proj_id = this.lUniformOutwardBase.proj_id
      this.lUniformBulkDistributionEmpMappingDetail.mapping_date = handy.formatDBDate(curBulkEmpMappingDetail.mapping_date)
      this.lUniformBulkDistributionEmpMappingDetail.empmap_emp_id = curBulkEmpMappingDetail.emp_id
      this.lUniformBulkDistributionEmpMappingDetail.uniform_size_id = curBulkEmpMappingDetail.uniform_size_id
      this.lUniformBulkDistributionEmpMappingDetail.available_stock = this.uniformBulkDistributionDetailForID.balance_qty
      this.lUniformBulkDistributionEmpMappingDetail.vendor_id = config.VENDOR_ID
      this.lUniformBulkDistributionEmpMappingDetail.emp_id = config.EMP_ID
      this.lMAction = 'update'
      this.manageUniformEmpMappingDetail = true
    },
    saveUniformEmpMappingDetail(action) {
      var qry = {
        params: {
          uniform_outward_base_id: this.lUniformOutwardBase.uniform_outward_base_id,
          proj_id: this.lUniformOutwardBase.proj_id,
          uniform_bulk_outward_det_id: this.lUniformBulkDistributionEmpMappingDetail.uniform_bulk_outward_det_id,
          outward_date: this.lUniformBulkDistributionEmpMappingDetail.mapping_date,
          outward_emp_id: this.lUniformBulkDistributionEmpMappingDetail.empmap_emp_id,
          designation: this.lUniformBulkDistributionEmpMappingDetail.designation,
          uniform_cat_id: this.lUniformBulkDistributionEmpMappingDetail.uniform_cat_id,
          uniform_sub_cat_id: this.lUniformBulkDistributionEmpMappingDetail.uniform_sub_cat_id,
          uniform_size_id: this.lUniformBulkDistributionEmpMappingDetail.uniform_size_id,
          qty: this.lUniformBulkDistributionEmpMappingDetail.qty,
          uniform_stock_sequence_id: this.lUniformBulkDistributionEmpMappingDetail.uniform_stock_sequence_id,
          unit_rate: this.lUniformBulkDistributionEmpMappingDetail.unit_rate,
          v_action: action,
          old_qty: this.lUniformBulkDistributionEmpMappingDetail.old_qty,
          vendor_id: config.VENDOR_ID,
          emp_id: config.EMP_ID
        }
      }
      if (this.$refs.lFormUniformEmpMappingDetail.validate()) {
        if (!this.lUniformBulkDistributionEmpMappingDetail.proj_id || !this.lUniformBulkDistributionEmpMappingDetail.mapping_date || !this.lUniformBulkDistributionEmpMappingDetail.empmap_emp_id || !this.lUniformBulkDistributionEmpMappingDetail.designation || !this.lUniformBulkDistributionEmpMappingDetail.uniform_cat_id || !this.lUniformBulkDistributionEmpMappingDetail.uniform_sub_cat_id || !this.lUniformBulkDistributionEmpMappingDetail.uniform_size_id || !this.lUniformBulkDistributionEmpMappingDetail.qty || this.lUniformBulkDistributionEmpMappingDetail.qty <= 0 || !this.lUniformBulkDistributionEmpMappingDetail.uniform_stock_sequence_id) {
          this.msg('Please enter all the given fields', 0)
        } else {
          this.axios.get(config.API_URL + '/getUniformOutwardDetailExistsForEmployeeForDate/', qry)
          .then(resp => {
            if (resp.data.length > 0 && action === 'create') {
              this.msg('Uniform already distributed to selected employee for selected date', 0)
            } else {
              // Check the total available stock for the combination
              // if the stock is available proceed with entered qty
              // if stock is not enough show message to enter the qty with in the stock limit
              this.axios.get(config.API_URL + '/getIsBulkDistributionStockExistsForID/', qry)
              .then(respon => {
                if (respon.data.result === 'ERROR') {
                  this.msg(respon.data.msg, 0)
                } else {
                  this.axios.post(config.API_URL + '/uniformBulkEmpMappingDetail/' + action, this.lUniformBulkDistributionEmpMappingDetail)
                  .then(response => {
                    this.loadUniformBulkDistributionDetailByID(this.lUniformBulkDistributionEmpMappingDetail.uniform_bulk_outward_det_id)
                    this.loadUniformBulkDistributionEmpMappingDetailsByID(this.lUniformBulkDistributionEmpMappingDetail.uniform_bulk_outward_det_id)
                    this.loadUniformOutwardDetail(this.lUniformOutwardBase)
                    this.loadUniformBulkDistributionDetail(this.lUniformOutwardBase)
                    if (action === 'create') {
                      this.msg('Saved Successfully', 1)
                    }
                    if (action === 'update') {
                      if (response.data.result === 'SUCCESS') {
                        this.msg('Saved Successfully', 1)
                      } else {
                        this.msg(response.data.msg, 0)
                      }
                    }
                    this.beingSaved = false
                    this.manageUniformEmpMappingDetail = false
                    this.lMAction = 'update'
                  })
                  .catch(err => {
                    this.msg(err, 0)
                    this.beingSaved = false
                  })
                }
              })
              .catch(err => {
                this.msg(err, 0)
                this.beingSaved = false
              })
            }
          })
          .catch(err => {
            this.msg(err, 0)
            this.beingSaved = false
          })
        }
      } else {
        this.msg('Please enter all the given fields', 0)
      }
    },
    deleteUniformEmpMappingDetail (curBulkEmpMappingDetail) {
      if (!confirm('Sure, you want to delete the employee mapping : "' + curBulkEmpMappingDetail.emp_name_with_id + ' -> ' + curBulkEmpMappingDetail.uniform_sub_cat +  ' -> ' + curBulkEmpMappingDetail.uniform_size + ' "?')) {
        return
      }
      this.beingSaved = true
      this.axios.post(config.API_URL + '/uniformBulkEmpMappingDetail/delete', curBulkEmpMappingDetail)
      .then(response => {
        if (response.data.result === 'SUCCESS') {
          this.msg('Deleted Successfully', 1)
          this.loadUniformBulkDistributionDetailByID(curBulkEmpMappingDetail.uniform_bulk_outward_det_id)
          this.loadUniformBulkDistributionEmpMappingDetailsByID(curBulkEmpMappingDetail.uniform_bulk_outward_det_id)
          this.loadUniformOutwardDetail(this.lUniformOutwardBase)
          this.loadUniformBulkDistributionDetail(this.lUniformOutwardBase)
          this.manageUniformEmpMappingDetail = false
          this.lMAction = 'view'
        } else {
          this.msg(response.data.msg, 0)
        }
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    cancelChangesUniformEmpMappingDetail() {
      this.manageUniformEmpMappingDetail = false
    },
    loadEmpMappingOutwardDetailIdForOutwardBaseId (curUniform_outward_base_id) {
      var qry = {
        params: {
          uniform_outward_base_id: curUniform_outward_base_id,
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUniformEmpMapOutwardDetailIdsForOutwardBaseId/', qry)
      .then(response => {
        this.uniformEmpMappingOutwarDetailIDs = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    // Uniform Report Declarations
    loadSubCatWiseStockReport () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.uniformReportSubCatWiseStock = []
      this.axios.get(config.API_URL + '/getSubCatWiseStockReport/', qry)
      .then(response => {
        var tot_inward_qty = 0
        var tot_outward_qty = 0
        var tot_balance_qty = 0
        var g_tot_inward_qty = 0
        var g_tot_outward_qty = 0
        var g_tot_balance_qty = 0

        var rec_length = response.data[0].length

        for(var i = 0; i < response.data[0].length; i++) {
          if(i < rec_length-1) {
            if(response.data[0][i].uniform_sub_cat_id != response.data[0][i+1].uniform_sub_cat_id) {
              this.uniformReportSubCatWiseStock.push({
                sno: i+1,
                uniform_sub_cat_id: response.data[0][i].uniform_sub_cat_id,
                uniform_sub_cat: response.data[0][i].uniform_sub_cat,
                uniform_size_id: response.data[0][i].uniform_size_id,
                uniform_size: response.data[0][i].uniform_size,
                inward_qty: response.data[0][i].inward_qty,
                outward_qty: response.data[0][i].outward_qty,
                stock_qty: response.data[0][i].stock_qty
              })

              tot_inward_qty += response.data[0][i].inward_qty
              tot_outward_qty += response.data[0][i].outward_qty
              tot_balance_qty += response.data[0][i].stock_qty
              g_tot_inward_qty += response.data[0][i].inward_qty
              g_tot_outward_qty += response.data[0][i].outward_qty
              g_tot_balance_qty += response.data[0][i].stock_qty

              this.uniformReportSubCatWiseStock.push({
                sno: '',
                uniform_sub_cat_id: 0,
                uniform_sub_cat: '',
                uniform_size_id: 0,
                uniform_size: 'Sub-Total',
                inward_qty: tot_inward_qty,
                outward_qty: tot_outward_qty,
                stock_qty: tot_balance_qty
              })
              tot_inward_qty = 0
              tot_outward_qty = 0
              tot_balance_qty = 0
            } else {
              this.uniformReportSubCatWiseStock.push({
                sno: i+1,
                uniform_sub_cat_id: response.data[0][i].uniform_sub_cat_id,
                uniform_sub_cat: response.data[0][i].uniform_sub_cat,
                uniform_size_id: response.data[0][i].uniform_size_id,
                uniform_size: response.data[0][i].uniform_size,
                inward_qty: response.data[0][i].inward_qty,
                outward_qty: response.data[0][i].outward_qty,
                stock_qty: response.data[0][i].stock_qty
              })
              tot_inward_qty += response.data[0][i].inward_qty
              tot_outward_qty += response.data[0][i].outward_qty
              tot_balance_qty += response.data[0][i].stock_qty
              g_tot_inward_qty += response.data[0][i].inward_qty
              g_tot_outward_qty += response.data[0][i].outward_qty
              g_tot_balance_qty += response.data[0][i].stock_qty
            }
          } else {
            this.uniformReportSubCatWiseStock.push({
              sno: i+1,
              uniform_sub_cat_id: response.data[0][i].uniform_sub_cat_id,
              uniform_sub_cat: response.data[0][i].uniform_sub_cat,
              uniform_size_id: response.data[0][i].uniform_size_id,
              uniform_size: response.data[0][i].uniform_size,
              inward_qty: response.data[0][i].inward_qty,
              outward_qty: response.data[0][i].outward_qty,
              stock_qty: response.data[0][i].stock_qty
            })
            tot_inward_qty += response.data[0][i].inward_qty
            tot_outward_qty += response.data[0][i].outward_qty
            tot_balance_qty += response.data[0][i].stock_qty
            g_tot_inward_qty += response.data[0][i].inward_qty
            g_tot_outward_qty += response.data[0][i].outward_qty
            g_tot_balance_qty += response.data[0][i].stock_qty

            this.uniformReportSubCatWiseStock.push({
              sno: '',
              uniform_sub_cat_id: 0,
              uniform_sub_cat: '',
              uniform_size_id: 0,
              uniform_size: 'Sub-Total',
              inward_qty: tot_inward_qty,
              outward_qty: tot_outward_qty,
              stock_qty: tot_balance_qty
            })
            tot_inward_qty = 0
            tot_outward_qty = 0
            tot_balance_qty = 0
          }
        }
        this.uniformReportSubCatWiseStock.push({
          sno: '',
          uniform_sub_cat_id: 0,
          uniform_sub_cat: '',
          uniform_size_id: 0,
          uniform_size: 'Grand-Total',
          inward_qty: g_tot_inward_qty,
          outward_qty: g_tot_outward_qty,
          stock_qty: g_tot_balance_qty
        })
        this.lAction = 'subcat-stockreport'
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadEmpWiseDistributionReportBase() {
      var curDate = new Date()
      this.lUniformEmpWiseDistributionReport.proj_id_pair = {proj_id: null, proj_name: null}
      this.lUniformEmpWiseDistributionReport.emp_id_pair = {emp_id: null, emp_name_with_id: null}
      this.lUniformEmpWiseDistributionReport.from_date = handy.formatDBDate(new Date(curDate.getFullYear(), curDate.getMonth(), 1))
      this.lUniformEmpWiseDistributionReport.to_date = handy.formatDBDate(new Date(curDate.getFullYear(), curDate.getMonth() + 1, 0))
      this.uniformReportEmployeeWiseDistribution = []
      this.loadAllMaintenanceProjects()
      this.loadAllEmployees()
      this.lAction = 'empwise-distribreport'
    },
    loadEmpWiseDistributionReport (curUniformEmpWiseDistributionReport) {
      if(curUniformEmpWiseDistributionReport.from_date != null && curUniformEmpWiseDistributionReport.to_date === null) {
        curUniformEmpWiseDistributionReport.to_date = curUniformEmpWiseDistributionReport.from_date
      }
      if(curUniformEmpWiseDistributionReport.to_date != null && curUniformEmpWiseDistributionReport.from_date === null) {
        curUniformEmpWiseDistributionReport.from_date = curUniformEmpWiseDistributionReport.to_date
      }
      var qry = {
        params: {
          proj_id: curUniformEmpWiseDistributionReport.proj_id_pair? curUniformEmpWiseDistributionReport.proj_id_pair.proj_id : null,
          emp_id: curUniformEmpWiseDistributionReport.emp_id_pair? curUniformEmpWiseDistributionReport.emp_id_pair.emp_id : null,
          from_date: curUniformEmpWiseDistributionReport.from_date,
          to_date: curUniformEmpWiseDistributionReport.to_date,
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getEmpWiseDistributionReport/', qry)
      .then(response => {
        this.uniformReportEmployeeWiseDistribution = response.data
        this.empwisedistrichipselection = 'All'
        this.lAction = 'empwise-distribreport'
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadAllMaintenanceProjects () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getAllMaintenanceProject/', qry)
      .then(response => {
        this.uniformAllProjects = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadAllEmployees() {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getEmployeeByVendorId/', qry)
      .then(response => {
        this.uniformAllEmployees = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadStockValueReport () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.uniformStockValueReport = []
      this.axios.get(config.API_URL + '/getStockValueReport/', qry)
      .then(response => {
        var tot_inward_qty = 0
        var tot_outward_qty = 0
        var tot_balance_qty = 0
        var tot_stock_value = 0
        var g_tot_inward_qty = 0
        var g_tot_outward_qty = 0
        var g_tot_balance_qty = 0
        var g_tot_stock_value = 0

        var rec_length = response.data.length

        for(var i = 0; i < response.data.length; i++) {
          if(i < rec_length-1) {
            if(response.data[i].uniform_sub_cat_id != response.data[i+1].uniform_sub_cat_id) {
              this.uniformStockValueReport.push({
                sno: i+1,
                uniform_sub_cat_id: response.data[i].uniform_sub_cat_id,
                uniform_sub_cat: response.data[i].uniform_sub_cat,
                uniform_size_id: response.data[i].uniform_size_id,
                uniform_size: response.data[i].uniform_size,
                inward_qty: response.data[i].inward_qty,
                outward_qty: response.data[i].outward_qty,
                stock_qty: response.data[i].stock_qty,
                stock_value: response.data[i].stock_value
              })

              tot_inward_qty += response.data[i].inward_qty
              tot_outward_qty += response.data[i].outward_qty
              tot_balance_qty += response.data[i].stock_qty
              tot_stock_value += response.data[i].stock_value
              g_tot_inward_qty += response.data[i].inward_qty
              g_tot_outward_qty += response.data[i].outward_qty
              g_tot_balance_qty += response.data[i].stock_qty
              g_tot_stock_value += response.data[i].stock_value

              this.uniformStockValueReport.push({
                sno: '',
                uniform_sub_cat_id: 0,
                uniform_sub_cat: '',
                uniform_size_id: 0,
                uniform_size: 'Sub-Total',
                inward_qty: tot_inward_qty,
                outward_qty: tot_outward_qty,
                stock_qty: tot_balance_qty,
                stock_value: tot_stock_value
              })
              tot_inward_qty = 0
              tot_outward_qty = 0
              tot_balance_qty = 0
              tot_stock_value = 0
            } else {
              this.uniformStockValueReport.push({
                sno: i+1,
                uniform_sub_cat_id: response.data[i].uniform_sub_cat_id,
                uniform_sub_cat: response.data[i].uniform_sub_cat,
                uniform_size_id: response.data[i].uniform_size_id,
                uniform_size: response.data[i].uniform_size,
                inward_qty: response.data[i].inward_qty,
                outward_qty: response.data[i].outward_qty,
                stock_qty: response.data[i].stock_qty,
                stock_value: response.data[i].stock_value
              })
              tot_inward_qty += response.data[i].inward_qty
              tot_outward_qty += response.data[i].outward_qty
              tot_balance_qty += response.data[i].stock_qty
              tot_stock_value += response.data[i].stock_value
              g_tot_inward_qty += response.data[i].inward_qty
              g_tot_outward_qty += response.data[i].outward_qty
              g_tot_balance_qty += response.data[i].stock_qty
              g_tot_stock_value += response.data[i].stock_value
            }
          } else {
            this.uniformStockValueReport.push({
              sno: i+1,
              uniform_sub_cat_id: response.data[i].uniform_sub_cat_id,
              uniform_sub_cat: response.data[i].uniform_sub_cat,
              uniform_size_id: response.data[i].uniform_size_id,
              uniform_size: response.data[i].uniform_size,
              inward_qty: response.data[i].inward_qty,
              outward_qty: response.data[i].outward_qty,
              stock_qty: response.data[i].stock_qty,
              stock_value: response.data[i].stock_value
            })
            tot_inward_qty += response.data[i].inward_qty
            tot_outward_qty += response.data[i].outward_qty
            tot_balance_qty += response.data[i].stock_qty
            tot_stock_value += response.data[i].stock_value
            g_tot_inward_qty += response.data[i].inward_qty
            g_tot_outward_qty += response.data[i].outward_qty
            g_tot_balance_qty += response.data[i].stock_qty
            g_tot_stock_value += response.data[i].stock_value

            this.uniformStockValueReport.push({
              sno: '',
              uniform_sub_cat_id: 0,
              uniform_sub_cat: '',
              uniform_size_id: 0,
              uniform_size: 'Sub-Total',
              inward_qty: tot_inward_qty,
              outward_qty: tot_outward_qty,
              stock_qty: tot_balance_qty,
              stock_value: tot_stock_value
            })
            tot_inward_qty = 0
            tot_outward_qty = 0
            tot_balance_qty = 0
            tot_stock_value = 0
          }
        }
        this.uniformStockValueReport.push({
          sno: '',
          uniform_sub_cat_id: 0,
          uniform_sub_cat: '',
          uniform_size_id: 0,
          uniform_size: 'Grand-Total',
          inward_qty: g_tot_inward_qty,
          outward_qty: g_tot_outward_qty,
          stock_qty: g_tot_balance_qty,
          stock_value: g_tot_stock_value
        })
        this.lAction = 'stock-value-report'
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadStockSequenceStockReport () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.uniformStockSequenceWiseReport = []
      this.axios.get(config.API_URL + '/getStockSequenceWiseReport/', qry)
      .then(response => {
        var tot_inward_qty = 0
        var tot_outward_qty = 0
        var tot_balance_qty = 0
        var g_tot_inward_qty = 0
        var g_tot_outward_qty = 0
        var g_tot_balance_qty = 0

        var rec_length = response.data[0].length

        for(var i = 0; i < response.data[0].length; i++) {
          if(i < rec_length-1) {
            if(response.data[0][i].uniform_sub_cat_id != response.data[0][i+1].uniform_sub_cat_id) {
              this.uniformStockSequenceWiseReport.push({
                sno: i+1,
                uniform_sub_cat_id: response.data[0][i].uniform_sub_cat_id,
                uniform_sub_cat: response.data[0][i].uniform_sub_cat,
                uniform_size_id: response.data[0][i].uniform_size_id,
                uniform_size: response.data[0][i].uniform_size,
                unit: response.data[0][i].unit,
                unit_rate: response.data[0][i].unit_rate,
                tax_percent: response.data[0][i].tax_percent,
                inward_qty: response.data[0][i].inward_qty,
                outward_qty: response.data[0][i].outward_qty,
                stock_qty: response.data[0][i].stock_qty
              })

              tot_inward_qty += response.data[0][i].inward_qty
              tot_outward_qty += response.data[0][i].outward_qty
              tot_balance_qty += response.data[0][i].stock_qty
              g_tot_inward_qty += response.data[0][i].inward_qty
              g_tot_outward_qty += response.data[0][i].outward_qty
              g_tot_balance_qty += response.data[0][i].stock_qty

              this.uniformStockSequenceWiseReport.push({
                sno: '',
                uniform_sub_cat_id: 0,
                uniform_sub_cat: '',
                uniform_size_id: 0,
                uniform_size: '',
                unit: '',
                unit_rate: 'Sub-Total',
                tax_percent: '',
                inward_qty: tot_inward_qty,
                outward_qty: tot_outward_qty,
                stock_qty: tot_balance_qty
              })
              tot_inward_qty = 0
              tot_outward_qty = 0
              tot_balance_qty = 0
            } else {
              this.uniformStockSequenceWiseReport.push({
                sno: i+1,
                uniform_sub_cat_id: response.data[0][i].uniform_sub_cat_id,
                uniform_sub_cat: response.data[0][i].uniform_sub_cat,
                uniform_size_id: response.data[0][i].uniform_size_id,
                uniform_size: response.data[0][i].uniform_size,
                unit: response.data[0][i].unit,
                unit_rate: response.data[0][i].unit_rate,
                tax_percent: response.data[0][i].tax_percent,
                inward_qty: response.data[0][i].inward_qty,
                outward_qty: response.data[0][i].outward_qty,
                stock_qty: response.data[0][i].stock_qty
              })
              tot_inward_qty += response.data[0][i].inward_qty
              tot_outward_qty += response.data[0][i].outward_qty
              tot_balance_qty += response.data[0][i].stock_qty
              g_tot_inward_qty += response.data[0][i].inward_qty
              g_tot_outward_qty += response.data[0][i].outward_qty
              g_tot_balance_qty += response.data[0][i].stock_qty
            }
          } else {
            this.uniformStockSequenceWiseReport.push({
              sno: i+1,
              uniform_sub_cat_id: response.data[0][i].uniform_sub_cat_id,
              uniform_sub_cat: response.data[0][i].uniform_sub_cat,
              uniform_size_id: response.data[0][i].uniform_size_id,
              uniform_size: response.data[0][i].uniform_size,
              unit: response.data[0][i].unit,
              unit_rate: response.data[0][i].unit_rate,
              tax_percent: response.data[0][i].tax_percent,
              inward_qty: response.data[0][i].inward_qty,
              outward_qty: response.data[0][i].outward_qty,
              stock_qty: response.data[0][i].stock_qty
            })
            tot_inward_qty += response.data[0][i].inward_qty
            tot_outward_qty += response.data[0][i].outward_qty
            tot_balance_qty += response.data[0][i].stock_qty
            g_tot_inward_qty += response.data[0][i].inward_qty
            g_tot_outward_qty += response.data[0][i].outward_qty
            g_tot_balance_qty += response.data[0][i].stock_qty

            this.uniformStockSequenceWiseReport.push({
              sno: '',
              uniform_sub_cat_id: 0,
              uniform_sub_cat: '',
              uniform_size_id: 0,
              uniform_size: '',
              unit: '',
              unit_rate: 'Sub-Total',
              tax_percent: '',
              inward_qty: tot_inward_qty,
              outward_qty: tot_outward_qty,
              stock_qty: tot_balance_qty
            })
            tot_inward_qty = 0
            tot_outward_qty = 0
            tot_balance_qty = 0
          }
        }
        this.uniformStockSequenceWiseReport.push({
          sno: '',
          uniform_sub_cat_id: 0,
          uniform_sub_cat: '',
          uniform_size_id: 0,
          uniform_size: '',
          unit: '',
          unit_rate: 'Grand-Total',
          tax_percent: '',
          inward_qty: g_tot_inward_qty,
          outward_qty: g_tot_outward_qty,
          stock_qty: g_tot_balance_qty
        })
        this.lAction = 'stocksequence-stockreport'
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadSubCatWiseSequenceStock_temp () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.uniformStockSequenceTableReport = []
      this.axios.get(config.API_URL + '/getSubCatWiseSequenceStockTable/', qry)
      .then(response => {
        for(var i = 0; i < response.data.length; i++) {
          this.uniformStockSequenceTableReport.push({
            sno: i+1,
            uniform_sub_cat: response.data[i].uniform_sub_cat,
            uniform_size: response.data[i].uniform_size,
            cur_stock: response.data[i].cur_stock,
          })
        }
        this.lAction = 'stocksequence-tabledata-temp'
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadStockSequenceAuditLog () {
      var qry = {
        params: {
          report_type: 'stock-sequence-audit-log',
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUniformTrackingAuditLogs/', qry)
      .then(response => {
        this.uniformStockSequenceAuditLog = response.data[0]
        this.lAction = 'stocksequence-auditlog'
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadInwardAuditLog () {
      var qry = {
        params: {
          report_type: 'inward-audit-log',
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUniformTrackingAuditLogs/', qry)
      .then(response => {
        this.uniformInwardAuditLog = response.data[0]
        this.lAction = 'inward-auditlog'
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadOutwardAuditLog () {
      var qry = {
        params: {
          report_type: 'outward-audit-log',
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUniformTrackingAuditLogs/', qry)
      .then(response => {
        this.uniformOutwardAuditLog = response.data[0]
        this.lAction = 'outward-auditlog'
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadBulkOutwardAuditLog () {
      var qry = {
        params: {
          report_type: 'bulk-outward-audit-log',
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUniformTrackingAuditLogs/', qry)
      .then(response => {
        this.uniformBulkOutwardAuditLog = response.data[0]
        this.lAction = 'bulk-outward-auditlog'
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadUniformAllProjectsDistributionReports () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUniformAllProjectsDistributionReports/', qry)
      .then(response => {
        this.uniformProjectWiseDistributionSummaryReport = response.data
        this.lAction = 'all-projectwise-distribution-summary'
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadUniformProjectwiseMonthlyDistributionReports (curItem) {
      var qry = {
        params: {
          proj_id: curItem.proj_id,
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUniformProjectwiseMonthlyDistributionReports/', qry)
      .then(response => {
        this.uniformProjectWiseMonthlyDistributionSummaryReport = response.data
        this.lAction = 'projectwise-month-distribution-summary'
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadUniformEmpWiseDistributionChipFilter (chipname) {
      this.empwisedistrichipselection = chipname
    },
    loadUniformMonthlyDistributionSummaryReportBase() {
      var curDate = new Date()
      this.lUniformMonthlyDistributionSummaryReport.uniform_cat_pair = {uniform_cat_id: null, uniform_cat: null}
      this.lUniformMonthlyDistributionSummaryReport.uniform_sub_cat_pair = {uniform_sub_cat_id: null, uniform_sub_cat: null}
      this.lUniformMonthlyDistributionSummaryReport.from_date = handy.formatDBDate(new Date(curDate.getFullYear(), curDate.getMonth(), 1))
      this.lUniformMonthlyDistributionSummaryReport.to_date = handy.formatDBDate(new Date(curDate.getFullYear(), curDate.getMonth() + 1, 0))
      this.uniformMonthlyDistributionSummaryReport = []
      this.loadUniformCategoryForReport()
      this.loadUniformSubCat()
      this.lAction = 'monthly-distribution-summary'
    },
    loadUniformCategoryForReport () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUniformCategory/', qry)
      .then(response => {
        this.uniformCatRpt = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadUniformMonthlyDistributionSummaryReport(curUniformMonthlyDistributionSummaryReport) {
      if(curUniformMonthlyDistributionSummaryReport.from_date != null && curUniformMonthlyDistributionSummaryReport.to_date === null) {
        curUniformMonthlyDistributionSummaryReport.to_date = curUniformMonthlyDistributionSummaryReport.from_date
      }
      if(curUniformMonthlyDistributionSummaryReport.to_date != null && curUniformMonthlyDistributionSummaryReport.from_date === null) {
        curUniformMonthlyDistributionSummaryReport.from_date = curUniformMonthlyDistributionSummaryReport.to_date
      }
      var qry = {
        params: {
          uniform_cat_id: curUniformMonthlyDistributionSummaryReport.uniform_cat_pair? curUniformMonthlyDistributionSummaryReport.uniform_cat_pair.uniform_cat_id : null,
          uniform_sub_cat_id: curUniformMonthlyDistributionSummaryReport.uniform_sub_cat_pair? curUniformMonthlyDistributionSummaryReport.uniform_sub_cat_pair.uniform_sub_cat_id : null,
          from_date: curUniformMonthlyDistributionSummaryReport.from_date,
          to_date: curUniformMonthlyDistributionSummaryReport.to_date,
          vendor_id: config.VENDOR_ID
        }
      }
      this.uniformMonthlyDistributionSummaryReport = []
      this.axios.get(config.API_URL + '/getUniformMonthlyDistributionSummaryReport/', qry)
      .then(response => {
        // this.uniformMonthlyDistributionSummaryReport = response.data
        var tot_outward_qty = 0
        var tot_amt_bf_tax = 0
        var tot_tax_amount = 0
        var tot_amt_af_tax = 0
        var tot_bulk_outward_qty = 0
        var tot_bulk_pending_qty = 0
        var tot_bulk_amt_bf_tax = 0
        var tot_bulk_tax_amount = 0
        var tot_bulk_amt_af_tax = 0
        var tot_grand_amount = 0

        var g_tot_outward_qty = 0
        var g_tot_amt_bf_tax = 0
        var g_tot_tax_amount = 0
        var g_tot_amt_af_tax = 0
        var g_tot_bulk_outward_qty = 0
        var g_tot_bulk_pending_qty = 0
        var g_tot_bulk_amt_bf_tax = 0
        var g_tot_bulk_tax_amount = 0
        var g_tot_bulk_amt_af_tax = 0
        var g_tot_grand_amount = 0

        var rec_length = response.data.length

        for(var i = 0; i < response.data.length; i++) {
          if(i < rec_length-1) {
            if(response.data[i].outward_date != response.data[i+1].outward_date || response.data[i].proj_id != response.data[i+1].proj_id) {
              this.uniformMonthlyDistributionSummaryReport.push({
                sno: i+1,
                outward_date: response.data[i].outward_date,
                proj_id: response.data[i].proj_id,
                proj_name: response.data[i].proj_name,
                uniform_cat_id: response.data[i].uniform_cat_id,
                uniform_cat: response.data[i].uniform_cat,
                uniform_sub_cat_id: response.data[i].uniform_sub_cat_id,
                uniform_sub_cat: response.data[i].uniform_sub_cat,
                outward_qty: response.data[i].outward_qty,
                amount: response.data[i].amount,
                tax_amount: response.data[i].tax_amount,
                total_amount: response.data[i].total_amount,
                bulk_outward_qty: response.data[i].bulk_outward_qty,
                bulk_pending_qty: response.data[i].bulk_pending_qty,
                bulk_amount: response.data[i].bulk_amount,
                bulk_tax_amount: response.data[i].bulk_tax_amount,
                bulk_total_amount: response.data[i].bulk_total_amount,
                grand_total_amount: response.data[i].grand_total_amount
              })

              tot_outward_qty += response.data[i].outward_qty
              tot_amt_bf_tax += response.data[i].amount
              tot_tax_amount += response.data[i].tax_amount
              tot_amt_af_tax += response.data[i].total_amount
              tot_bulk_outward_qty += response.data[i].bulk_outward_qty
              tot_bulk_pending_qty += response.data[i].bulk_pending_qty
              tot_bulk_amt_bf_tax += response.data[i].bulk_amount
              tot_bulk_tax_amount += response.data[i].bulk_tax_amount
              tot_bulk_amt_af_tax += response.data[i].bulk_total_amount
              tot_grand_amount += response.data[i].grand_total_amount

              g_tot_outward_qty += response.data[i].outward_qty
              g_tot_amt_bf_tax += response.data[i].amount
              g_tot_tax_amount += response.data[i].tax_amount
              g_tot_amt_af_tax += response.data[i].total_amount
              g_tot_bulk_outward_qty += response.data[i].bulk_outward_qty
              g_tot_bulk_pending_qty += response.data[i].bulk_pending_qty
              g_tot_bulk_amt_bf_tax += response.data[i].bulk_amount
              g_tot_bulk_tax_amount += response.data[i].bulk_tax_amount
              g_tot_bulk_amt_af_tax += response.data[i].bulk_total_amount
              g_tot_grand_amount += response.data[i].grand_total_amount

              this.uniformMonthlyDistributionSummaryReport.push({
                sno: '',
                outward_date: '',
                proj_id: 0,
                proj_name: '',
                uniform_cat_id: 0,
                uniform_cat: '',
                uniform_sub_cat_id: 0,
                uniform_sub_cat: 'Sub-Total',
                outward_qty: tot_outward_qty,
                amount: tot_amt_bf_tax,
                tax_amount: tot_tax_amount,
                total_amount: tot_amt_af_tax,
                bulk_outward_qty: tot_bulk_outward_qty,
                bulk_pending_qty: tot_bulk_pending_qty,
                bulk_amount: tot_bulk_amt_bf_tax,
                bulk_tax_amount: tot_bulk_tax_amount,
                bulk_total_amount: tot_bulk_amt_af_tax,
                grand_total_amount: tot_grand_amount
              })
              tot_outward_qty = 0
              tot_amt_bf_tax = 0
              tot_tax_amount = 0
              tot_amt_af_tax = 0
              tot_bulk_outward_qty = 0
              tot_bulk_pending_qty = 0
              tot_bulk_amt_bf_tax = 0
              tot_bulk_tax_amount = 0
              tot_bulk_amt_af_tax = 0
              tot_grand_amount = 0
            } else {
              this.uniformMonthlyDistributionSummaryReport.push({
                sno: i+1,
                outward_date: response.data[i].outward_date,
                proj_id: response.data[i].proj_id,
                proj_name: response.data[i].proj_name,
                uniform_cat_id: response.data[i].uniform_cat_id,
                uniform_cat: response.data[i].uniform_cat,
                uniform_sub_cat_id: response.data[i].uniform_sub_cat_id,
                uniform_sub_cat: response.data[i].uniform_sub_cat,
                outward_qty: response.data[i].outward_qty,
                amount: response.data[i].amount,
                tax_amount: response.data[i].tax_amount,
                total_amount: response.data[i].total_amount,
                bulk_outward_qty: response.data[i].bulk_outward_qty,
                bulk_pending_qty: response.data[i].bulk_pending_qty,
                bulk_amount: response.data[i].bulk_amount,
                bulk_tax_amount: response.data[i].bulk_tax_amount,
                bulk_total_amount: response.data[i].bulk_total_amount,
                grand_total_amount: response.data[i].grand_total_amount
              })
              tot_outward_qty += response.data[i].outward_qty
              tot_amt_bf_tax += response.data[i].amount
              tot_tax_amount += response.data[i].tax_amount
              tot_amt_af_tax += response.data[i].total_amount
              tot_bulk_outward_qty += response.data[i].bulk_outward_qty
              tot_bulk_pending_qty += response.data[i].bulk_pending_qty
              tot_bulk_amt_bf_tax += response.data[i].bulk_amount
              tot_bulk_tax_amount += response.data[i].bulk_tax_amount
              tot_bulk_amt_af_tax += response.data[i].bulk_total_amount
              tot_grand_amount += response.data[i].grand_total_amount

              g_tot_outward_qty += response.data[i].outward_qty
              g_tot_amt_bf_tax += response.data[i].amount
              g_tot_tax_amount += response.data[i].tax_amount
              g_tot_amt_af_tax += response.data[i].total_amount
              g_tot_bulk_outward_qty += response.data[i].bulk_outward_qty
              g_tot_bulk_pending_qty += response.data[i].bulk_pending_qty
              g_tot_bulk_amt_bf_tax += response.data[i].bulk_amount
              g_tot_bulk_tax_amount += response.data[i].bulk_tax_amount
              g_tot_bulk_amt_af_tax += response.data[i].bulk_total_amount
              g_tot_grand_amount += response.data[i].grand_total_amount
            }
          } else {
            this.uniformMonthlyDistributionSummaryReport.push({
              sno: i+1,
              outward_date: response.data[i].outward_date,
              proj_id: response.data[i].proj_id,
              proj_name: response.data[i].proj_name,
              uniform_cat_id: response.data[i].uniform_cat_id,
              uniform_cat: response.data[i].uniform_cat,
              uniform_sub_cat_id: response.data[i].uniform_sub_cat_id,
              uniform_sub_cat: response.data[i].uniform_sub_cat,
              outward_qty: response.data[i].outward_qty,
              amount: response.data[i].amount,
              tax_amount: response.data[i].tax_amount,
              total_amount: response.data[i].total_amount,
              bulk_outward_qty: response.data[i].bulk_outward_qty,
              bulk_pending_qty: response.data[i].bulk_pending_qty,
              bulk_amount: response.data[i].bulk_amount,
              bulk_tax_amount: response.data[i].bulk_tax_amount,
              bulk_total_amount: response.data[i].bulk_total_amount,
              grand_total_amount: response.data[i].grand_total_amount
            })
            tot_outward_qty += response.data[i].outward_qty
            tot_amt_bf_tax += response.data[i].amount
            tot_tax_amount += response.data[i].tax_amount
            tot_amt_af_tax += response.data[i].total_amount
            tot_bulk_outward_qty += response.data[i].bulk_outward_qty
            tot_bulk_pending_qty += response.data[i].bulk_pending_qty
            tot_bulk_amt_bf_tax += response.data[i].bulk_amount
            tot_bulk_tax_amount += response.data[i].bulk_tax_amount
            tot_bulk_amt_af_tax += response.data[i].bulk_total_amount
            tot_grand_amount += response.data[i].grand_total_amount

            g_tot_outward_qty += response.data[i].outward_qty
            g_tot_amt_bf_tax += response.data[i].amount
            g_tot_tax_amount += response.data[i].tax_amount
            g_tot_amt_af_tax += response.data[i].total_amount
            g_tot_bulk_outward_qty += response.data[i].bulk_outward_qty
            g_tot_bulk_pending_qty += response.data[i].bulk_pending_qty
            g_tot_bulk_amt_bf_tax += response.data[i].bulk_amount
            g_tot_bulk_tax_amount += response.data[i].bulk_tax_amount
            g_tot_bulk_amt_af_tax += response.data[i].bulk_total_amount
            g_tot_grand_amount += response.data[i].grand_total_amount

            this.uniformMonthlyDistributionSummaryReport.push({
              sno: '',
              outward_date: '',
              proj_id: 0,
              proj_name: '',
              uniform_cat_id: 0,
              uniform_cat: '',
              uniform_sub_cat_id: 0,
              uniform_sub_cat: 'Sub-Total',
              outward_qty: tot_outward_qty,
              amount: tot_amt_bf_tax,
              tax_amount: tot_tax_amount,
              total_amount: tot_amt_af_tax,
              bulk_outward_qty: tot_bulk_outward_qty,
              bulk_pending_qty: tot_bulk_pending_qty,
              bulk_amount: tot_bulk_amt_bf_tax,
              bulk_tax_amount: tot_bulk_tax_amount,
              bulk_total_amount: tot_bulk_amt_af_tax,
              grand_total_amount: tot_grand_amount
            })
            tot_outward_qty = 0
            tot_amt_bf_tax = 0
            tot_tax_amount = 0
            tot_amt_af_tax = 0
            tot_bulk_outward_qty = 0
            tot_bulk_pending_qty = 0
            tot_bulk_amt_bf_tax = 0
            tot_bulk_tax_amount = 0
            tot_bulk_amt_af_tax = 0
            tot_grand_amount = 0
          }
        }
        this.uniformMonthlyDistributionSummaryReport.push({
          sno: '',
          outward_date: '',
          proj_id: 0,
          proj_name: '',
          uniform_cat_id: 0,
          uniform_cat: '',
          uniform_sub_cat_id: 0,
          uniform_sub_cat: 'Grand-Total',
          outward_qty: g_tot_outward_qty,
          amount: g_tot_amt_bf_tax,
          tax_amount: g_tot_tax_amount,
          total_amount: g_tot_amt_af_tax,
          bulk_outward_qty: g_tot_bulk_outward_qty,
          bulk_pending_qty: g_tot_bulk_pending_qty,
          bulk_amount: g_tot_bulk_amt_bf_tax,
          bulk_tax_amount: g_tot_bulk_tax_amount,
          bulk_total_amount: g_tot_bulk_amt_af_tax,
          grand_total_amount: g_tot_grand_amount
        })
        this.lAction = 'monthly-distribution-summary'
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadUniformBulkDistribMappingComparisonReportBase() {
      var curDate = new Date()
      this.lUniformBulkDistribMapCompReport.proj_id_pair = {proj_id: null, proj_name: null}
      this.lUniformBulkDistribMapCompReport.from_date = handy.formatDBDate(new Date(curDate.getFullYear(), curDate.getMonth(), 1))
      this.lUniformBulkDistribMapCompReport.to_date = handy.formatDBDate(new Date(curDate.getFullYear(), curDate.getMonth() + 1, 0))
      this.uniformBulkDistribMapCompReport = []
      this.loadAllMaintenanceProjects()
      this.lAction = 'bulk-distrib-empmap-compare-rpt'
    },
    loadUniformBulkDistribMappingComparisonReport (curItem) {
      if(curItem.from_date != null && curItem.to_date === null) {
        curItem.to_date = curItem.from_date
      }
      if(curItem.to_date != null && curItem.from_date === null) {
        curItem.from_date = curItem.to_date
      }
      var qry = {
        params: {
          proj_id: curItem.proj_id_pair? curItem.proj_id_pair.proj_id : null,
          from_date: curItem.from_date,
          to_date: curItem.to_date,
          vendor_id: config.VENDOR_ID
        }
      }
      this.uniformBulkDistribMapCompReport = []
      this.axios.get(config.API_URL + '/getUniformBulkDistributionMappingComparisonReport/', qry)
      .then(response => {
        this.uniformBulkDistribMapCompReport = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadPurchaseHistorySummaryBase () {
      var curDate = new Date()
      this.lUniformPurchaseHistorySummary.from_date = handy.formatDBDate(new Date(curDate.getFullYear(), curDate.getMonth(), 1))
      this.lUniformPurchaseHistorySummary.to_date = handy.formatDBDate(new Date(curDate.getFullYear(), curDate.getMonth() + 1, 0))
      this.uniformPurchaseHistorySummary = []
      this.lAction = 'purchase-history-summary'
    },
    loadUniformPurchaseHistorySummary(curItem) {
      if(curItem.from_date != null && curItem.to_date === null) {
        curItem.to_date = curItem.from_date
      }
      if(curItem.to_date != null && curItem.from_date === null) {
        curItem.from_date = curItem.to_date
      }
      var qry = {
        params: {
          from_date: curItem.from_date,
          to_date: curItem.to_date,
          vendor_id: config.VENDOR_ID
        }
      }
      this.uniformPurchaseHistorySummary = []
      this.axios.get(config.API_URL + '/getUniformPurchaseHistorySummary/', qry)
      .then(response => {
        var tot_pur_qty = 0
        var tot_amt_bf_tax = 0
        var tot_tax_amt = 0
        var tot_amt_af_tax = 0

        var g_tot_pur_qty = 0
        var g_tot_amt_bf_tax = 0
        var g_tot_tax_amt = 0
        var g_tot_amt_af_tax = 0

        var rec_length = response.data.length

        for(var i = 0; i < response.data.length; i++) {
          if(i < rec_length-1) {
            if(response.data[i].invoice_date != response.data[i+1].invoice_date || response.data[i].uniform_sub_cat_id != response.data[i+1].uniform_sub_cat_id) {
              this.uniformPurchaseHistorySummary.push({
                sno: i+1,
                invoice_date: response.data[i].invoice_date,
                uniform_sub_cat_id: response.data[i].uniform_sub_cat_id,
                uniform_sub_cat: response.data[i].uniform_sub_cat,
                uniform_size_id: response.data[i].uniform_size_id,
                uniform_size: response.data[i].uniform_size,
                pur_qty: response.data[i].pur_qty,
                amount_bf_tax: response.data[i].amount_bf_tax,
                tax_amount: response.data[i].tax_amount,
                amount_af_tax: response.data[i].amount_af_tax
              })

              tot_pur_qty += response.data[i].pur_qty
              tot_amt_bf_tax += response.data[i].amount_bf_tax
              tot_tax_amt += response.data[i].tax_amount
              tot_amt_af_tax += response.data[i].amount_af_tax

              g_tot_pur_qty += response.data[i].pur_qty
              g_tot_amt_bf_tax += response.data[i].amount_bf_tax
              g_tot_tax_amt += response.data[i].tax_amount
              g_tot_amt_af_tax += response.data[i].amount_af_tax

              this.uniformPurchaseHistorySummary.push({
                sno: '',
                invoice_date: '',
                uniform_sub_cat_id: 0,
                uniform_sub_cat: '',
                uniform_size_id: 0,
                uniform_size: 'Sub-Total',
                pur_qty: tot_pur_qty,
                amount_bf_tax: tot_amt_bf_tax,
                tax_amount: tot_tax_amt,
                amount_af_tax: tot_amt_af_tax
              })
              tot_pur_qty = 0
              tot_amt_bf_tax = 0
              tot_tax_amt = 0
              tot_amt_af_tax = 0
            } else {
              this.uniformPurchaseHistorySummary.push({
                sno: i+1,
                invoice_date: response.data[i].invoice_date,
                uniform_sub_cat_id: response.data[i].uniform_sub_cat_id,
                uniform_sub_cat: response.data[i].uniform_sub_cat,
                uniform_size_id: response.data[i].uniform_size_id,
                uniform_size: response.data[i].uniform_size,
                pur_qty: response.data[i].pur_qty,
                amount_bf_tax: response.data[i].amount_bf_tax,
                tax_amount: response.data[i].tax_amount,
                amount_af_tax: response.data[i].amount_af_tax
              })
              tot_pur_qty += response.data[i].pur_qty
              tot_amt_bf_tax += response.data[i].amount_bf_tax
              tot_tax_amt += response.data[i].tax_amount
              tot_amt_af_tax += response.data[i].amount_af_tax

              g_tot_pur_qty += response.data[i].pur_qty
              g_tot_amt_bf_tax += response.data[i].amount_bf_tax
              g_tot_tax_amt += response.data[i].tax_amount
              g_tot_amt_af_tax += response.data[i].amount_af_tax
            }
          } else {
            this.uniformPurchaseHistorySummary.push({
              sno: i+1,
              invoice_date: response.data[i].invoice_date,
              uniform_sub_cat_id: response.data[i].uniform_sub_cat_id,
              uniform_sub_cat: response.data[i].uniform_sub_cat,
              uniform_size_id: response.data[i].uniform_size_id,
              uniform_size: response.data[i].uniform_size,
              pur_qty: response.data[i].pur_qty,
              amount_bf_tax: response.data[i].amount_bf_tax,
              tax_amount: response.data[i].tax_amount,
              amount_af_tax: response.data[i].amount_af_tax
            })
            tot_pur_qty += response.data[i].pur_qty
            tot_amt_bf_tax += response.data[i].amount_bf_tax
            tot_tax_amt += response.data[i].tax_amount
            tot_amt_af_tax += response.data[i].amount_af_tax

            g_tot_pur_qty += response.data[i].pur_qty
            g_tot_amt_bf_tax += response.data[i].amount_bf_tax
            g_tot_tax_amt += response.data[i].tax_amount
            g_tot_amt_af_tax += response.data[i].amount_af_tax

            this.uniformPurchaseHistorySummary.push({
              sno: '',
              invoice_date: '',
              uniform_sub_cat_id: 0,
              uniform_sub_cat: '',
              uniform_size_id: 0,
              uniform_size: 'Sub-Total',
              pur_qty: tot_pur_qty,
              amount_bf_tax: tot_amt_bf_tax,
              tax_amount: tot_tax_amt,
              amount_af_tax: tot_amt_af_tax
            })
            tot_pur_qty = 0
            tot_amt_bf_tax = 0
            tot_tax_amt = 0
            tot_amt_af_tax = 0
          }
        }
        this.uniformPurchaseHistorySummary.push({
          sno: '',
          invoice_date: '',
          uniform_sub_cat_id: 0,
          uniform_sub_cat: '',
          uniform_size_id: 0,
          uniform_size: 'Grand-Total',
          pur_qty: g_tot_pur_qty,
          amount_bf_tax: g_tot_amt_bf_tax,
          tax_amount: g_tot_tax_amt,
          amount_af_tax: g_tot_amt_af_tax
        })
      })
      .catch(err => {
        this.msg(err, true)
      })
    }
  }
}

</script>
